import { Variant } from "@interfaces/Variant"
import { getListingTypeTheme } from "@utils/ListingUtils"
import { CloudStoreAttributeEnum } from "cs.node.utils/BindingUtils"
import { ChildListingStatusEnum, ChildListingTypeEnum } from "cs.node.utils/csapi/provisioning"
import { PropertyAnalysis } from "cs.node.utils/ItemUtils"
import { Badge } from "react-bootstrap"

const it = {
    __LANGUAGE: "it",
    ACCEDI: "Accedi",
    ACCESSO_IN_CORSO: "Accesso in corso...",
    LOGIN: 'Login',
    RICORDAMI: 'Ricordami',
    CREDENZIALI_NON_RICONOSCIUTE: 'Credenziali non riconosciute',
    CERCA: "Cerca",
    CHANGE_PASSWORD: {
        PASSWORD_DIMENTICATA: "Password dimenticata?",
        RECUPERA_PASSWORD: "Recupera password",
        RECUPERA_PASSWORD_DESC: "Inserisci la tua email per ricevere le istruzioni per il reset della password.",
        EMAIL: "Email",
        INVIA: "Invia",
        RICHIESTA_INVIATA_CON_SUCCESSO: "Richiesta inviata con successo. Controlla la tua casella di posta elettronica.",
        TORNA_ALLA_LOGIN: "Torna alla login",
        CONFERMA_INVIO_EMAIL_RESET_PASSWORD: (email: string) => `Confermi l'invio dell'email di reset password all'indirizzo ${email}?`,
        CIAO: (username: string) => <>Ciao, <strong>{username}</strong>!</>,
        DESC: "Scegli una nuova password per il tuo account.",
        CAMBIA_PASSWORD: "Cambia password",
        CONFERMA_CAMBIO_PASSWORD: "Confermi il cambio della password?",
        PASSWORD_REGEX: "La password deve essere tra 8 e 64 caratteri, deve contenere almeno un carattere minuscolo e uno maiuscolo, deve contenere un numero e un carattere speciale tra i seguenti: @ # $ % ^ & + = !",
        NUOVA_PASSWORD: "Nuova password",
        CONFERMA_NUOVA_PASSWORD: "Conferma nuova password",
        ERR_PASSWORD_DIFFERENTI: "Nuova password e conferma nuova password devono coincidere",
        ERR_FORMATO_PASSWORD_LOWER_CASE: "La password deve contenere almeno un carattere minuscolo",
        ERR_FORMATO_PASSWORD_UPPER_CASE: "La password deve contenere almeno un carattere maiuscolo",
        ERR_FORMATO_PASSWORD_DIGIT: "La password deve contenere almeno un numero",
        ERR_FORMATO_PASSWORD_SPECIAL: "La password deve contenere almeno uno tra i caratteri: @ # $ % ^ & + = !",
        PASSWORD_CAMBIATA_CON_SUCCESSO: "La tua password è stata cambiata con successo.",
        VAI_ALLA_LOGIN: "Vai alla login"
    },
    SOTTOUTENTI: "Sottoutenti",
    BILLING: "Billing",
    MODULI: "Moduli",
    LOGOUT: "Logout",
    CONFERMA_LOGOUT: "Sei sicuro di voler uscire?",
    COPIA: "Copia",
    COPIATO: "Copiato!",
    OK: "Ok",
    MODIFICA: "Modifica",
    ELIMINA: "Elimina",
    VISUALIZZA: "Visualizza",
    ORDINA: "Ordina",
    AGGIUNGI: "Aggiungi",
    AGGIORNA: "Aggiorna",
    CARICA: "Carica",
    ANNULLA: "Annulla",
    INDIETRO: "Indietro",
    CHIUDI: "Chiudi",
    RIFIUTA: "Rifuta",
    RIPRISTINA: "Ripristina",
    RIGENERA: "Rigenera",
    NESSUNO: "Nessuno",
    NESSUN_ELEMENTO_PRESENTE: "Nessun elemento presente",
    NESSUN_RISULTATO_TROVATO: "Nessun risultato trovato",
    SELEZIONA: "Seleziona",
    SELEZIONA_TUTTI: "Seleziona tutti",
    DESELEZIONA_TUTTI: "Deseleziona tutti",
    ABILITATO: "Abilitato",
    DISABILITATO: "Disabilitato",
    RIUSCITO: "Riuscito",
    FALLITO: "Fallito",
    CONFERMA: "Conferma",
    ATTENDERE: "Attendere, prego",
    ATTENZIONE: "Attenzione",
    ERRORE_GENERICO: "Si è verificato un errore, si prega di riprovare.",
    RIPROVA: "Riprova",
    DETTAGLI_ERRORE: "Dettagli errore",
    SELEZIONA_UN_VALORE: "Seleziona un valore",
    SELEZIONA_MODALITA_CARICAMENTO: "Seleziona la modalità di caricamento:",
    VIA_FILE: "Via file",
    VIA_URL: "Via URL",
    VIA_TESTO: "Via testo",
    SELEZIONA_FILE_DA_CARICARE: "Seleziona il file da caricare",
    URL_DA_CARICARE: "Url da caricare",
    SELEZIONA_UN_FILE: "Seleziona un file",
    SI: "Sì",
    NO: "No",
    TUTTI: "Tutti",
    SALES_ORDER: "Ordine di vendita",
    TRANSFER_ORDER:"Ordine di trasferimento",
    SALVA: "Salva",
    APPLICA: "Applica",
    SCARICA: "Scarica",
    E_MAIL: "Email",
    ELIMINAZIONE_IN_CORSO: "Eliminazione in corso...",
    SALVATAGGIO_IN_CORSO: "Salvataggio in corso...",
    OPERAZIONE_AVVENUTA_CON_SUCCESSO: "Operazione avvenuta con successo",
    COPIA_VALORE: "Copia valore",
    COPIA_ID: "Copia ID",
    PROCEDI: "Procedi",
    PROSEGUI: "Prosegui",
    CAMBIA: "Cambia",
    CREA: "Crea",
    ISTRUZIONI: "Istruzioni",
    DETTAGLI: "Dettagli",
    MOSTRA: "Mostra",
    RICERCA_IN_CORSO: "Ricerca in corso...",
    RISULTATI: (count:number)=>count===1?`1 risultato`:`${count} risultati`,
    SELEZIONATI: (count:number)=>count===1?`1 selezionato`:`${count} selezionati`,
    HOME: "Home",
    INIZIA: "Inizia",
    VERIFICA: "Verifica",
    SELEZIONA_FILE: "Seleziona file",
    CLICCA_PER_COPIARE: "Clicca per copiare",
    SALE_CHANNEL:"Canale di vendita",
    SALES_CHANNEL:"Canali di vendita",
    BADGE_SHOP_PRIMARY:"Shop Primario",
    MARKUP: "Markup",
    DISCOUNT: "Discount",
    TAX_RATE: "Tax Rate",
    COUNTRY:"Nazione",
    MINIMO: "Minimo",
    MASSIMO: "Massimo",
    ZERO_NON_AMMESSO: "Zero non ammesso",
    ATTIVA: "Attiva",
    DISATTIVA: "Disattiva",
    CONTACTS: {
        EMAIL: "Email",
        PHONE: "Telefono",
        MOBILE: "Cellulare"
    },
    DATE_UTILS: {
        GIORNI: (days: number)=>days===1?"giorno":"giorni",
        ORE: (hours: number)=>hours===1?"ora":"ore",
        MINUTI: (minutes: number)=>minutes===1?"minuto":"minuti",
        SECONDI: (seconds: number)=>seconds===1?"secondo":"secondi",
        MILLISECONDI: (seconds: number)=>seconds===1?"ms":"ms",
    },
    SEARCH_BAR: {
        ARTICOLI: (count: number)=>count===1?`${count} Articolo`:`${count} Articoli`,
        ORDINI: (count: number)=>count===1?`${count} Ordine`:`${count} Ordini`,
        SHOP: (count: number)=>`${count} Shop`,
        CLIENTI: (count: number)=>count===1?`${count} Cliente`:`${count} Clienti`,
    },
    MENU: {
        IL_TUO_CLOUDSTORE: "Il tuo CloudStore",
        ATTIVITA: "Attività",
        GESTIONE: "Gestione",
        DASHBOARD: "Dashboard",
        CATALOGO: "Catalogo",
        ORDINI: "Ordini",
        SPEDIZIONI: "Spedizioni",
        CLIENTI: "Clienti",
        SHOPS: "Shops",
        ASSOCIAZIONE_MAGAZZINI: "Associazione magazzini",
        MAGAZZINI: "Magazzini",
        LISTA: "Lista",
        LISTA_ARTICOLI: "Lista articoli",
        SHIPMENTS: "Spedizioni",
        LISTING: "Listing",
        LISTING_ELENCO: "Elenco",
        LISTINI: "Listini",
        ASSOCIAZIONE_VALORI: "Associazione valori",
        AGGIORNAMENTO_DISPONIBILITA: "Aggiornamento disponibilità",
        WHS_MOVEMENTS:"Movimenti di magazzino",
        CATEGORIES:"Categorie",
        RETURNS:"Resi",
        GESTIONE_PREZZI: "Gestione prezzi",
        CONDIZIONI_COMMERCIALI: "Condizioni commerciali",
        MODIFICA_CONDIZIONE_COMMERCIALE: "Modifica condizione commerciale",
        LOGS:"Registro Attività",
        PACKAGING: "Packaging",
        STAMPA_ETICHETTE: "Stampa etichette",
        GROUPAGE: "Groupage",
        LOGS_SETTINGS:"Configurazione registro attività",
        RISERVE: "Riserve",
        QUEUES:"Code",
        REGOLE_ESCLUSIONE_LISTING: "Regole di esclusione dai listing",
        REGOLE_ESCLUSIONE: "Regole di esclusione",
        MODIFICA_REGOLA_ESCLUSIONE_LISTING: "Modifica regola di esclusione da listing",
        CUSTOMERS: "Clienti",
        MODULI: "Moduli",
        REPORT: "Report",
        CONFIGURAZIONE_REPORT: "Configurazione report",
        AVAILABILITY_BUCKET: "Availability Bucket",
        DAM: "DAM",
        UTENTI: "Utenti",
        EXPORT: "Export",
        PROFILO: "Profilo",
    },
    PAGE_ACCESS_DENIED: {
        TITLE:"Accesso non consentito",
        SUBTITLE:"Non è possibile accedere alla risorsa richiesta.",
        BACK_TO_HOME:"Torna alla home"
    },
    PAGE_NOT_FOUND: {
        TITLE:"Pagina non trovata",
        SUBTITLE:"La risorsa richiesta non esiste.",
        BACK_TO_HOME:"Torna alla home"
    },
    PAGE_ONLY_DESKTOP_OR_TABLET: {
        TITLE:"Pagina non disponibile su mobile",
        SUBTITLE:"La risorsa richiesta non è disponibile su dispositivi mobile.",
        BACK_TO_HOME:"Torna alla home"
    },
    PAGE_AVAILABILITY_BUCKETS: {
        NUOVO_BUCKET: "Nuovo bucket",
        SHOP_CONTENUTI: "Shop contenuti",
        SHOP_DA_AGGIUNGERE: "Shop da aggiungere",
        NOME: "Nome"
    },
    PAGE_MAINTENANCE: {
        TITLE: "Manutenzione in corso",
        SUBTITLE: "Stiamo eseguendo delle operazioni di manutenzione, ma torneremo presto online."
    },
    PAGE_HOME: {
        BENVENUTO: (name: string)=><>Benvenuto, {name}</>,
        RIEPILOGO: "Ecco un riepilogo della tua attività.",
    },
    PAGE_BUSINESS_CONDITIONS: {
        NUOVA_CONDIZIONE_COMMERCIALE: "nuova condizione commerciale",
        AVVIA_ELABORAZIONE: "Avvia elaborazione",
        TEST_CONDIZIONI_COMMERCIALI: "Esegui un test delle condizioni commerciali",
        TUTTE_LE_CONDIZIONI_COMMERCIALI_APPLICATE: "Tutte le condizioni commerciali sono applicate.",
        DA_ELABORARE: "Ci sono __ELEMENTS__ da elaborare.",
        ASSOCIAZIONI_CON_SHOPS: "associazioni con shops",
        ASSOCIAZIONI_CON_CUSTOMER: "associazioni con customers",
        RISULTATI_ASSOCIAZIONE: "Risultati associazione",
        SHOP_GIA_ASSOCIATO: (navigateFunction: Function)=><>Shop già associato ad una condizione commerciale. Clicca <span className="cs-link" onClick={()=>navigateFunction()}>qui</span> per modificarla.</>,
        SHOP_ASSOCIATO_CORRETTAMENTE: "Shop associato correttamente.",
        CONDIZIONI: "condizioni",
        CONDIZIONI_ATTIVE: "Condizioni attive",
        CONDIZIONI_DA_ELABORARE: "Condizioni da elaborare",
        CONDIZIONI_DISABILITATE: "Condizioni disabilitate",
        CONDIZIONI_CANCELLATE: "Condizioni cancellate",
        CONDIZIONI_IN_ELABORAZIONE: "Condizioni in elaborazione",
        TAB_0: "Condizioni attive / da elaborare / disabilitate",
        CONFERMA_DISABILITA: "Confermi la disattivazione della condizione __NAME__?",
        CONFERMA_CANCELLAZIONE: "Confermi la cancellazione della condizione __NAME__?",
        CONFERMA_ABILITA: "Confermi l'abilitazione della condizione __NAME__?",
        CONFERMA_ANNULLAMENTO: "Confermi l'annullamento dell'operazione in corso per la condizione __NAME__?",
        CONFERMA_AVVIO_ELABORAZIONE: "Confermi l'avvio dell'elaborazione delle condizioni commerciali?",
        DATI_GENERALI: "Dati generali",
        NOME: "Nome",
        TAX_RATE: "Tax Rate",
        CONDIZIONE_DI_DEFAULT: "Condizione di default",
        ASSOCIAZIONE_SHOP: "Associazione shop",
        ASSOCIAZIONE_CUSTOMER: "Associazione customer",
        ECCEZIONI: "Eccezioni",
        ASSOCIAZIONE_SHOP_INFO: "In questa sezione puoi associare questa condizione commerciale a uno o più shop.",
        AGGIUNGI_ASSOCIAZIONE: "Aggiungi associazione",
        NUOVA_ASSOCIAZIONE: "Nuova associazione",
        CONFERMA_ASSOCIAZIONE_SHOP: "Confermi l'associazione di questa condizione commerciale agli shop selezionati?",
        CONFERMA_CANCELLAZIONE_ASSOCIAZIONE_SHOP: "Confermi la cancellazione dell'associazione selezionata?",
        ASSOCIAZIONE_CUSTOMER_INFO: "In questa sezione puoi associare questa condizione commerciale a uno o più customer.",
        CONFERMA_ASSOCIAZIONE_CUSTOMER: "Confermi l'associazione di questa condizione commerciale ai customer selezionati?",
        CONFERMA_CANCELLAZIONE_ASSOCIAZIONE_CUSTOMER: "Confermi la cancellazione dell'associazione selezionata?",
        SELEZIONA_UN_CUSTOMER: "Seleziona un customer",
        ECCEZIONI_INFO: "In questa sezione puoi definire delle eccezioni alla condizione di default definita in testata.",
        NUOVA_ECCEZIONE: "Nuova eccezione",
        MODIFICA_ECCEZIONE: "Modifica eccezione",
        SCARICA_TEMPLATE: "Scarica template Excel vuoto",
        SCARICA_ECCEZIONI: "Scarica Excel delle eccezioni configurate",
        CARICA_ECCEZIONI: "Carica Excel delle eccezioni per questa condizione commerciale",
        SELEZIONA_ALMENO_UN_ATTRIBUTO: "Seleziona almeno un attributo su cui applicare la condizione",
        CONFERMA_SALVATAGGIO_CONDIZIONE: "Confermi il salvataggio delle modifiche effettuate?",
        LOGS:"Registro Attività",
        TABLE: {
            NOME: "Nome",
            VARIAZIONE: "Variazione",
            MARKUP: "Markup",
            DISCOUNT: "Sconto",
            NUMERO_ECCEZIONI: "N° Eccezioni",
            STATO: "Stato",
            VAI_A_DETTAGLIO: "Vai al dettaglio",
            DISABILITA: "Disabilita",
            CANCELLA: "Cancella",
            RIATTIVA: "Riattiva",
            ANNULLA_OPERAZIONE: "Annulla operazione",
        },
        STATUS: {
            LABEL: {
                PENDING: "Da elaborare",
                PROCESSING: "In elaborazione",
                CONFIRMED: "Confermata",
                TO_BE_DEPRECATED: "Da rendere obsoleta",
                DEPRECATED: "Obsoleta",
                TO_BE_DISABLED: "Da disabilitare",
                DISABLED: "Disabilitata",
                TO_BE_CANCELED: "Da cancellare",
                CANCELED: "Cancellata",
                TO_BE_ENABLED: "Da abilitare",
                    },
            SHORT: {
                PENDING: "Questa condizione è in attesa di essere confermata e attivata.",
                PROCESSING: "Questa condizione è attualmente in fase di elaborazione.",
                CONFIRMED: "Questa condizione è confermata e attualmente in vigore.",
                TO_BE_DEPRECATED: "Questa condizione è stata impostata per essere resa obsoleta durante la prossima elaborazione.",
                DEPRECATED: "Questa condizione è obsoleta e non è più in vigore.",
                TO_BE_DISABLED: "Questa condizione è stata impostata per essere disabilitata durante la prossima elaborazione.",
                DISABLED: "Questa condizione è attualmente disabilitata e non viene applicata.",
                TO_BE_CANCELED: "Questa condizione è stata impostata per essere cancellata durante la prossima elaborazione.",
                CANCELED: "Questa condizione è cancellata.",
                TO_BE_ENABLED: "Questa condizione è stata impostata per essere abilitata durante la prossima elaborazione.",
            },
            EXTENDED: {
                PENDING: "Questa condizione è in attesa di essere confermata e attivata.",
                PROCESSING: "Questa condizione è attualmente in fase di elaborazione.",
                CONFIRMED: "Questa condizione è confermata e attualmente in vigore.",
                TO_BE_DEPRECATED: "Questa condizione è stata impostata per essere resa obsoleta durante la prossima elaborazione.",
                DEPRECATED: "Questa condizione è obsoleta e non è più in vigore.",
                TO_BE_DISABLED: "Questa condizione è stata impostata per essere disabilitata durante la prossima elaborazione.",
                DISABLED: "Questa condizione è attualmente disabilitata e non viene applicata.",
                TO_BE_CANCELED: "Questa condizione è stata impostata per essere cancellata durante la prossima elaborazione.",
                CANCELED: "Questa condizione è cancellata.",
                TO_BE_ENABLED: "Questa condizione è stata impostata per essere abilitata durante la prossima elaborazione.",
            }
        },
        EXCEPTIONS: {
            SEASON: "Season",
            BRAND: "Brand",
            CATEGORY: "Category",
            SKU_PARENT: "SKU Parent",
            PARTNER_CODE: "Partner",
            VARIAZIONE: "Variazione",
            AZIONI: "Azioni"
        },
        PROCESSING: {
            ELABORAZIONE_IN_CORSO: "Elaborazione in corso...",
            PREPARAZIONE: "Preparazione...",
            ELABORAZIONE_ASSOCIAZIONI_CUSTOMERS: "Elaborazione associazioni customer...",
            ELABORAZIONE_ASSOCIAZIONI_SHOPS: "Elaborazione associazioni shop...",
            AGGIORNAMENTO_STATI_RELAZIONI: "Aggiornamento stati e relazioni...",
            APPLICAZIONE_CONDIZIONI_CREAZIONE_LISTING: "Applicazione condizioni e creazione listing..."
        },
        UPLOAD_RESULTS: {
            RISULTATO_CARICAMENTO: "Risultato del caricamento",
            NO_ROWS_ACCEPTED: "Poiché nessuna riga è stata elaborata correttamente, non sono state apportate modifiche alle eccezioni attuali.",
            SOME_ROWS_ACCEPTED: "Puoi visionare il risultato nella tabella delle eccezioni in questa pagina; è possibile che alcune righe dell'Excel siano state raggruppate per essere gestite con maggior semplicità e chiarezza. Se sei soddisfatto del risultato, ti basterà salvare la condizione commerciale con l'apposito pulsante in alto a destra!",
            EXCEPTIONS_CREATED: "Eccezioni create:",
            ROWS_ERROR: "Righe in errore (scartate):",
            ROWS_WARNING: "Righe con avvisi:",
            RIGA: "Riga",
        }
    },
    PAGE_LISTING_EXCLUSION_RULES: {
        STATUS: {
            LABEL: {
                PENDING: "Da elaborare",
                PROCESSING: "In elaborazione",
                CONFIRMED: "Confermata",
                TO_BE_DEPRECATED: "Da rendere obsoleta",
                DEPRECATED: "Obsoleta",
                TO_BE_DISABLED: "Da disabilitare",
                DISABLED: "Disabilitata",
                TO_BE_CANCELED: "Da cancellare",
                CANCELED: "Cancellata",
                TO_BE_ENABLED: "Da abilitare",
                    },
            SHORT: {
                PENDING: "Questa regola è in attesa di essere confermata e attivata.",
                PROCESSING: "Questa regola è attualmente in fase di elaborazione.",
                CONFIRMED: "Questa regola è confermata e attualmente in vigore.",
                TO_BE_DEPRECATED: "Questa regola è stata impostata per essere resa obsoleta durante la prossima elaborazione.",
                DEPRECATED: "Questa regola è obsoleta e non è più in vigore.",
                TO_BE_DISABLED: "Questa regola è stata impostata per essere disabilitata durante la prossima elaborazione.",
                DISABLED: "Questa regola è attualmente disabilitata e non viene applicata.",
                TO_BE_CANCELED: "Questa regola è stata impostata per essere cancellata durante la prossima elaborazione.",
                CANCELED: "Questa regola è cancellata.",
                TO_BE_ENABLED: "Questa regola è stata impostata per essere abilitata durante la prossima elaborazione.",
            },
            EXTENDED: {
                PENDING: "LONG DESCRIPTION PENDING",
                PROCESSING: "LONG DESCRIPTION PROCESSING",
                CONFIRMED: "LONG DESCRIPTION CONFIRMED",
                TO_BE_DEPRECATED: "LONG DESCRIPTION TO_BE_DEPRECATED",
                DEPRECATED: "LONG DESCRIPTION DEPRECATED",
                TO_BE_DISABLED: "LONG DESCRIPTION TO_BE_DISABLED",
                DISABLED: "LONG DESCRIPTION DISABLED",
                TO_BE_CANCELED: "LONG DESCRIPTION TO_BE_CANCELED",
                CANCELED: "LONG DESCRIPTION CANCELED",
                TO_BE_ENABLED: "LONG DESCRIPTION TO_BE_ENABLED",
            }
        },
        PROCESSING: {
            ELABORAZIONE_IN_CORSO: "Elaborazione in corso...",
            PREPARAZIONE: "Preparazione delle regole in corso...",
            ELABORAZIONE: "Elaborazione delle regole in corso...",
            APPLICAZIONE: "Applicazione delle regole in corso...",
            FINALIZZAZIONE: "Impostazione stati finali e creazione dei listing in corso..."
        },
        TABLE: {
            NOME: "Nome regola",
            DATA_CREAZIONE: "Data creazione",
            DATA_MODIFICA: "Data modifica",
            STATO: "Stato",
            VAI_A_DETTAGLIO: "Vai al dettaglio",
            DISABILITA: "Disabilita",
            CANCELLA: "Cancella",
            RIATTIVA: "Riattiva",
            ANNULLA_OPERAZIONE: "Annulla operazione",
        },
        TUTTE_LE_REGOLE_APPLICATE: "Tutte le regole sono applicate.",
        DA_ELABORARE: "Ci sono __COUNT__ regole da elaborare.",
        REL_NON_COMPLETA: "Questa regola non verrà applicata in quanto non sono state inserite le condizioni o non è stata specificata la lista degli shop esclusi",
        CONFERMA_AVVIO_ELABORAZIONE: "Confermi l'avvio dell'elaborazione delle regole?",
        NUOVA_REGOLA: "Nuova regola",
        AVVIA_ELABORAZIONE: "Avvia elaborazione delle regole",
        TEST_REGOLE: "Esegui un test sulle regole",
        REGOLE_ATTIVE: "Regole attive",
        REGOLE_DA_ELABORARE: "Regole da elaborare",
        REGOLE_DISABILITATE: "Regole disabilitate",
        REGOLE_CANCELLATE: "Regole cancellate",
        REGOLE_IN_ELABORAZIONE: "Regole in elaborazione",
        TAB_0: "Regole attive / da elaborare / disabilitate",
        CONFERMA_DISABILITA: "Confermi la disattivazione della regola __NAME__?",
        CONFERMA_CANCELLAZIONE: "Confermi la cancellazione della regola __NAME__?",
        CONFERMA_ABILITA: "Confermi l'abilitazione della regola __NAME__?",
        CONFERMA_ANNULLAMENTO: "Confermi l'annullamento dell'operazione in corso per la regola __NAME__?",
        NOME: "Nome",
        CONFERMA_SALVATAGGIO_REGOLA: "Confermi il salvataggio delle modifiche effettuate alla regola?",
        DATI_GENERALI: "Dati generali",
        CONDIZIONI: "Condizioni",
        SHOP_ESCLUSI: "Shop esclusi",
        CLIENTI_ESCLUSI: "Clienti esclusi",
        CLIENTI_ESCLUSI_INFO: "In questa sezione puoi scegliere a quali clienti applicare l'esclusione dai listing definita nella regola che stai modificando.",
        AGGIUNGI_CLIENTI_ESCLUSI: "Aggiungi clienti esclusi",
        CONFERMA_ESCLUSIONE_CLIENTI: "Confermi l'applicazione dell'esclusione ai clienti selezionati?",
        CONFERMA_CANCELLAZIONE_ESCLUSIONE_CLIENTE: "Confermi la cancellazione dell'esclusione per il cliente selezionato?",
        STORICO: "Storico",
        HISTORY: {
            NESSUN_ELEMENTO_DISPONIBILE: "Nessun elemento disponibile.",
            CREATE_GUI: "La regola è stata creata sull'applicazione CloudStore.",
            CREATE_ENGINE: "La regola è stata creata dal motore di regole CloudStore durante il passaggio:",
            CREATE_API: "La regola è stata creata dalle API CloudStore.",
            UPDATED_GUI: "La regola è stata modificata sull'applicazione CloudStore.",
            UPDATED_ENGINE: "La regola è stata modificata dal motore di regole CloudStore durante il passaggio:",
            UPDATED_API: "La regola è stata modificata dalle API CloudStore.",
            STEPS: {
                _0: "sconosciuto",
                _1: "preparazione delle regole",
                _2: "elaborazione delle regole",
                _3: "applicazione delle regole",
                _4: "impostazione stati finali e creazione dei listing",
            }
        },
        EXCLUDED_SHOPS_INFO: "In questa sezione puoi scegliere a quali shop applicare l'esclusione dai listing definita nella regola che stai modificando.",
        SELEZIONA_SHOP_ESCLUSI: "Seleziona gli shop da escludere",
        NUOVA_CONDIZIONE: "Nuova condizione",
        MODIFICA_CONDIZIONE: "Modifica condizione",
        SCARICA_TEMPLATE: "Scarica template Excel vuoto",
        SCARICA_CONDIZIONI: "Scarica Excel delle condizioni configurate",
        CARICA_CONDIZIONI: "Carica Excel delle condizioni per questa regola",
        CONDIZIONI_INFO: "In questa sezione puoi definire le condizioni affinché la regola di esclusione risulti valida.",
        CONDITIONS: {
            SEASON: "Season",
            BRAND: "Brand",
            CATEGORY: "Category",
            SKU_PARENT: "SKU Parent",
            OPERATORE: "Operatore",
            VALORE: "Valore",
            CONFERMA_AGGIUNGI_A_CONDIZIONE: "Confermi l'aggiunta dei valori richiesti alla condizione?",
            CONFERMA_AGGIUNGI_A_CONDIZIONE_HELP: "L'aggiunta non verrà salvata in automatico! Potrai sempre decidere di modificare le condizioni prima del salvataggio.",
            VALORE_PRESENTE_IN_CLOUDSTORE: "Questo valore è già presente in qualcuno degli articoli del tuo inventario.",
            VALORE_NON_PRESENTE_IN_CLOUDSTORE: "Questo valore non è ancora censito in nessuno degli articoli del tuo inventario.",
            NESSUN_VALORE_SELEZIONATO: "Nessun valore selezionato.",
            CATEGORIE_SELEZIONATE: "Ci sono __COUNT__ categorie selezionate. Per visualizzarle, utilizzare il selettore qui sopra.",
            ERRORE_CONDIZIONI_INCOMPLETE: (labels: string[]) => <>Le seguenti condizioni sono incomplete: <strong>{labels.join(", ")}</strong></>
        },
        UPLOAD_RESULTS: {
            RISULTATO_CARICAMENTO: "Risultato del caricamento",
            NO_ROWS_ACCEPTED: "Poichè nessuna condizione caricata è risultata valida, le condizioni attuali rimangono immutate.",
            SOME_ROWS_ACCEPTED: "Puoi visualizzare il risultato del caricamento nei relativi box di questa pagina.",
        }
    },
    PAGE_MODULES: {
        MODULI_ABILITATI: "Moduli abilitati",
        MODULI_DISABILITATI: "Moduli disabilitati",
        NESSUN_MODULO_ABILITATO: "Nessun modulo abilitato.",
        NESSUN_MODULO_DISABILITATO: "Nessun modulo disabilitato.",
        STATUS:{
            LABEL: "Stato",
            ACTIVE: "Attivo",
            INACTIVE: "Non attivo",
            NOT_APPLICABLE: "Non Applicabile",
            PENDING: "In Attesa",
            VALIDATING: "In Validazione",
            CONFIRMED: "Confermato",
            AUTH_ERROR: "Errore di Autenticazione",
            ERROR: "Errore",
        },
        TITLES: {
            BUSINESS_CONDITIONS: "Gestione avanzata prezzi",
            BECOMMERCE: "BeCommerce",
            B2B: "B2B",
            POS: "POS",
            ERP: "ERP",
            FINANCE: "Finance",
            FxFF: "Fullfilment by Farfetch",
            WAREHOUSES: "Magazzini",
            NETSUITE: "Integrazione NetSuite",
            MODULO_NON_SUPPORTATO: "Modulo non supportato",
        },
        DESCRIPTIONS: {
            BUSINESS_CONDITIONS: "Questo modulo permette di gestire in maniera completa le informazioni dei prezzi di un articolo sia a livello di listini che a livello di condizioni commerciali.",
            BECOMMERCE: "Il tuo E-Commerce integrato con CloudStore.",
            B2B: "È un'applicazione che consente di vendere i prodotti del tuo catalogo a clienti B2B attraverso le funzionalità tipiche di un canale di vendita, come la gestione dell'anagrafica clienti e la gestione del flusso ordini. Compatibile con PC e tablet.",
            POS: "È un'applicazione dedicata al mondo Retail che consente di integrare un negozio fisico nell'ecosistema di CloudStore attraverso semplici funzionalità come la creazione di un ordine e la gestione dell'anagrafica di un cliente. Permette inoltre di monitorare le giacenze presente in altri negozi/magazzini così da poter fornire al cliente finale un'esperienza completa.",
            ERP: "Il modulo ERP è progettato per fornire funzionalità specifiche e dedicate a chi integra il proprio ERP con CloudStore attraverso le CloudStore API",
            FINANCE: "Questo modulo permette di stimare le componenti tasse sui prezzi indicati negli ordini privi di tale informazione, durante la fase di ricezione ordine dagli shop.",
            FxFF: "L'integrazione permette la gestione dei canali Farfetch per i quali è attivo il servizio di Fulfillment by Farfetch (FxFF)",
            WAREHOUSES: "Il modulo magazzini mette a disposizione diverse funzionalità e aree che l'utente può usare per gestire in maniera più ampia e personalizzata l'inventario e la pubblicazione degli articoli sugli shop.",
            NETSUITE: "L'integrazione implementa processi di inbound e outbound di dati tra gli account di CloudStore e di NetSuite al fine di sincronizzare clienti, articoli, ordini, dati di fatturazione, dati di spedizione e movimenti di magazzino.",
        },
        B2B: {
            CONFIGURAZIONI_RELATIVE_AGLI_SHOP: "Configurazioni relative agli shop",
            ALTRE_CONFIGURAZIONI: "Altre configurazioni",
            SHOP_PRIMARIO: "Shop primario",
            SHOP_SECONDARI: "Shop secondari",
            PASSWORD_EXCEL: "Password Excel",
            PASSWORD_EXCEL_INFO: "Password per aprire i file Excel generati nel modulo B2B",
            MODELLO_GESTIONE_PREZZI_DI_DEFAULT: "Modello di gestione prezzi di default",
            SMTP: {
                TITLE: "Configurazione server SMTP",
                INFO: "Configurazione del server SMTP utilizzato per l'invio delle email ai clienti B2B.",
                ABILITATO: "Server SMTP abilitato",
                HOSTNAME: "Nome host",
                PORT: "Porta",
                USERNAME: "Username",
                PASSWORD: "Password",
                SENDER: "Indirizzo mittente"
            },
            GESTIONE_PREORDINI: "Gestione preordini",
            GESTIONE_PREZZI: "Gestione prezzi",
            STATO_ORDINE_GENERATO_DA_PREORDINE: "Stato ordine generato da preordine",
            CUSTOMER_NELLO_SHOP: (shopName: string) => `Customer presenti nello shop ${shopName}`,
            AGGIUNGI_CLIENTI: "Aggiungi clienti",
            INFORMAZIONI_SALVATAGGIO_CUSTOMER_SHOP: "I clienti aggiunti in questa sezione non saranno salvati automaticamente: il salvataggio avverrà cliccando sul pulsante di salvataggio dell'intero modulo B2B.",
            AGGIUNGI_SHOP_SECONDARI: "Aggiungi shop secondari",
            SHOPS: "Shop",
        },
        BECOMMERCE: {
            TABS: {
                AREE_GEOGRAFICHE: "Aree geografiche",
                SPESE_DI_SPEDIZIONE: "Spese di spedizione",
            },
            NESSUNA_AREA_GEOGRAFICA_DEFINITA: "Nessuna area geografica definita.",
            AGGIUNGI_AREA_GEOGRAFICA: "Aggiungi area geografica",
            MODIFICA_AREA_GEOGRAFICA: "Modifica area geografica",
            NOME_AREA: "Nome area",
            NAZIONI_INCLUSE: "Nazioni incluse",
            ERRORE_NOME_AREA_GIA_UTILIZZATO: "Nome area già utilizzato",
            ERRORE_COUNTRIES_GIA_UTILIZZATE: (countries: string[])=>`Le seguenti nazioni sono già incluse in un'altra area geografica: ${countries.join(", ")}`,
            NUMERO_NAZIONI_INCLUSE: (count: number)=>count===1?`1 nazione inclusa`:`${count} nazioni incluse`,
            SELEZIONA_METODO_DI_SPEDIZIONE: "Seleziona un metodo di spedizione",
            AGGIUNGI_RANGE_DI_PREZZO: "Aggiungi range di prezzo",
            MODIFICA_RANGE_DI_PREZZO: "Modifica range di prezzo",
            DA_PREZZO: "Da prezzo",
            A_PREZZO: "A prezzo",
            COSTO_SPEDIZIONE: "Costo spedizione",
            GESTISCI_SOVRAPPOSIZIONE_RANGE_DI_PREZZO: "Gestisci sovrapposizione range di prezzo",
            GESTISCI_SOVRAPPOSIZIONE_RANGE_DI_PREZZO_INFO: "Quando questa opzione è selezionata, in caso di sovrapposizione verranno adattati gli altri range di prezzo esistenti per evitare conflitti.",
            ERRORE_RANGE_DI_PREZZO_SOVRAPPPOSTI: "Range di prezzo sovrapposti ad altri esistenti per lo stesso metodo di spedizione",
            MINIMO_MAGGIORE_MASSIMO: "Il valore minimo deve essere minore del valore massimo",
            CONFIGURAZIONE_GATEWAY_PAGAMENTO: "Configurazione gateway di pagamento",
            PAYPAL: "PayPal",
            PAYPLUG: "PayPlug",
            PAYPAL_BASE_URL: "Base URL PayPal",
            PAYPAL_CLIENT_ID: "Client ID PayPal",
            PAYPAL_SECRET: "Secret PayPal",
            PAYPLUG_BASE_URL: "Base URL PayPlug",
            PAYPLUG_KEY: "Chiave PayPlug",
            IS_LIVE: "Ambiente di produzione",
            SHOP_DI_RIFERIMENTO: "Shop di riferimento",
        },
        FINANCE: {
            CLASSE_TASSAZIONE_COSTI_SPEDIZIONE: "Classe di tassazione costi di spedizione",
            TABS: {
                CLASSI_DI_TASSAZIONE: "Classi di tassazione",
                ALIQUOTE_FISCALI: "Aliquote fiscali"
            },
            DATA_CREAZIONE: "Data creazione",
            DATA_ULTIMA_MODIFICA: "Data ultima modifica",
            NOME: "Nome",
            PERCENTUALE: "Percentuale",
            NAZIONE: "Nazione",
            STATI: "Stati",
            POSTAL_CODE_RANGE: "Intervallo CAP",
        },
        POS: {
            SHOP_ASSOCIATIONS:"Associazione shop",
            IMPOSTAZIONI_APPLICAZIONE: "Impostazioni applicazione",
            DNS: "DNS",
            NOME_APP: "Nome app",
        },
        WAREHOUSES: {
            ALGORITMO: "Algoritmo",
            SELECT_ALGO: "Seleziona un algoritmo per il modulo magazzini",
            NONE :"Nessuno",
            NO_OP:"Nessuna operazione",
            WHS_PRIORITY:"Priorità Magazzini",
            TEMP_COMMIT:"Magazzino di appoggio",
            SHOP_DRIVEN:"Guidato dallo shop",
        },
        NETSUITE: {
            STATO: "Stato",
        },
        BUSINESS_CONDITIONS: {
            INBOUND_ORDER_PRICE_CHECK: "Controlla prezzo durante scarico ordini",
        },
        ACTIVATE_MODULE:"Attivazione Modulo",
        LAST_UPDATE_DATE:"Data ultimo aggiornamento",
        LAST_STATUS_UPDATE_DATE:"Data ultimo aggiornamento stato",
        LAST_ERROR_MESSAGE:"Ultimo messaggio di errore",
        ENABLE_DISABLED:"Abilita / disabilita modulo",
        GENERAL_CONFIG: "Configurazioni generali",
        UPDATE_CONFIRM: (module:string)=>`Si vuole prosegure con l'aggiornamento del modulo ${module}?`,
        ERROR_LOADING:"Si è verificato un errore durante il caricamento del modulo, si prega di riprovare o di contattare l'assistenza CloudStore",
        LAST_RESTART_ATTEMPT_INDEX: "Ultimo tentativo di riavvio del modulo",
        CONFIGURAZIONE: "Configurazione",
    },
    PAGE_PACKAGING: {
        SELEZIONA_UN_ORDINE: "Seleziona un ordine",
        ERRORE_SUPERAMENTO_QUANTITA_GROUPAGE: "Questo ordine causa il superamento della quantità massima per questo groupage.",
        CERCA_UN_ORDINE: "Cerca un ordine...",
        SELEZIONA_UN_MAGAZZINO: "Seleziona un magazzino...",
        SELEZIONA_UN_COMPUTER: "Seleziona un computer di stampa...",
        SELEZIONA_UNA_STAMPANTE_ZEBRA: "Seleziona una stampante zebra...",
        SELEZIONA_UNA_STAMPANTE_STANDARD: "Seleziona una stampante standard...",
        SELEZIONA_UNA_STAMPANTE_DI_SERVIZIO: "Seleziona una stampante di servizio...",
        NESSUNA_STAMPANTE_ZEBRA_CONFIGURATA: "Nessuna stampante zebra configurata",
        NESSUNA_STAMPANTE_STANDARD_CONFIGURATA: "Nessuna stampante standard configurata",
        NESSUNA_STAMPANTE_DI_SERVIZIO_CONFIGURATA: "Nessuna stampante di servizio configurata",
        SELEZIONA_UN_MAGAZZINO_INFO: "Per iniziare, seleziona un magazzino nelle opzioni in alto a destra.",
        LEGGI_UN_ARTICOLO: "Leggi il codice a barre di un articolo per identificare un ordine da lavorare.",
        ARTICOLO_NON_TROVATO: "Articolo non trovato.",
        ARTICOLO_NON_IN_ORDINE: "L’articolo letto non appartiene a quest’ordine.",
        ARTICOLO_COMPLETATO: "L'articolo letto è già stato completamente confermato in quest'ordine.",
        ORDINE_GIA_COMPLETATO: "La lavorazione di quest'ordine è già stata chiusa per questo magazzino.",
        ORDINE_SENZA_ARTICOLI_DA_INSCATOLARE: "Quest'ordine non ha articoli da inscatolare in questo magazzino.",
        ORDINE_NON_COMPLETAMENTE_CONFERMATO: "Non tutti gli articoli di quest'ordine sono stati confermati: la lavorazione non può essere chiusa.",
        ARTICOLO_IN_NESSUN_ORDINE: "Non è stato possibile trovare ordini da inscatolare che contengono questo articolo.",
        ARTICOLO_IN_ORDINE_PACKAGED: "L’articolo appartiene a un ordine che è già stato confermato ma non stampato. Vuoi andare alla pagina di dettaglio dell’ordine per procedere con la stampa?",
        ARTICOLO: "Articolo",
        MAGAZZINO: "Magazzino",
        SCATOLA: "Scatola",
        SELEZIONA_UNA_SCATOLA_ORDINE: "Seleziona una scatola per l'ordine",
        SELEZIONA_UNA_SCATOLA_RIGHE: "Seleziona una scatola per ciascuna riga dell'ordine",
        QUANTITA_CONFERMATA: "Quantità confermata",
        QUANTITA_RICHIESTA: "Quantità richiesta",
        SELEZIONA_UNA_SCATOLA: "Seleziona una scatola...",
        SELEZIONA_SCATOLE: "Seleziona scatole",
        CONFERMA_SCATOLA: "Conferma scatola",
        CHIUDI_LAVORAZIONE: "Chiudi lavorazione",
        CHIUDI_ORDINE: "Chiudi ordine",
        STAMPA_TUTTI: "Stampa tutti",
        STAMPA_DI_SERVIZIO: "Stampa di servizio",
        STAMPA_SINGOLA_SCHEDA_ARTICOLO: "Stampa singola scheda articolo",
        STAMPA_TUTTE_LE_SCHEDE_ARTICOLO: (count: number) => `Stampa tutte le schede articolo (${count})`,
        RICHIESTA_CONFERMA_NO_SCATOLE: "Non hai ancora confermato la scelta della scatola per questo ordine",
        INFORMAZIONI_SULLO_STATO: "Informazioni sullo stato",
        SCATOLA_CONFERMA_IN_CORSO: "Conferma scatola in corso",
        SCATOLA_CONFERMA_IN_CORSO_DESCRIPTION: "La conferma della scatola selezionata per questo ordine è in corso, si prega di attendere.",
        SCATOLA_CONFERMATA_CORRETTAMENTE: "Scatola confermata correttamente",
        SCATOLA_CONFERMATA_CORRETTAMENTE_DESCRIPTION: "La scatola selezionata è stata confermata correttamente per questo ordine.",
        ERRORE_CONFERMA_SCATOLA: "Errore nella conferma della scatola",
        ERRORE_CONFERMA_SCATOLA_DESCRIPTION: "Si è verificato un errore durante la conferma della scatola per questo ordine. Si prega di riprovare.",
        VAI_DETTAGLIO_CODA: "Vai al dettaglio della coda",
        RIESEGUI_CONFERMA_SCATOLA: "Riesegui conferma scatola",
        CONFERMA_RIESECUZIONE_CONFERMA_SCATOLA: "Sei sicuro di voler rieseguire la conferma della scatola?",
        RICHIESTA_CONFERMA: "Prima di chiudere la lavorazione di questo ordine, controlla di avere stampato i documenti necessari.",
        CONFERMA_UNA_QUANTITA_PER_QUESTO_ARTICOLO: "Conferma una quantità per questo articolo",
        CONFERMA_UNA_QUANTITA_ARTICOLO: (sku: string, shopOrderId: string) => <>Confermare una quantità per l'articolo <span className="fw-bold">{sku}</span> nell'ordine <span className="fw-bold">{shopOrderId}</span>?</>,
        GROUPAGE: {
            ORDINI_IN_LAVORAZIONE: "Ordini in lavorazione",
            NESSUN_ORDINE_IN_LAVORAZIONE: "Nessun ordine in lavorazione.",
            ORDINE_NON_IN_GROUPAGE_VUOI_AGGIUNGERE: "L'ordine selezionato non è attualmente incluso in questo groupage. Vuoi aggiungerlo al groupage?",
            ORDINE_NON_IN_GROUPAGE_VUOI_CREARE_GROUPAGE: "L'ordine selezionato non è attualmente incluso in un groupage. Vuoi creare un nuovo groupage con questo ordine?",
            CHIUDI_GROUPAGE: "Chiudi groupage",
            ORDINI_LAVORABILI: "Ordini lavorabili",
            NESSUN_ORDINE_LAVORABILE: "Nessun ordine lavorabile.",
            CONFERMA_CHIUSURA_GROUPAGE: "Prima di chiudere la lavorazione di questo groupage, controlla di avere stampato i documenti necessari.",
            IN_LAVORAZIONE: "In lavorazione",
            COMPLETATO: "Completato",
            ERRORE_SPEDIZIONE_GIA_PRESENTE: "Il groupage di destinazione ha già una spedizione. Chiudi la lavorazione del groupage prima di poter lavorare questo ordine.",
            RIMUOVI_DAL_GROUPAGE: "Rimuovi dal groupage",
            CONFERMA_RIMOZIONE_DAL_GROUPAGE: (shopOrderId: string) => <>Rimuovere l'ordine <span className="fw-bold">{shopOrderId}</span> dal groupage? I pezzi già confermati verranno azzerati.</>,
            ERRORE_RIMOZIONE_SPEDIZIONE_GIA_PRESENTE: "Il groupage ha già una spedizione: non è possibile rimuovere l'ordine.",
        },
        PRINT_ERRORS: {
            TITLE: "Si sono verificati i seguenti errori in fase di stampa:",
            GENERIC: "Generico",
            DOCUMENT_NOT_PDF: "Il documento richiesto non è un pdf",
            NO_PDF_AVAILABLE: "Nessun pdf disponibile per il documento richiesto",
            ORDER_DOCUMENTS_MISSING: "Manca il documento nell'ordine",
            URL_NOT_FOUND: "URL del documento non trovata",
            UNAUTHORIZED: "Accesso al documento non autorizzato",
            CETTIRE_NO_ORDER: "Ordine Cettire non confermato e quindi non disponibile per la stampa",
            NO_ORDER_ITEM_ID: "Order item id non presente",
            ZEBRA_PRINTER_NOT_AVAILABLE: "Stampante Zebra non disponibile: documento non stampato sulla Zebra",
            STANDARD_PRINTER_NOT_AVAILABLE: "Stampante standard non disponibile: documento non stampato sulla standard",
            CONFIRM_ORDER_ITEM: "Si è verificato un errore nella conferma della riga dell'ordine Cettire.",
            UNKNOWN_ERROR: "Errore sconosciuto",
            SERVICE: "Stampa di servizio",
        },
        ZEBRA_ERRORS: {
            OK: "La stampante funziona correttamente.",
            PAPER_OUT: "Carta assente o terminata",
            RIBBON_OUT: "Ribbon assente o terminato",
            MEDIA_DOOR_OPEN: "Sportello aperto",
            CUTTER_FAULT: "Errore nel cutter",
            PRINTHEAD_OVERHEATING: "Testina di stampa surriscaldata",
            MOTOR_OVERHEATING: "Motore surriscaldato",
            PRINTHEAD_FAULT: "Errore nella testina di stampa",
            INCORRECT_PRINTHEAD: "Testina di stampa non corretta",
            PRINTER_PAUSED: "Stampante in pausa",
            ERRORE_SCONOSCIUTO: "Errore sconosciuto. Controllare che la stampante Zebra sia accesa e collegata correttamente.",
        },
        CETTIRE: {
            PRENOTA_SPEDIZIONE: "Prenota spedizione",
            PRENOTA_SPEDIZIONE_DISABILITATO: "Per poter prenotare una spedizione su Cettire è necessario confermare tutti gli articoli per il magazzino selezionato.",
            NESSUNA_SPEDIZIONE_CREATA: "Nessuna spedizione creata.",
            INFORMAZIONI_SULLO_STATO: "Informazioni sullo stato",
            ELEMENTO_CODA_NON_ANCORA_PRESENTE: "L'elemento di coda non è ancora presente.",
            PRENOTAZIONE_AVVENUTA_CORRETTAMENTE: "Prenotazione avvenuta correttamente",
            PRENOTAZIONE_AVVENUTA_CORRETTAMENTE_DESCRIPTION: "La prenotazione della spedizione è avvenuta correttamente.",
            PRENOTAZIONE_FALLITA: "Prenotazione fallita",
            PRENOTAZIONE_FALLITA_DESCRIPTION: "La prenotazione della spedizione è fallita. Qui sotto puoi trovare il motivo del fallimento:",
            PRENOTAZIONE_IN_CORSO: "Prenotazione in corso",
            PRENOTAZIONE_IN_CORSO_DESCRIPTION: "La prenotazione della spedizione è in corso, si prega di attendere.",
            RIESEGUI_PRENOTAZIONE: "Riesegui prenotazione",
            VAI_DETTAGLIO_CODA: "Vai al dettaglio della coda",
            CONFERMA_RIESECUZIONE: "Sei sicuro di voler rieseguire la prenotazione della spedizione?"
        },
        MIINTO: {
            PRENOTA_SPEDIZIONE: "Prenota spedizione",
            SELEZIONA_TIPO_SERVIZIO: "Seleziona il tipo di servizio",
            SELEZIONA_SERVIZIO: "Seleziona servizio",
            SELEZIONA_PUNTO_DI_RITIRO: "Seleziona punto di ritiro",
            INFORMAZIONI_SULLO_STATO: "Informazioni sullo stato",
            ELEMENTO_CODA_NON_ANCORA_PRESENTE: "L'elemento di coda non è ancora presente.",
            PRENOTAZIONE_AVVENUTA_CORRETTAMENTE: "Prenotazione avvenuta correttamente",
            PRENOTAZIONE_AVVENUTA_CORRETTAMENTE_DESCRIPTION: "La prenotazione della spedizione è avvenuta correttamente.",
            PRENOTAZIONE_FALLITA: "Prenotazione fallita",
            PRENOTAZIONE_FALLITA_DESCRIPTION: "La prenotazione della spedizione è fallita. Qui sotto puoi trovare il motivo del fallimento:",
            PRENOTAZIONE_IN_CORSO: "Prenotazione in corso",
            PRENOTAZIONE_IN_CORSO_DESCRIPTION: "La prenotazione della spedizione è in corso, si prega di attendere.",
            RIESEGUI_PRENOTAZIONE: "Riesegui prenotazione",
            VAI_DETTAGLIO_CODA: "Vai al dettaglio della coda",
            CONFERMA_RIESECUZIONE: "Sei sicuro di voler rieseguire la prenotazione della spedizione?"
        }
    },
    PAGE_PRICEBOOKS: {
        AGGIUNGI_LISTINO: "Aggiungi listino",
        SCARICA_TEMPLATE: "Scarica template",
        CARICA_LISTINI: "Carica listini",
        TABLE: {
            NOME: "Nome",
            CODICE: "Codice",
            NAZIONI: "Nazioni",
            VALUTA: "Valuta",
            NUMERO_ARTICOLI: "N° Articoli",
            VAI_A_DETTAGLIO: "Vai al dettaglio",
            SCARICA_EXCEL: "Scarica Excel"
        }
    },
    PAGE_PRICEBOOK: {
        LISTINO_NON_TROVATO: "Listino non trovato",
        DATI_GENERALI: "Dati generali",
        NAZIONI: "Nazioni",
        ARTICOLI: "Articoli",
        PREZZO: "Prezzo",
        PREZZO_SCONTATO: "Prezzo scontato",
    },
    PAGE_REPORTS: {
        REPORT_DA_PROCESSARE: (count:number)=>count===0?<>Nessun report da elaborare</>:<>{count} report da elaborare.</>,
        REPORT_FALLITI: (count: number)=>count===0?<>Congratulazioni! Nessun report fallito.</>:<>{count} report falliti.</>,
        VAI_A_DETTAGLIO: "Vai al dettaglio",
        RIELABORA: "Rielabora il report",
        TRACKING: "Tracking elaborazione",
        VUOI_RIELABORARE_QUESTO_REPORT: "Sei sicuro di voler rielaborare questo report?",
    },
    PAGE_REPORT: {
        DETTAGLIO_REPORT: "Dettaglio report",
        REPORT_NON_TROVATO: "Report non trovato",
        INFORMAZIONI: "Informazioni",
        ID_REPORT: "ID Report",
        NOME_REPORT: "Nome report",
        CODICE_REPORT: "Codice report",
        CREATO_IL: "Creato il",
        AGGIORNATO_IL: "Aggiornato il",
        CONFIGURAZIONE_REPORT_DEL: "Configurazione report del",
        CONFIGURAZIONE: "Configurazione",
        SCHEDULAZIONE: "Schedulazione",
        NESSUNA_SCHEDULAZIONE: "Nessuna schedulazione",
        DESTINATARI: "Destinatari",
        NESSUN_DESTINATARIO: "Nessun destinatario",
        JSON: "JSON",
        DETTAGLI: "Dettagli",
        COPIA_JSON: "Copia JSON",
        CAMBIA_VISUALIZZAZIONE: "Cambia visualizzazione",
        INCLUDI_MAGAZZINI: "Includi magazzini"
    },
    PAGE_RESERVATIONS: {
        AGGIUNGI_RISERVA: "Aggiungi riserva",
        ELIMINA_RISERVE: "Elimina riserve",
        SCARICA_EXCEL: "Scarica Excel",
        MODIFICA_RISERVE_DA_EXCEL: "Modifica riserve da Excel",
        BULK_UPLOAD_INFO: (navigateFunction: Function) =><>Puoi verificare l'andamento della tua richiesta cliccando <span className="cs-link" onClick={()=>navigateFunction()}>qui</span>.</>,
        ARTICOLI: "__COUNT__ articoli",
        SELEZIONARE_SHOP_ARTICOLO: "Selezionare shop e articolo",
        ARTICOLO_PLACEHOLDER: "Digitare SKU parent, barcode o SKU...",
        TABLE: {
            ARTICOLO: "Articolo",
            PREZZO: "Prezzo",
            MAGAZZINO: "Magazzino",
            SHOPS: "Shop",
            QTY: "Qty",
            DATA_CREAZIONE: "Data creazione",
            DATA_MODIFICA: "Data modifica",
            QTY_RENDER: "__QTY__ di __WH_QTY__",
            SHOP_TOOLTIP: "Clicca per andare alla pagina dello shop __SHOP_NAME__, alt+click per filtrare le riserve per questo shop",
            SKU_TOOLTIP: (sku: string)=>`Clicca per andare alla pagina dello SKU ${sku}, alt+click per filtrare le riserve per questo SKU`,
            WH_TOOLTIP: "Premi alt+click per filtrare le riserve per questo magazzino",
        },
        SHOP_ARTICOLO_VALIDI: "Gli shop e l'articolo selezionati sono validi.",
        VALIDAZIONE_IN_CORSO: "Validazione in corso...",
        NEW_RESERVATION_CHECK_ERRORS: {
            SHOP_NON_IN_BUCKETS: "I seguenti shop non appartengono a nessuno dei bucket disponibili all'utente:",
            ARTICOLO_NON_TROVATO: "Articolo non trovato.",
            SKU_CON_BUCKET_MANCANTI: "I seguenti sku non sono disponibili ad alcuni dei bucket utilizzati dagli shop selezionati:",
            SKU_CON_SHOP_ESCLUSI: "I seguenti sku hanno, tra gli shop esclusi dai listing, almeno uno degli shop selezionati:",
            WHS_NON_DISPONIBILI: "Non sono disponibili magazzini per gli shop selezionati.",
        },
        NEW_RESERVATION_RESULTS: {
            QUANTITA: "Quantità richiesta",
            RISULTATI: "Risultati",
            ESEGUITO: "Eseguito",
            ERRORE: "In errore",
            INFO: "Nessuna quantità riservabile"
        },
        SELEZIONA_MASSIMA_QUANTITA_DISPONIBILE: "Riserva la massima quantità disponibile nel magazzino",
        ATTIVI_SE_SHOP_ARTICOLO_VALIDATI: "Attivi una volta selezionati e validati gli shop e l'articolo da utilizzare per la nuova riserva.",
        SELEZIONARE_MAGAZZINO_E_QUANTITA: "Selezionare un magazzino e definire la quantità da riservare.",
        SELEZIONARE_MAGAZZINO_MAX_QTY: "Selezionare un magazzino; verrà riservata la quantità massima disponibile in esso.",
    },
    PAGE_SETTINGS_REPORTS: {
        REPORT_DISABILITATO: ()=><>Questo report è <span className="fw-bold">disabilitato</span>. Puoi abilitarlo cliccando con il tasto destro e scegliendo l'opzione apposita.</>,
        REPORT_ABILITATO: ()=><>Questo report è <span className="fw-bold">abilitato</span>. Puoi disabilitarlo cliccando con il tasto destro e scegliendo l'opzione apposita.</>,
        ABILITA: "Abilita",
        DISABILITA: "Disabilita",
        NUOVO_REPORT: "Nuovo report",
        MODIFICA_REPORT: "Modifica report",
        SELEZIONA_TIPO_REPORT: "Seleziona il tipo di report...",
        FORMATO_DESTINATARI_HELP: ()=><><div className="mb-1">E' possibile inserire indirizzi email nei seguenti formati:</div><ul><li>mario.rossi@email.com</li><li>Mario Rossi &lt;mario.rossi@email.com&gt;</li></ul></>,
        FORMATO_DESTINATARI_NON_CORRETTO: "Almeno uno dei destinatari non ha il formato corretto",
        CAMPI_AGGIUNTIVI: "Campi aggiuntivi",
        INFORMAZIONI_AGGIUNTIVE: "Informazioni aggiuntive",
        INCLUDI_INFORMAZIONI_CATEGORIE: "Includi le informazioni sulle categorie",
        INCLUDI_INFORMAZIONI_IMMAGINI: "Includi le informazioni sulle immagini",
        INCLUDI_INFORMAZIONI_SHOP_ATTIVI: "Includi le informazioni sugli shop attivi",
        CONFERMA_CREAZIONE: "Confermi la creazione del report?",
        CONFERMA_MODIFICA: "Confermi le modifiche al report?",
        CREAZIONE_AVVENUTA_CON_SUCCESSO: "Creazione avvenuta con successo",
        MODIFICA_AVVENUTA_CON_SUCCESSO: "Modifica avvenuta con successo",
        MINUTI: "Minuti",
        ORE: "Ore",
        GIORNI: "Giorni",
        MESI: "Mesi",
        GIORNI_SETTIMANALI: "Giorni settimanali",
        RAGGRUPPA_PER_SKU_PARENT: "Raggruppa per SKU Parent",
        RAGGRUPPA_PER_SKU_PARENT_HELP: ()=><><div className="mb-1">E' possibile raggruppare gli articoli per SKU Parent:</div><ul><li>Se il raggruppamento è attivo, il report contiene una riga per SKU Parent;</li><li>Se il raggruppamento NON è attivo, il report contiene una riga per SKU.</li></ul></>,
        CONFERMA_ABILITAZIONE: "Confermi l'abilitazione di questo report?",
        CONFERMA_DISABILITAZIONE: "Confermi la disabilitazione di questo report?",
        CONFERMA_ELIMINAZIONE: "Confermi l'eliminazione di questo report?",
        TABLE: {
            TIPO_REPORT: "Tipo report",
            STATO: "Stato",
            SCHEDULAZIONE: "Schedulazione",
            DESTINATARI: "Destinatari",
            SHOP: "Shop",
            CAMPI_PERSONALIZZATI: "Campi personalizzati",
        }
    },
    PAGE_SHOPS: {
        FILTERS: {
            CONFIRMED: "Confermato",
            ERROR: "Errore",
            AUTH_ERROR: "Errore di autenticazione",
            PENDING: "In elaborazione",
            DISABLED: "Disabilitato",
            STATO_DI_ABILITAZIONE: "Stato di abilitazione",
            SOLO_ABILITATI: "Solo abilitati",
            SOLO_DISABILITATI: "Solo disabilitati",
        },
        NUOVO_SHOP: "Nuovo Shop",
        TIPO_SHOP: "Tipo di shop",
        NOME_SHOP: "Nome shop",
        TABLE: {
            NOME: "Nome",
            TIPO: "Tipo",
            STATO: "Stato",
            ABILITATO: "Abilitato",
            DISABILITATO: "Disabilitato",
            CODICE: "Codice",
            VAI_A_DETTAGLIO: "Vai al dettaglio",
            COPIA_ID: "Copia ID",
            COPIA_CUSTOMER_CODE: "Copia codice cliente",
            COPIA_MERCHANT_ID: "Copia Merchant ID",
            COPIA_TOKEN: "Copia Token",
            COPIA_BEARER: "Copia Bearer Token",
            ATTIVA: "Attiva shop",
            DISATTIVA: "Disattiva shop",
            CONFERMA_DISATTIVAZIONE_SHOP: "Confermi la disattivazione dello shop __SHOP__?",
            CONFERMA_ATTIVAZIONE_SHOP: "Confermi l'attivazione dello shop __SHOP__?",
            SHOP_ATTIVATO: "Shop __SHOP__ attivato correttamente.",
            SHOP_DISATTIVATO: "Shop __SHOP__ disattivato correttamente.",
            MIINTO_API: "Miinto API",
            COPIA_URL: "Copia URL",
            COPIA_USERNAME: "Copia username",
            COPIA_PASSWORD: "Copia password",
            COPIA_X_API_KEY: "Copia x_api_key",
        },
        REPORT_DI_VALIDAZIONE: {
            TITLE: "Report di validazione",
            PASSI_DI_VALIDAZIONE: "Passi di validazione",
            LIVELLO: "Livello",
            GRUPPO: "Gruppo",
            MESSAGGIO: "Messaggio",
        },
        AGGIORNA_QUANTITA_VISIBILI: {
            TITLE: "Aggiorna quantità visibili",
            NESSUNO_SHOP_ABILITATO: "Non ci sono shop abilitati su cui eseguire l'aggiornamento.",
            CONFERMA_AGGIORNAMENTO_SINGLE: (name:string)=><>Verrà effettuato l'aggiornamento delle quantità disponibili per lo shop <span className="fw-bold">{name}</span>. Proseguire?</>,
            CONFERMA_AGGIORNAMENTO: (count:number)=><>Verrà effettuato l'aggiornamento delle quantità disponibili per <span className="fw-bold">{count}</span> shop. Proseguire?</>,
            SI_SONO_VERIFICATI_ERRORI: "Si sono verificati i seguenti errori:",
        }
    },
    PAGE_SHOP: {
        SEZIONI: {
            STATISTICHE_ESPOSIZIONE_CATALOGO: "Statistiche esposizione catalogo",
            CONFIGURAZIONE: "Configurazione",
            LISTING: "Listing",
            CATALOGO_ONLINE: "Catalogo online",
            FUNZIONALITA_ATTIVE: "Funzionalità attive",
            VALORI_ATTRIBUTI: "Valori attributi",
        },
        DETTAGLIO_SHOP: "Dettaglio shop",
        TIPO_SHOP: "Tipo shop",
        NOME: "Nome",
        CUSTOMER_CODE: "Customer code",
        CONFIGURAZIONI_GENERALI: "Configurazioni generali",
        CONFIGURAZIONI_SPECIFICHE: "Configurazioni specifiche",
        ALTRE_CONFIGURAZIONI: "Altre configurazioni",
        ENDPOINT_PER_SCARICO_CATALOGO: "Endpoint per scarico catalogo",
        CREDENZIALI: "Credenziali",
        LISTINO: "Listino",
        LISTINI: "Listini",
        LISTINO_PIENO: "Listino pieno",
        LISTINO_SCONTATO: "Listino scontato",
        LISTINI_DI_DEFAULT: "Listini di default",
        ACCESS_KEY: "Access key",
        SECRET_KEY: "Secret key",
        BRAND_LABEL: "Brand label",
        SELLER_LABEL: "Seller label",
        SHIPPING_POINT: "Shipping point",
        GENERALE: "Generale",
        DEFAULT_CURRENCY: "Default currency",
        LISTING: "Listing",
        FLUSSI: "Flussi",
        CONFIGURAZIONE_FLUSSI_E_LISTING: "Configurazione flussi e listing",
        STRATEGIA_MAGAZZINI: "Strategia magazzini",
        SOVRASCRIVI_CONFIGURAZIONE_ACCOUNT: "Sovrascrivi la configurazione dell'account",
        STRATEGIA: "Strategia",
        CONFERMA_CREAZIONE: "Confermi la creazione dello shop?",
        CONFERMA_MODIFICA: "Confermi le modifiche allo shop?",
        CREAZIONE_AVVENUTA_CON_SUCCESSO: "Creazione dello shop __NAME__ avvenuta con successo",
        MODIFICA_AVVENUTA_CON_SUCCESSO: "Modifica allo shop __NAME__ avvenuta con successo",
        TOKEN: "Token",
        CONFERMA_RIGENERAZIONE_TOKEN: "Confermi la rigenerazione del token?",
        ORDER_PRICE:"Prezzo dell'ordine",
        CREDENZIALI_SHOP_API:"Credenziali shop API",
        CONTROLLO_PREZZI_RICEZIONE_ORDINE: "Controllo prezzi in ricezione ordine",
        API_CREDENTIALS:"Credenziali API",
        SFTP_CREDENTIALS:"Credenziali SFTP",
        OTHER_CONFIGURATIONS:"Altre configurazioni",
        LANGUAGES: "Lingue da pubblicare sullo shop",
        CAMPI_TAG: "Campi tag",
        PUBLISH_ONLY_ITEMS_WITH_QUANTITY: "Pubblica solo articoli con quantità",
        STATISTICHE_CATALOGO: "Statistiche catalogo",
        TOLLERANZA_ESPOSIZIONE_STATISTICHE_CATALOGO: "Tolleranza esposizione statistiche catalogo",
        CONTROLLO_ORDINI_PENDING: {
            TITLE: "Controllo ordini pending",
            STATO_DI_ATTIVAZIONE: "Stato di attivazione",
            TOLLERANZA: "Tolleranza (in ore)",
            INVIO_EMAIL_CLIENTE: "Invia email al cliente",
            CONTROLLO_DISABILITATO_SE_INBOUND_ORDER_NON_ATTIVO: "Il controllo ordini pending non è attivabile se lo scarico ordini è disabilitato."
        },
        OPZIONI_PER_VARIAZIONI: {
            TITLE: "Opzioni per le variazioni",
            OPZIONI: "Opzioni",
            DESCRIZIONI_IN_LINGUA: "Descrizioni in lingua per le opzioni",
            NESSUNA_OPZIONE_SELEZIONATA: "Nessuna opzione selezionata",
            NESSUNA_LINGUA_SELEZIONATA: "Nessuna lingua selezionata",
        },
        CATALOG_EXPOSURE: {
            RIEPILOGO: "Riepilogo",
            ULTIMO_AGGIORNAMENTO: "Ultimo aggiornamento",
            VALORE_TOTALE: "Valore totale",
            QUANTITA_TOTALE: "Quantità totale",
            NUMERO_TAGLIE: "Numero taglie",
            NUMERO_ARTICOLI: "Numero articoli",
            DETTAGLI: "Dettagli",
            DATE_FILTER: {
                DAL_PRIMO_DEL_MESE: "Dal primo del mese",
                ULTIMI_TRE_MESI: "Ultimi 3 mesi",
                ULTIMI_SEI_MESI: "Ultimi 6 mesi",
                ULTIMI_NOVE_MESI: "Ultimi 9 mesi",
                ULTIMO_ANNO: "Ultimo anno"
            }
        },
        ACTIVE_FEATURES: {
            CONDIZIONE_COMMERCIALE: "Condizione commerciale",
            NESSUNA_CONDIZIONE_COMMERCIALE: "Nessuna condizione commerciale associata",
            NESSUNA_REGOLA_DI_ESCLUSIONE: "Nessuna regola di esclusione associata",
            CONDIZIONE_COMMERCIALE_DESC: "Condizione commerciale associata allo Shop",
            ALTRI_SHOP_ASSOCIATI: "Altri shop associati",
            CUSTOMER_ASSOCIATI: "Customer associati",
            ECCEZIONI_PRESENTI: "Eccezioni presenti",
            REGOLE_DI_ESCLUSIONE: "Regole di esclusione",
            REGOLE_DI_ESCLUSIONE_DESC: "Regole di esclusione dal listing associate allo Shop",
            NOME_CONDIZIONE_COMMERCIALE: "Nome condizione commerciale",
            NOME_REGOLA: "Nome regola",
            COPIA_ID: "Copia ID regola",
            ALTRI_SHOP_ESCLUSI: "Altri shop esclusi",
            CONDIZIONI: "Condizioni",
            VAI_ALLA_REGOLA: "Vai alla regola di esclusione",
        },
        ATTRIBUTE_VALUES: {
            NESSUN_ATTRIBUTO_CON_VALORI_SHOP: "Nessun attributo con valori specifici per lo shop.",
            SELEZIONA_ATTRIBUTO: "Seleziona attributo...",
            SELEZIONA_ATTRIBUTO_INFO: "Seleziona un attributo per visualizzare i suoi valori specifici per questo shop.",
            SELEZIONA_VALORE_PARENT: (parentAttribute: CloudStoreAttributeEnum) => `Seleziona un valore per l'attributo ${parentAttribute}...`,
        },
        CHANNEL: {
            ERRORE_SALVATAGGIO: "Si è verificato un errore nel salvataggio dei seguenti shop: __SHOPLIST__",
        },
        PERSONAL_SHOP: {
            PRODUCT_CACHE: {
                FILTERS: {
                    SKU: "SKU",
                    SHOP_ITEM_ID: "Shop Item ID",
                },
                TABLE: {
                    SKU: "SKU",
                    SHOP_ITEM_ID: "Shop Item ID",
                    QTY: "Quantità",
                    PRICE: "Prezzo",
                    SALE_PRICE: "Prezzo scontato",
                    UPDATE_DT: "Data aggiornamento"
                },
                CONTEXT_MENU: {
                    COPIA_SKU: "Copia SKU",
                    COPIA_SHOP_ITEM_ID: "Copia Shop Item ID"
                }
            },
        },
        MIINTO: {
            IDENTIFIER: "Identificativo",
            SECRET: "Secret",
            LANGUAGES: "Lingue da pubblicare sullo shop",
            PRICEBOOKS: "Listini",
            TOKEN: "Token",
            URL: "URL",
            USERNAME: "Username",
            PASSWORD: "Password",
            PRODUCT_CACHE: {
                FILTERS: {
                    MIINTO_ID: "Miinto ID",
                    MIINTO_ITEM_ID: "Miinto Item ID"
                },
                TABLE: {
                    MIINTO_ID: "Miinto ID",
                    MIINTO_ITEM_ID: "Miinto Item ID",
                    GTIN: "GTIN",
                    ITEM_GROUP_ID: "Item Group ID",
                    COLOR: "Colore",
                    UPDATE_DT: "Data aggiornamento"
                },
                CONTEXT_MENU: {
                    MOSTRA_DETTAGLIO: "Mostra dettaglio",
                    COPIA_MIINTO_ID: "Copia Miinto ID",
                    COPIA_MIINTO_ITEM_ID: "Copia Miinto Item ID"
                },
                DETTAGLI: {
                    TITLE: "Dettagli prodotto",
                    STYLE_ID: "Style ID",
                }
            }
        },
        AMAZON: {
            AMAZON_EUROPE: "Amazon Europa",
            MARKETPLACE: "Marketplace",
            CLIENT_ID: "Client ID",
            MERCHANT_ID: "Merchant ID",
            DEVELOPER_MERCHANT_ID: "Developer Merchant ID",
            DEVELOPER_MERCHANT_ID_DESC: "Il Developer Merchant ID è un identificativo richiesto da Amazon per l'integrazione, ma non è sempre necessario. Se non è presente nella documentazione di integrazione del marketplace Amazon di riferimento, è possibile inserire lo stesso valore del Merchant ID.",
            COPIA_DA_MERCHANT_ID: "Copia da Merchant ID",
            CLIENT_SECRET: "Client Secret",
            REFRESH_TOKEN: "Refresh token",
            CONFERMA_RIMOZIONE_SHOP: "Confermi la rimozione del marketplace __MARKETPLACE__?",
            SELEZIONARE_ALMENO_UN_MARKETPLACE: "Selezionare almeno un marketplace",
            IMPORTA_DATI_CLIENTE_ORDINI: {
                TITLE: "Importa dati cliente ordini",
                DESC: ()=><div><p>Questa funzionalità permette all’utente di caricare e processare il file di export <span className="fw-bold">spedizione gestite da Amazon - fatturazione fiscale</span> degli ordini Amazon esportato dal Seller Central.</p><p>Verrà analizzata la conformità del file prima dell'utilizzo.</p><p>Durante il caricamento verranno mostrati i risultati dell'operazione fino al completamento.</p></div>,
                ERRORE_FILE_NON_CONFORME_COLONNE_MANCANTI: (columns: string[])=> <span>Il file caricato non è conforme perché mancano le seguenti colonne: <strong>{columns.join(", ")}</strong></span>,
                ERRORE_RIGA_CAMPI_OBBLIGATORI: (columns: string[])=>`Mancano i seguenti campi obbligatori: ${columns.join(", ")}`,
                TOTALE_RIGHE: "Totale righe nel file",
                RIGHE_VALIDE: "Righe valide",
                RIGHE_NON_VALIDE: "Righe non valide",
                IMPORT_LOG: {
                    TEXT: {
                        IMPORT_AVVIATO: (startDate: string, endDate: string) => `Avviato import per gli ordini dal ${startDate} al ${endDate}`,
                        SCARICO_ORDINI: ()=>"Scarico ordini in corso...",
                        ORDINI_TROVATI: (count: number) => `Ordini trovati a sistema nel range di date richiesto: ${count}`,
                        ERRORE_RIGA_ORDINE_DUPLICATO: (rowNumber: number, orderId: string) => `${rowNumber} KO: Ordine ${orderId} duplicato nel file di import.`,
                        ERRORE_RIGA_NON_VALIDA: (rowNumber: number, message: string) => `${rowNumber} KO: Riga non valida: ${message}`,
                        ERRORE_ORDINE_NON_TROVATO: (rowNumber: number, orderId: string) => `${rowNumber} KO: Ordine ${orderId} non trovato a sistema.`,
                        ERRORE_SHIPPING_INFO: (rowNumber: number, orderId: string) => `${rowNumber} KO: Ordine ${orderId} errore nel salvataggio delle informazioni di spedizione.`,
                        ERRORE_BILLING_INFO: (rowNumber: number, orderId: string) => `${rowNumber} KO: Ordine ${orderId} errore nel salvataggio delle informazioni di fatturazione.`,
                        RIGA_OK: (rowNumber: number, orderId: string) => `${rowNumber} OK: Ordine ${orderId} aggiornato correttamente.`,
                        ORDINI_AGGIORNATI: (count: number) => `Ordini aggiornati correttamente: ${count}`,
                        ORDINI_NON_AGGIORNATI: (count: number) => `Ordini non aggiornati: ${count}`,
                        FINE_IMPORT: ()=>"Import terminato.",
                    },
                    HTML: {
                        IMPORT_AVVIATO: (startDate: string, endDate: string) => <>Avviato import per gli ordini dal <strong>{startDate}</strong> al <strong>{endDate}</strong></>,
                        SCARICO_ORDINI: ()=><>Scarico ordini in corso...</>,
                        ORDINI_TROVATI: (count: number) => <>Ordini trovati a sistema nel range di date richiesto: <strong>{count}</strong></>,
                        ERRORE_RIGA_ORDINE_DUPLICATO: (rowNumber: number, orderId: string) => <><strong className="text-danger">{rowNumber} KO:</strong> Ordine <strong>{orderId}</strong> duplicato nel file di import.</>,
                        ERRORE_RIGA_NON_VALIDA: (rowNumber: number, message: string) => <><strong className="text-danger">{rowNumber} KO:</strong> Riga non valida: {message}</>,
                        ERRORE_ORDINE_NON_TROVATO: (rowNumber: number, orderId: string) => <><strong className="text-danger">{rowNumber} KO:</strong> Ordine <strong>{orderId}</strong> non trovato a sistema.</>,
                        ERRORE_SHIPPING_INFO: (rowNumber: number, orderId: string) => <><strong className="text-danger">{rowNumber} KO:</strong> Ordine <strong>{orderId}</strong> errore nel salvataggio delle informazioni di spedizione.</>,
                        ERRORE_BILLING_INFO: (rowNumber: number, orderId: string) => <><strong className="text-danger">{rowNumber} KO:</strong> Ordine <strong>{orderId}</strong> errore nel salvataggio delle informazioni di fatturazione.</>,
                        RIGA_OK: (rowNumber: number, orderId: string) => <><strong className="text-success">{rowNumber} OK:</strong> Ordine <strong>{orderId}</strong> aggiornato correttamente.</>,
                        ORDINI_AGGIORNATI: (count: number) => <>Ordini aggiornati correttamente: <strong>{count}</strong></>,
                        ORDINI_NON_AGGIORNATI: (count: number) => <>Ordini non aggiornati o con errori: <strong>{count}</strong></>,
                        FINE_IMPORT: ()=><>Import terminato.</>,
                    }
                },
                SCARICA_REPORT: "Scarica report"
            },
        },
        WINKELSTRAAT: {
            TIPO_CREDENZIALI: "Tipo credenziali",
            CLIENT_ID: "ID Client",
            SECRET_ID: "ID Secret",
            X_API_KEY: "x_api_key",
            TOKEN_CHANNABLE: "Token Channable",
            PROJECT_ID_CHANNABLE: "Project ID Channable",
            SKU_PREFIX: "Prefisso SKU",
            WEBHOOKS_TITLE: "Webhooks",
            WEBHOOKS: {
                SHIPMENT: "Shipment",
                SHIPMENT_TRACK: "Shipment track",
                RMA_ITEMS: "RMA items",
            },
            URL: "URL",
            USERNAME: "Username",
            PASSWORD: "Password",
            USA_ITEM_ID_COME_CODICE_ARTICOLO: "Usa item id come codice articolo",
        },
        DECATHLON: {
            PRODUCT_CACHE: {
                FILTERS: {
                    OFFER_ID: "Offer ID",
                    OFFER_SKU: "Offer SKU",
                    PRODUCT_SKU: "Product SKU",
                },
                TABLE: {
                    OFFER_ID: "Offer ID",
                    OFFER_SKU: "Offer SKU",
                    PRODUCT_SKU: "Product SKU",
                    QTY: "Qty",
                    PRICE: "Price",
                    UPDATE_DT: "Update date"
                },
                CONTEXT_MENU: {
                    MOSTRA_DETTAGLIO: "Mostra dettaglio",
                    COPIA_OFFER_ID: "Copia Offer ID",
                    COPIA_OFFER_SKU: "Copia Offer SKU",
                    COPIA_PRODUCT_SKU: "Copia Product SKU",
                },
                DETTAGLI: {
                    TITLE: "Dettagli prodotto",
                    CS_ITEM_ID: "CS Item ID",
                    CS_PARENT_SKU: "CS Parent SKU",
                    MIRAKL_SHOP_ID: "Mirakl Shop ID",
                    ORIGIN: "Origine"
                }
            }
        },
        GIGLIO: {
            USERNAME: "Username",
            PASSWORD: "Password",
            ENVIRONMENT: "Ambiente",
            SANDBOX: "Sandbox",
            PRODUCTION: "Produzione",
            INTEGRATED_TEST: "Test di integrazione"
        },
        ZALANDO: {
            CLIENT_ID: "ID Client",
            SECRET_ID: "ID Secret",
            ZSS_ATTIVO: "ZSS Abilitato",
            ZFS_ATTIVO: "ZFS Abilitato",
            CENTRI_LOGISTICI: "Centri logistici",
            ID_ZALANDO: "ID Zalando",
            MAGAZZINO_CLOUDSTORE: "Magazzino CloudStore",
            PRODUCT_CACHE: {
                FILTERS: {
                    EAN: "EAN",
                    SKU: "SKU",
                    SIMPLE_ID: "Simple ID"
                },
                TABLE: {
                    EAN: "EAN",
                    SKU: "SKU",
                    SIMPLE_ID: "Simple ID"
                },
                CONTEXT_MENU: {
                    MOSTRA_DETTAGLIO: "Mostra dettaglio",
                    COPIA_EAN: "Copia EAN",
                    COPIA_SKU: "Copia SKU",
                    COPIA_SIMPLE_ID: "Copia Simple ID"
                },
                DETTAGLI: {
                    TITLE: "Dettagli prodotto",
                    OFFERS: "Offerte",
                    ORIGIN: "Origine",
                    UPDATE_DT: "Data di aggiornamento",
                    COUNTRY: "Paese",
                    STOCK: "Stock",
                    PRICE_REGULAR: "Prezzo normale",
                    PRICE_DISCOUNTED: "Prezzo scontato",
                    STATUSES: "Stati"
                }
            }
        },
        ITALIST:{
            PARTIAL_ORDER:"Abilita ordini parziali",
            API_KEY: "api key",
            STORE_KEY:"store key",
        },
        CETTIRE:{
            USERNAME: "Username",
            PASSWORD: "Password",
            USER_ID:"User Id",
        },
        MIRAKL:{
            API_KEY: "api key",
            SHOP_ID: "Shop Id",
        },
        FARFETCH:{
            STORE_ID:"Store Id",
            SAFE_KEY:"Chiave di sicurezza",
            GOT_TO_SHOP:"Dettaglio dello shop",
            MERCHANT_CODE:"Merchant Code",
            MERCHANT_CODE_EXIST: "Valore duplicato in altro shop Farfetch",
            VPI_PORT_ERROR:"la porta deve essere inferiore o uguale a 65535",
            URL: "URL",
            USERNAME: "Username",
            PASSWORD: "Password",
            CONFERMA_AUTOMATICA_SCATOLA_SUGGERITA: "Conferma automatica della scatola suggerita da Farfetch",
            CONFERMA_AUTOMATICA_SCATOLA_SUGGERITA_DISABLED: "Questa opzione è disabilitata quando lo scarico ordini non è attivo.",
            CONFERMA_AUTOMATICA_SCATOLA_SUGGERITA_DESC: "Dopo aver confermato la disponibilità della merce, CloudStore confermerà automaticamente la scatola che Farfetch ha suggerito in fase di invio dell’ordine, se presente.",
            REST: {
                REST_API: "REST API",
                CONFIGURA_REST_API: "Configura REST API",
                CLIENT_ID: "Client ID",
                CLIENT_SECRET: "Client Secret",
                USERNAME: "Username",
                PASSWORD: "Password",
                PARTNER_ID: "Partner ID",
                USER_AGENT: "User agent",
                MERCHANT_UUID: "Merchant UUID",
            },
            VPI:{
                TITLE:"Vendor Provider Imagery",
                ENABLED:"Abilita Vendor Provider Imagery",
                HOSTNAME:"Nome del Host",
                PORT:"Porta",
                USENAME:"Username",
                PASSWORD:"Password",
            },
            FXFF:{
                TITLE:"Fulfillment",
                ENABLED:"Abilita Fulfillment da Farfetch", 
                LOGISTIC_CENTER:"Centro Logistico",
                LOGISTIC_CENTER_IT:"Italia",
                LOGISTIC_CENTER_HK:"Hong Kong",
                LOGISTIC_CENTER_US:"Stati Uniti",
            },
            SANDBOX:"Sandbox",
            B2B:"B2B",
            ROLE:"Ruolo",
            TABLE_SEC:{
                TITLE:"Lista shops secondari collegati",
                NOME: "Nome Shop",
                CODICE:"Codice",
                COPY_ID:"Copia identificativo Shop",
                SHOP_ID_COPY: "Shop id di __FF__ copiato!",
                GOT_TO_SHOP:"Dettaglio dello shop",
            },
            PRIMARY_SHOP:"Shop Primario",
            BUSINESS_MODEL: "Business Model",
            DEFAULT: "Default",
            BID_ASK: "Bid / Ask",
            BUY_SELL: "Buy / Sell",
            QUESTO_SHOP_PRIMARIO: "Questo è uno shop primario.",
            QUESTO_SHOP_SECONDARIO: "Questo è uno shop secondario.",
            PRODUCT_CACHE: {
                FILTERS: {
                    SKU: "SKU",
                    BARCODE: "Barcode",
                    STORE_BARCODE: "Store Barcode",
                    CERCA_PER_SKU: "Cerca per SKU",
                },
                TABLE: {
                    ITEMID: "Item ID",
                    SKU: "SKU",
                    BARCODE: "Barcode",
                    STORE_BARCODE: "Store Barcode",
                    BRAND: "Marca",
                    PREZZI: "Prezzi",
                    PIENO: "Pieno",
                    SCONTATO: "Scontato",
                    TAGLIA_STAGIONE: "Taglia / Stagione",
                    TAGLIA: "Taglia",
                    STAGIONE: "Stagione",
                    QUANTITA: "Quantità"
                },
                CONTEXT_MENU: {
                    MOSTRA_DETTAGLIO: "Mostra dettaglio",
                    COPIA_ITEM_ID: "Copia Item ID",
                    COPIA_STORE_BARCODE: "Copia Store Barcode"
                },
                DETTAGLI: {
                    TITLE: (itemId: number, size: string)=>`Identificativi prodotto ${itemId.toString()} / ${size}`,
                    ALTRE_INFORMAZIONI: "Altre informazioni",
                    BARCODE: "Barcode",
                    PREZZO_PIENO: "Prezzo pieno",
                    PREZZO_SCONTATO: "Prezzo scontato",
                    DATA_AGGIORNAMENTO: "Data aggiornamento",
                    DIPARTIMENTO: "Dipartimento",
                    GENERE: "Genere",
                    SKU: "SKU",
                    NOME: "Nome",
                    GRUPPO: "Gruppo",
                    SCALA_TAGLIE: "Scala taglie",
                    STILE: "Stile",
                    ORIGINE: "Origine"
                }
            }
        },
        SHOPIFY: {
            DISCLAIMER_LINGUA: ()=><div><strong>Attenzione!</strong> L'elenco delle lingue da pubblicare sullo shop, se popolato, deve obbligatoriamente contenere la lingua impostata come default per questo shop su Shopify.</div>,
            CONFIGURAZIONE_METAFIELD_PRODOTTO: "Configurazione Metafield - Prodotto",
            CAMPO_CLOUDSTORE: "Campo CloudStore",
            METAFIELD_SHOPIFY: "Metafield Shopify",
            TIPO: "Tipo",
            NAMEFIELD_SHOPIFY: "Namefield Shopify",
            DATA_TYPE_SHOPIFY: "Data type Shopify",
            NESSUNA_CONFIGURAZIONE: "Nessuna associazione definita.",
            NOTIFICA_CLIENTE_SPEDIZIONE_ORDINE: "Notifica utente alla spedizione dell'ordine",
            SHOP_NAME: "shop_name",
            TOKEN: "token",
            TIPO_AUTENTICAZIONE: "Tipo di autenticazione",
            CREDENZIALI_LEGACY: "Credenziali legacy",
            CREDENZIALI_SVILUPPATORE: "Credenziali sviluppatore",
            CLIENT_ID: "Client ID",
            CLIENT_SECRET: "Client Secret",
            USA_SHOPIFY_MARKETS: "Usa Shopify Markets",
            TITOLO_CATALOGO: "Titolo catalogo",
        },
        ZETTLE: {
            API_KEY: "Api key",
            CLIENT_ID: "Client ID",
            VAT_PERCENTAGE: "Percentuale IVA"
        }
    },
    PAGE_WAREHOUSES: {
        NUOVO_MAGAZZINO: "Nuovo Magazzino",
        FILTRA_SYSTEM: "Mostra i magazzini definiti dal sistema",
        FILTRA_USER: "Mostra i magazzini definiti da utente",
        TABLE: {
            NOME: "Nome",
            STATO: "Stato",
            PRIORITA: "Priorità",
            CODICE: "Codice",
            DEFINITO_DA: " Definito da",
            VAI_A_DETTAGLIO: "Vai al dettaglio",
            COPIA_ID: "Copia ID",
            COPIA_CODICE: "Copia codice",
            ELIMINA:"Cancella Magazzino",
            CONFERMA_RIMOZIONE_MAGAZZINO: "Confermi l'eliminazione del magazzino __WAREHOUSE__?",
            RIMOZIONE_MAGAZZINO_SUCCESS: "Il magazzino __WAREHOUSE__ è stato eliminato correttamente",
            ADDRESS_LINE: "Indirizzo",
            CITY:"Città",
            PROVINCE:"Provincia",
            PROVINCE_CODE:"Codice",
            POSTAL_CODE:"Codice postale",
            COUNTRY_CODE:"Nazione",
            MODIFY:"Modifica magazzino"
        },
        OPERATION_SUCCESS:"Magazzino salvato correttamente",
        OPERATION_ERROR:"Errore durante il salvataggio del magazzino"
    },
    PAGE_CUSTOMERS:{
        CUSTOMER_DETAILS:"Dettaglio Cliente",
        COPIA_ID: "Copia ID",
        NEW_CUSTOMER:"Nuovo Cliente",
        CUSTOMER:"Cliente",
        RETURN:"Return",
        LOADING: "in caricamento...",
        NOT_FOUND: "Cliente non trovato",
        ON_ERROR: "in errore", 
        CREATION_DATE:"Data creazione",
        ORDINI_ULTIMO_ANNO: "Ordini nell'ultimo anno",
        ORDERS_MADE:"Ordini effettuati nel periodo",
        UPDATED_DATE:"Data ultimo aggionamento",
        ORDER_DATE: "Data ordine",
        SHIPPING_ADDRESSES:"Indirizzi di spedizione",
        ADD_NEW_ADDRESS:"Aggiungi un nuovo indirizzo si spedizione",
        MODIFY_ADDRESS:"Modifica indirizzo di spedizione",
        SHIPPING_ADDRESSES_DEFAULT:" Indirizzo di default",
        NETSUITE_INBOUND_TOOLTIP: "L'inbound customer di NetSuite è attivo, pertanto la maggior parte delle proprietà di questo utente non è modificabile.",
        ERRORE_NOMINATIVO: "Ragione sociale oppure nome e cognome devono essere presenti",
        ERRORE_TELEFONO: "Formato non corretto (es. corretto: +39123456789)",
        USA_COME_SPEDIZIONE: "Usa anche come indirizzo di spedizione",
        COPIA_DA_FATTURAZIONE: "Copia da fatturazione",
        VAI_A_SCHEDA_CLIENTE: "Vai alla scheda cliente",
        RESTA_NELLA_PAGINA: "Resta nella pagina",
        TABS:{
            INFORMAZIONI_GENERALI: {
                TITLE: "Informazioni generali",
                ANAGRAFICA: "Anagrafica",
                CONTATTI: "Contatti",
                NOME: "Nome",
                COGNOME: "Cognome",
                RAGIONE_SOCIALE: "Ragione sociale",
                CODICE_CLIENTE: "Codice cliente",
                LINGUA: "Lingua",
                EMAIL: "Email",
                TELEFONO: "Telefono",
                CELLULARE: "Cellulare",
                PEC: "PEC",
            },
            FATTURAZIONE: {
                TITLE: "Fatturazione",
                CODICI: "Codici",
                INDIRIZZO: "Indirizzo",
                PARTITA_IVA: "Partita IVA",
                CODICE_FISCALE: "Codice fiscale",
                SDI: "SDI",
                NAZIONE: "Nazione",
                INDIRIZZO_1: "Indirizzo 1",
                INDIRIZZO_2: "Indirizzo 2",
                CITTA: "Città",
                PROVINCIA: "Provincia",
                SIGLA_PROVINCIA: "Sigla provincia",
                CODICE_POSTALE: "Codice postale",
            },
            SPEDIZIONE: {
                TITLE: "Spedizione",
                INDIRIZZI_DI_SPEDIZIONE: "Indirizzi di spedizione",
                NESSUN_INDIRIZZO_PRESENTE: "Al momento non sono definiti indirizzi di spedizione per questo cliente.",
                INFORMAZIONI_GENERALI: "Informazioni generali",
                INDIRIZZO: "Indirizzo",
                CONTATTI: "Contatti",
                AGGIUNGI_INDIRIZZO: "Aggiungi indirizzo",
                MODIFICA_INDIRIZZO: "Modifica indirizzo",
                ALIAS: "Alias",
                NOME: "Nome",
                COGNOME: "Cognome",
                RAGIONE_SOCIALE: "Ragione sociale",
                NAZIONE: "Nazione",
                INDIRIZZO_1: "Indirizzo 1",
                INDIRIZZO_2: "Indirizzo 2",
                CITTA: "Città",
                PROVINCIA: "Provincia",
                SIGLA_PROVINCIA: "Sigla provincia",
                CODICE_POSTALE: "Codice postale",
                EMAIL: "Email",
                TELEFONO: "Telefono",
                CELLULARE: "Cellulare"
            },
            CONDIZIONI_COMMERCIALI: {
                TITLE: "Condizioni commerciali",
                CONDIZIONE_COMMERCIALE_ATTIVA: "Condizione commerciale attiva",
                STORICO: "Storico delle condizioni commerciali associate",
                NESSUNA_CONDIZIONE_COMMERCIALE_ATTIVA: "Nessuna condizione commerciale attiva per questo customer.",
                NESSUNO_STORICO: "Nessun dato presente.",
                ULTIMA_MODIFICA: "Ultima modifica",
                STATO: "Stato",
                NUMERO_ECCEZIONI: "Numero eccezioni",
                PLACEHOLDER_CONDIZIONE_COMMERCIALE: (date: string, variant?: Variant, label?: string)=> <div className="d-flex align-items-center justify-content-start">
                    <span className="me-2">Data di associazione:</span>
                    <span className="fw-bold me-2">{date}</span>
                    <span className="me-2">Stato attuale dell'associazione:</span>
                    <span className={`fw-bold text-${variant}`}>{label}</span>
                </div>
            },
            ORDINI: {
                TITLE: "Ordini",
                CONFIGURAZIONE_CONTROLLO_ORDINI_PENDING: "Configurazione controllo ordini PENDING",
                TOLLERANZA: "Tolerance",
            },
            B2B: {
                TITLE: "B2B",
                GESTIONE_PREZZI: "Modello di gestione prezzi",
                GESTIONE_PREZZI_INFO: (variation:string)=><div>Nel caso in cui questa informazione non sia specificata verrà applicata la gestione prezzi di default per l'account <span className="fw-bold">({variation})</span></div>,
                SHOP_DI_DEFAULT: "Shop di default",
                SALVATAGGIO_SHOP_DESCRIPTION: "Il salvataggio degli shop di default va effettuato cliccando sull'apposito pulsante in questa sezione.",
            },
            BECOMMERCE: {
                TITLE: "BeCommerce",
                METODI_DI_PAGAMENTO_ABILITATI: "Metodi di pagamento abilitati",
                METODI_DI_SPEDIZIONE_ABILITATI: "Metodi di spedizione abilitati",
                BANK_TRANSFER: "Bonifico bancario",
                PAYPAL: "PayPal",
                CREDIT_CARD: "Carta di credito",
                CUSTOMER: "Corriere del cliente",
                DHL_EXPRESS: "DHL Express",
                VAI_A_BECOMMERCE: "Vai al BeCommerce",
                CONFIGURAZIONE: "Configurazione",
                INVIA_EMAIL_REGISTRAZIONE: "Invia email di invito alla registrazione",
                INVIA_EMAIL_REGISTRAZIONE_CONFERMA: (email: string) => <>Confermi l'invio della email di invito a <strong>{email}</strong>?</>,
            },
            ACCOUNT: {
                TITLE: "Account",
                DESCRIPTION: ()=><div>Le operazioni effettuate in questa sezione vengono applicate <span className="fw-bold">immediatamente</span>, senza bisogno di effettuare il salvataggio con l'apposito pulsante in alto a destra.</div>,
                MODIFICA_UTENTE: "Modifica nome utente",
                USERNAME: "Nome utente",
                RESET_PASSWORD: "Reimposta Password",
                STATO_CLIENTE: "Stato cliente",
                CLIENTE_ATTIVO: "Cliente attivo",
                CLIENTE_NON_ATTIVO: "Cliente non attivo",
                ATTIVA_CLIENTE: "Attiva",
                DISATTIVA_CLIENTE: "Disattiva",
                CONFERMA_USERNAME: (username: string)=><><div>Stai per modificare il nome utente di questo cliente in</div><div className="fw-bold my-2">{username}</div><div>Sei sicuro di voler procedere?</div></>,
                USERNAME_GIA_IN_USO: "Questo username è già in uso da un altro cliente.",
                CONFERMA_ATTIVAZIONE: "Sei sicuro di voler attivare questo cliente?",
                CONFERMA_DISATTIVAZIONE: "Sei sicuro di voler disattivare questo cliente?",
                RESET_PASSWORD_DESCRIPTION: "Cliccando sul pulsante a destra verrà inviata una email al cliente con le istruzioni per reimpostare la password di accesso.",
                INVIA_RICHIESTA: "Invia richiesta",
                CONFERMA_RESET: "Sei sicuro di voler reimpostare la password per questo cliente?",
            },
            REL: {
                TITLE: "Regole di esclusione",
                REGOLE_DI_ESCLUSIONE_DESC: "Regole di esclusione associate al customer",
                NESSUNA_REGOLA: "Non sono presenti regole di esclusione associate a questo cliente.",
                NOME_REGOLA: "Nome regola",
                SHOP_ESCLUSI: "Shop esclusi",
                CONDIZIONI: "Condizioni",
                VAI_ALLA_REGOLA: "Vai alla regola di esclusione",
                COPIA_ID: "Copia ID regola",
            }
        },
        STATUS:{
            ACTIVE:"Attivo",
            INACTIVE:"Inattivo",
        },
        TABLE:{
            USERNAME:" User Name",
            NOMINATIVO: "Nominativo",
            CODE :"Username / Codice Cliente",
            COUNTRY:"Nazione",
            STATUS:"Stato",
            EMAIL:"Email",
            EMAILPEC:"Email pec",
            PHONE:"Telefono",
            CELL:"Cellulare",
            ANAGRAFICA_CLIENTE:"Anagrafica Cliente",
            BILLING_ADDRESS:"Indirizzo Fatturazione",
            SHIPPING_ADDRESS: "Indirizzo Spedizione",
            CF:"Codice Fiscale",
            SDI:"Codice SDI",
            VAT:"Codice Vat",
            ADDRESS_LINE: "Indirizzo",
            CITY:"Città",
            VAI_A_DETTAGLIO: "Vai al dettaglio",
            PROVINCE:"Provincia",
            PROVINCE_CODE:"Codice provincia",
            POSTAL_CODE:"Codice postale",
            COUNTRY_CODE:"Nazione",
            SWITCH_DESC:"L'indirizzo di fatturazione coincide con quello di spedizione"
        },
        CONTACT_NAME:"Nome contatto",
        OPERATION_SUCCESS:"Cliente salvato correttamente",
        OPERATION_ERROR:"Errore durante il salvataggio del Cliente",
        ATLEAST_1_STATUS:"Almeno uno stato deve essere selezionato",
        RESET_PWD_SUCCESS:"Reset password avvenuto con successo",
        CHANGE_STATUS_SUCCESS:"Cambio stato del cliente avvenuto con successo",
        CONFIRM_DELETE_ADDRESS:"si vuole procedere con l'eliminazione dell'indirizzo selezionato?",
        ADD_CUSTOMER_ADDRESS:"Aggiungi indirizzo di spedizione",
        CUSTOMER_ADDRESS_LIST:"Lista indirizzi di spezione del cliente",
        TEST_REL: {
            TITLE: "Test regole di esclusione",
            SELEZIONA_UN_ARTICOLO_PER_VISUALIZZARE_LA_VISIBILITA: "Seleziona un articolo per visualizzare la sua visibilità in questo shop in base alle regole di esclusione definite.",
            ARTICOLO_VISIBILE: "L'articolo è visibile in questo shop.",
            ARTICOLO_NON_VISIBILE: "L'articolo non è visibile in questo shop a causa delle seguenti regole di esclusione:",
            NESSUNO_SHOP_SELEZIONATO: "Nessuno shop selezionato per questa applicazione.",
        }
    },
    PAGE_WHS_MOVEMENTS: {
        FILTRO_AVANZATO: "Filtro avanzato",
        NEW_MOVEMENTS: "Nuovo movimento",
        SCARICA_TEMPLATE_MOVIMENTI:"Scarica Template",
        CARICA_MOVIMENTI:"Carica movimenti",
        CREATION_PROGRESS:"Creazione movimento in corso",
        CREATION_SUCCESS:"Creazione movimento in corso",
        CREATION_ERROR:"Errore durante la creazione del movimento", 
        TABLE: {
            DATE: "Data",
            ORDER: "Ordine",
            BRAND: "Brand",
            QUANTITY: "Quantità",
            TYPE: "Tipo",
            WAREHOUSE: " Magazzino",
            TAGS: "Tags",
            COPIA_ID: "Copia ID",
            COPIA_ID_ORDER: "Copia ID dell'ordine",
            COPIA_SKU: "Copia SKU",
            TYPE_ABSOLUTE:"Assoluto",
            TYPE_DIFFERENTIAL:"Differenziale",
            SKU:"SKU"
        },
        ADD_WHR_MOVEMENTS:{
            TITLE: "Nuovo movimento di magazzino",
            SKU: "SKU",
            SKU_PLACEHOLDER: "Inserisci uno SKU",
            WAREHOUSE:"Magazzino",
            WAREHOUSE_PLACEHOLDER: "Seleziona Magazzino",
            TYPE_PLACEHOLDER: "Seleziona Tipologia",
            COLLEGA_MOVIMENTO_ORDINE: "Collega il movimento a un ordine",
            COLLEGA_MOVIMENTO_ORDINE_TEXT: ()=><>È possibile collegare il movimento a un ordine. In tal caso il movimento sarà di tipo <strong>differenziale</strong> e la quantità selezionabile sarà vincolata a quella presente nei movimenti di magazzino per l'ordine.</>,
            DESCRIZIONI_QUANTITA: {
                CAMPI_OBBLIGATORI_NO_ORDINE: "Prima di impostare una quantità occorre selezionare SKU, magazzino e tipo di movimento.",
                CAMPI_OBBLIGATORI_ORDINE: "Prima di impostare una quantità occorre selezionare SKU, magazzino e ordine. Quando si collega un ordine, il tipo di movimento è sempre differenziale.",
                ASSOLUTO_NO_ORDINE: "Per un movimento di tipo assoluto la quantità minima impostabile è 0.",
                DIFFERENZIALE_NO_ORDINE: "Se il movimento è di tipo differenziale puoi scaricare al massimo la quantità a disposizione nel magazzino selezionato per l’articolo selezionato, e non è possibile impostare la quantità a 0.",
                ORDINE_GIA_SODDISFATTO: "Per l’ordine selezionato non è possibile creare nuovi movimenti, in quanto già interamente soddisfatto.",
                ORDINE_NON_SODDISFATTO: (count:number)=>`Per l’ordine selezionato e per l’articolo indicato è necessario creare movimenti di magazzino per un totale di ${count===1?"un pezzo": `${count} pezzi`}. Se il magazzino selezionato non ha giacenza sufficiente, puoi creare successivamente altri movimenti usando magazzini differenti.`,
            }
        },
        DOWNLOAD_TEMPLATE_TITLE: "Istruzioni",
        DOWNLOAD_TEMPLATE_INFO: ()=><>
            <p>Cliccando sul pulsante in basso scaricherai il template del CSV per il caricamento massivo di movimenti di magazzino.</p>
            <p>Il file è composto dalle seguenti colonne:</p>
            <ul>
                <li><strong>$op:</strong> operazione da eseguire. <strong>Obbligatorio con valore INS.</strong></li>
                <li><strong>$rt:</strong> tipo di record. <strong>Obbligatorio con valore WHS-MOVEMENT.</strong></li>
                <li><strong>sku / item_id:</strong> SKU o item id dell'articolo. Va scelta una delle due intestazioni e compilata con i valori corrispondenti.<strong>Obbligatorio.</strong></li>
                <li><strong>whs_code / whs_id:</strong> codice o id del magazzino. Va scelta una delle due intestazioni e compilata con i valori corrispondenti.<strong>Obbligatorio.</strong></li>
                <li><strong>qty:</strong> quantità movimentata. Può essere negativa o positiva. <strong>Obbligatorio.</strong> Se il valore per <strong>absolute</strong> è <strong>true</strong>, allora il valore dev'essere positivo.</li>
                <li><strong>absolute:</strong> identifica se il movimento è assoluto (<strong>true</strong>) o relativo (<strong>false</strong>). <i>opzionale, default <strong>false</strong>.</i></li>
                <li><strong>tags:</strong> elenco di valori separati da virgola. Usati per assegnare delle etichette aggiuntive al movimento. <i>Opzionale.</i></li>
            </ul>
        </>,
        UPLOAD_MODAL:{
            TITLE:"Carica nuovi movimenti di magazzino",
            UPLOAD_SUCCESS:"Caricamento avvenuto con successo"
        }
    },
    PAGE_SHIPMENTS :{
        ORDINI: "Ordini",
        NESSUN_ORDINE_PRESENTE: "Nessun ordine presente",
        SHIPMENT :"Spedizione",
        NUOVA_SPEDIZIONE: "Nuova Spedizione",
        FILTRO_AVANZATO: "Filtro avanzato",
        VAI_A_DETTAGLIO: "Vai al dettaglio",
        APRI_ANTEPRIMA: "Apri anteprima",
        COPIA_ID: "Copia ID",
        CONSULTA_INVIO_A_SHOP: "Consulta l'invio allo Shop",
        NESSUN_INVIO_TROVATO: "Nessun invio allo shop trovato.",
        FILTERS: {
            ORDER_TYPE: "Tipologia di ordine",
            ORFRT: "N° ordine"
        },
        TABLE: {
            ORDER: "Ordine",
            CARRIER: "Vettore",
            STATUS: "Stato",
            TRACKING_NUMBER: "N° Tracking",
            SHIPPING_DATE: "Data spedizione",
            DELIVERY_METHOD: "Metodo di consegna",
            DELIVERY_DATE: "Data consegna",
            VAI_A_DETTAGLIO: "Vai al dettaglio",
            COPIA_ID: "Copia ID",
            ORDER_POPUP_TITLE: "ID Ordini",
            TRACKING_URL: "Tracking URL", 
        },
        PREVIEW: {
            RECIPIENT_INFO: "Informazioni destinatario",
            NAME : "Nome",
            SURNAME : "Cognome",
            SHIPMENT_INFO: "Informazioni spedizione",
            COMPANY: "Società",
            BUYER: "Acquirente",
            ADDRESS: "Indirizzo",
        },
        SPEDIZIONE_NON_TROVATA: "Spedizione non trovata",
    },
    PAGE_CATALOG: {
        NUOVO_ARTICOLO: "Nuovo articolo",
        SINCRONIZZA_PARENT_ITEM: "Sincronizza parent item",
        SINCRONIZZA_PARENT_ITEM_CONFIRM: "Sei sicuro di voler avviare la sincronizzazione dei parent item?",
        ESTRAI_CATALOGO: "Estrai catalogo",
        ESTRAI_CATALOGO_CONFIRM: "Sei sicuro di voler avviare l'estrazione del catalogo?",
        ESTRAI_CATALOGO_SUCCESS: (navigateFunction: Function, isDesktop: boolean)=><>Estrazione avviata correttamente. {isDesktop && <>Puoi seguire la sua esecuzione nell'<span className="cs-link text-decoration-underline" onClick={()=>navigateFunction()}>area report</span>.</>}</>,
        ESTRAI_CATALOGO_ALREADY_RUNNING: (navigateFunction: Function, isDesktop: boolean)=><>Estrazione già in corso. {isDesktop && <>Puoi seguire la sua esecuzione nell'<span className="cs-link text-decoration-underline" onClick={()=>navigateFunction()}>area report</span>.</>}</>,
        FILTRO_AVANZATO: "Filtro avanzato",
        INSERIRE_TRE_CARATTERI_PER_CERCARE: "Inserire almeno tre caratteri per cercare",
        SKU: "SKU",
        BARCODE: "Barcode",
        TITOLO: "Titolo",
        BRAND: "Brand",
        CATEGORIA: "Categoria",
        DISPONIBILITA: "Disponibilità",
        FILTERS: {
            BRAND: "Brand",
            CATEGORIE: "Categorie",
            STAGIONI: "Stagioni",
            CANALE_DI_VENDITA: "Canale di vendita",
            QUANTITY: "Quantità",
            SELEZIONA_LE_CATEGORIE: "Seleziona le categorie...",
            CATEGORIE_SELEZIONATE: "Categorie selezionate"
        },
        SKU_GIA_ESISTENTE: "SKU già presente a catalogo",
        EREDITA_PROPRIETA: "Eredita proprietà",
        VAI_A_ARTICOLO: "Vai all'articolo",
        COPIA_SKU: "Copia SKU",
        COPIA_BARCODE: "Copia barcode",
        COPIA_SKU_PARENT: "Copia SKU parent",
        COPIA_MNF_CODE: "Copia MNF code",
    },
    PAGE_EXPORT: {
        TIPO_EXPORT: "Tipo di export",
        UTENTE: "Utente",
        EXPORTERS: {
            CONDIZIONI_ECONOMICHE_SHOP: {
                TITLE: "Condizioni economiche shop",
                SELEZIONA_SHOP: "Seleziona shop",
                INCLUDI_IMMAGINI: "Includi immagini",
                RIMUOVI_IMMAGINI_SOPRA_SOGLIA: "Rimuovi immagini sopra questa soglia (campo vuoto = mantieni default)",
                IMMAGINI_RIDOTTE: "Immagini ridotte",
                IMMAGINI_RIDOTTE_DESC: "Per motivi di performance in questo export alcune immagini sono state rimosse."
            },
            CATALOGO: {
                TITLE: "Catalogo",
                RAGGRUPPA_PER_SKU_PARENT: "Raggruppa per SKU Parent",
                RAGGRUPPA_PER_SKU_PARENT_HELP: ()=><><div className="mb-1">E' possibile raggruppare gli articoli per SKU Parent:</div><ul><li>Se il raggruppamento è attivo, l'export contiene una riga per SKU Parent;</li><li>Se il raggruppamento NON è attivo, l'export contiene una riga per SKU.</li></ul></>,
                CAMPI_AGGIUNTIVI: "Campi aggiuntivi",
                INCLUDI_INFORMAZIONI_CATEGORIE: "Includi le informazioni sulle categorie",
                INCLUDI_IMMAGINI: "Includi immagini",
                INCLUDI_INFORMAZIONI_SHOP_ATTIVI: "Includi le informazioni sugli shop attivi",
            }
        },
        NUOVO_EXPORT: "Nuovo export",
    },
    PAGE_ITEM: {
        DETTAGLIO_ARTICOLO: (sku_parent:string)=>`Dettaglio articolo ${sku_parent}`,
        ARTICOLO_NON_TROVATO: (sku_parent:string, createFunction?: Function)=><>
            <div className="fs-5 text-center">Non è stato trovato nessun articolo con codice <span className="fw-bold">{sku_parent}</span>.</div>
            {createFunction && <div className="fs-6 mt-2 text-center">Vuoi crearne uno? <span className="cs-link" onClick={()=>createFunction()}>Clicca qui!</span></div>}
        </>,
        NUOVO_ARTICOLO: "Aggiungi un articolo di questo prodotto",
        ARTICOLO_CORRENTE: "Articolo corrente",
        RIPARA_ERRORE: "Ripara errore",
        RIPARA_PROPRIETA: (label:string)=><div className="d-flex align-items-center justify-content-start"><span className="me-2">Ripara proprietà</span><span className="fw-bold">{label}</span></div>,
        SCEGLI_VALORE_VARIAZIONE: (label: string)=><span>Scegli uno dei seguenti valori tra quelli già presenti e usalo per le variazioni che sono privi della proprietà <span className="fw-bold">{label}</span>:</span>,
        VARIAZIONI_AGGIORNATE_SUCCESSO: (count: number)=>(count>1)?<span>Sono state aggiornate con successo <span className="fw-bold">{count}</span> variazioni di questo articolo.</span>:<span>È stata aggiornata con successo <span className="fw-bold">una</span> variazione di questo articolo.</span>,
        ERRORI_AGGIORNAMENTO: "Si sono verificati i seguenti errori",
        GESTISCI_TRADUZIONI: "Gestisci traduzioni",
        TRADUCI_DA: (source:string) => <span>Traduci automaticamente da: <span className="fw-bold">{source}</span></span>,
        TRADUZIONE_NON_DISPONIBILE: "Traduzione non disponibile",
        SCELTA_TRADUZIONE_DESC: "Seleziona la lingua di default con cui visualizzare le proprietà in lingua dell'articolo.",
        AGGIUNGI_TRADUZIONE: "Aggiungi traduzione",
        TABS: {
            PANORAMICA: {
                TITLE: "Panoramica",
                DATA_ULTIMA_MODIFICA: "Data ultima modifica",
                CI_SONO_VARIAZIONI: (qty: number, onClick: Function)=>(qty===1)?<div>C'è <span className="fw-bold cs-link" onClick={()=>onClick()}>una variazione</span> di questo articolo.</div>:<div>Ci sono <span className="fw-bold cs-link" onClick={()=>onClick()}>{qty} variazioni</span> di questo articolo.</div>,
            },
            DATI: {
                TITLE: "Dati",
                GENERALI: "Generali",
                PERSONALIZZATI: "Personalizzati",
            },
            IMMAGINI: {
                TITLE: "Immagini",
                COLLOCAMENTO: "Collocamento",
                POSIZIONE: "Posizione",
                SHOP_ESCLUSI: "Shop esclusi",
                NESSUNO_SHOP_ESCLUSO: "Nessuno shop escluso",
                URL_MANCANTE: "L'URL dell'immagine non è disponibile.",
                PRESENZA_IMMAGINE_VARIAZIONI_KO: (needed:number, actual: number)=><span>Questa immagine è presente in <span className="fw-bold">{actual}</span> di <span className="fw-bold">{needed}</span> variazioni.</span>,
                SELEZIONA_IMMAGINE_PER_DETTAGLI: "Seleziona una immagine a sinistra per visualizzarne i dettagli.",
                PERCORSO_IMMAGINE: "Percorso immagine",
                TUTTE_LE_VARIAZIONI: "Agisci su tutte le variazioni dell'articolo",
                VARIAZIONE: (sku: string)=>`Agisci sulla variazione ${sku}`,
                AGGIUNGI_IMMAGINE: "Aggiungi una immagine",
                ERRORE_VALORE_POS: "La posizione deve essere 1 o superiore.",
                ERRORE_POS_DUPLICATA: "In una delle variazioni selezionate esiste già una immagine con questa posizione.",
                CONFERMA_ELIMINAZIONE: "Confermi l'eliminazione dell'immagine selezionata?",
            },
            AB: {
                TITLE: "Availability Buckets",
                AGGIUNGI_AB: "Aggiungi un Availability bucket",
                QUANTITA: "Quantità",
                PREZZI: "Prezzi",
                GENERALE: "Generale",
                SHOP_SPENTO: "Questo shop è spento",
                PREZZO: "Prezzo",
            },
            VARIAZIONI: {
                TITLE: "Variazioni",
                SELEZIONA_VARIAZIONE: "Seleziona una variazione",
                AGGIUNGI_VARIAZIONI: "Aggiungi variazioni",
                SELEZIONA_ATTRIBUTO_VARIAZIONE: "Seleziona l'attributo di variazione",
                SELEZIONA_ATTRIBUTO_VARIAZIONE_DESC: "Seleziona un attributo di variazione per poter aggiungere nuove variazioni di questo articolo.",
                COLORE: "Colore",
                TAGLIA: "Taglia",
                COLORE_IN_LINGUA_DESC: (lang:string)=><>La lingua che verrà usata per il colore è <span className="fw-bold ms-2">{lang}</span>.</>,
                ERRORE_SKU_GIA_PRESENTE: "SKU già presente in variazioni già esistenti",
                ERRORE_SKU_GIA_PRESENTE_NUOVE_VARIAZIONI: "SKU duplicato nelle nuove variazioni da inserire",
                ERRORE_SIZE_GIA_PRESENTE: "Taglia già presente in variazioni già esistenti",
                ERRORE_SIZE_GIA_PRESENTE_NUOVE_VARIAZIONI: "Taglia duplicata nelle nuove variazioni da inserire",
                ERRORE_COLORE_GIA_PRESENTE: "Colore già presente in variazioni già esistenti",
                ERRORE_COLORE_GIA_PRESENTE_NUOVE_VARIAZIONI: "Colore duplicato nelle nuove variazioni da inserire",
            },
            ARTICOLI_COLLEGATI: {
                TITLE: "Articoli collegati",
                AGGIUNGI_COLLEGAMENTO: "Aggiungi il collegamento a un articolo",
                AGGIUNGI_COLLEGAMENTO_INFO: "In questa sezione puoi collegare la variazione selezionata a uno o più articoli diversi.",
                TIPO_COLLEGAMENTO: "Tipo di collegamento",
                GIFT: "Omaggio",
                RELATED: "Relazionato",
                QUANTITA: "Quantità",
                SHOP_ESCLUSI: "Shop esclusi",
                ARTICOLO_NON_TROVATO: "Variazione non trovata",
                ERRORE_ARTICOLO_UGUALE: "Non è possibile collegare una variazione di un articolo a sé stessa",
                ERRORE_ARTICOLO_GIA_COLLEGATO: "La variazione dell'articolo scelta è già collegata",
                VARIAZIONE: "Variazione",
                SCOLLEGA: "Scollega articolo",
                VAI_A_ARTICOLO: "Vai all'articolo",
                CONFERMA_SCOLLEGAMENTO: "Confermi l'eliminazione del collegamento con la variazione selezionata?",
            },
            MAGAZZINI: {
                TITLE: "Magazzini",
                MAGAZZINO: "Magazzino",
                DISPONIBILITA: "Disponibilità",
                QUANTITA_RISERVATE: "Quantità riservate",
            },
            DISPONIBILITA_PER_SHOP: {
                TITLE: "Disponibilità per shop",
                SHOP: "Shop",
                DISPONIBILITA: "Disponibilità",
                PREZZO: "Prezzo",
            },
            MOVIMENTI_MAGAZZINO: {
                TITLE: "Movimenti di magazzino",
                TABLE: {
                    DATE: "Data",
                    QUANTITA: "Quantità",
                    TIPO: "Tipo",
                    MAGAZZINO: "Magazzino",
                    TAGS: "Tags",
                },
                ASSOLUTO: "Assoluto",
                DIFFERENZIALE: "Differenziale",
            },
            AGGIORNAMENTI_DISPONIBILITA: {
                TITLE: "Aggiornamenti disponibilità",
            },
            LISTINI: {
                TITLE: "Listini",
                NOME_LISTINO: "Nome listino",
                VARIAZIONI: "Variazioni",
                TUTTE_LE_VARIAZIONI: "Tutte le variazioni",
                PREZZO: "Prezzo",
            },
            CONDIZIONI_COMMERCIALI: {
                TITLE: "Condizioni commerciali",
                NOME_CONDIZIONE_COMMERCIALE: "Nome condizione commerciale",
                VARIAZIONI: "Variazioni",
                TUTTE_LE_VARIAZIONI: "Tutte le variazioni",
                PREZZO: "Prezzo",
            },
            GPSR: {
                TITLE: "GPSR",
                TITLE_EXTENDED: "General Product Safety Regulation",
            },
            CODICI_SHOP: {
                TITLE: "Codici shop",
                TIPO_SHOP: "Tipo shop",
                NOME_SHOP: "Nome shop",
                CODICE_SHOP: "Codice shop",
                CODICE_ARTICOLO_SHOP: "Codice articolo nello shop"
            },
            IDENTIFICATIVI_ESTERNI: {
                TITLE: "Identificativi esterni",
                IDENTIFICATIVO: "Identificativo",
                VALORE: "Valore",
                LABELS: {
                    EXTERNAL_ID: "Codice esterno",
                    NS_INTERNAL_ID: "Identificativo NetSuite",
                    SHOP_INTERNAL_ID: "Identificativo Shop"
                }
            },
            VISIBILITA_NEGLI_SHOP: {
                TITLE: "Visibilità negli shop",
                SHOP: "Shop",
                VISIBILITA: "Visibilità",
                VISUALIZZA_STORICO: "Visualizza storico",
                VISIBILITA_PER_CUSTOMER_B2B: "Visibilità per customer nel B2B",
                VISIBILITA_PER_CUSTOMER_BECOMMERCE: "Visibilità per customer nel BeCommerce",
                VISIBILE: "Visibile",
                NON_VISIBILE: "Non visibile",
                VISIBILITA_PER_CUSTOMER: (shopName: string)=><span>Visibilità per customer nello shop <span className="fw-bold">{shopName}</span></span>,
                ARTICOLO_VISIBILE_PER_LO_SHOP_SELEZIONATO: ()=><span>Articolo <span className="fw-bold text-success">visibile</span> nello shop selezionato.</span>,
                ARTICOLO_NON_VISIBILE_PER_LO_SHOP_SELEZIONATO: ()=><span>Articolo <span className="fw-bold text-danger">non visibile</span> nello shop selezionato, a causa delle seguenti regole:</span>,
            }
        },
        ANALYSIS: {
            NESSUN_PROBLEMA_RILEVATO: "Nessun problema rilevato.",
            ERRORS: {
                GENERIC: (entry: PropertyAnalysis)=><div><span className="fw-bold">{entry.field}:</span> presenta un errore.</div>,
                TOTALLY_MISSING: (entry:PropertyAnalysis)=><div><span className="fw-bold">{entry.field}:</span> mancante in tutte le variazioni dell'articolo.</div>,
                PARTIALLY_MISSING: (entry:PropertyAnalysis)=><div><span className="fw-bold">{entry.field}:</span> mancante in alcune delle variazioni dell'articolo.</div>,
                PROPERTY_DIFFERENT: (entry:PropertyAnalysis)=><div><span className="fw-bold">{entry.field}:</span> in alcune variazioni dell'articolo ha valori diversi da quello principale: <span className="fw-bold">{((entry.additional_info?.less_frequent_values ?? []) as string[]).join(', ')}</span>.</div>,
                PROPERTY_NOT_DISTINCT: (entry:PropertyAnalysis)=><div><span className="fw-bold">{entry.field}:</span> alcune variazioni dell'articolo hanno i seguenti valori in comune: <span className="fw-bold">{((entry.additional_info?.more_frequent_values ?? []) as string[]).join(', ')}</span>.</div>,
                ABS_DIFFERENT: (entry:PropertyAnalysis)=><div><span className="fw-bold">Availability Buckets:</span> differenti tra le variazioni dell'articolo.</div>,
                ABS_PRICE_DIFFERENT: (_:PropertyAnalysis)=><div><span className="fw-bold">Availability Buckets:</span> prezzi differenti tra buckets e shop diversi.</div>,
            },
            DETAILS: {
                VALORE_CAMPO: (field: string) => `Valore del campo ${field}`,
                NUMERO_IMMAGINI: "Numero immagini",
                BULLET_POINTS: "Bullet points",
                LOCALIZZATI: "Localizzati",
                NON_LOCALIZZATI: "Non localizzati",
                STATO: "Stato",
                ERRORS: {
                    GENERIC: "Presenta un errore.",
                    TOTALLY_MISSING: "Valore mancante.",
                    PARTIALLY_MISSING: "Valore mancante.",
                    PROPERTY_DIFFERENT: "Valore diverso da quello principale.",
                    PROPERTY_NOT_DISTINCT: "Valore duplicato.",
                    IMAGES_MISSING: "Immagini mancanti.",
                    BULLET_POINTS_MISSING: "Bullet points mancanti.",
                    ABS_DIFFERENT: "Availability buckets differenti dalla maggioranza delle variazioni.",
                    ABS_PRICE_DIFFERENT: "Prezzi differenti tra buckets e shop diversi.",
                }
            }
        },
        FIELD_NAMES: {
            SKU: "SKU",
            SKU_PARENT: "SKU Parent",
            MNF_CODE: "MNF Code",
            SEASON: "Stagione",
            SIZE: "Taglia",
            BRAND: "Marca",
            TITLE: "Titolo",
            DESC: "Descrizione",
            MNF_EMAIL_ADDRESS: "Indirizzo email",
            MNF_NAME: "Nome",
            MNF_POSTAL_ADDRESS: "Indirizzo postale",
            MNF_TRADEMARK: "Trademark",
            MNF_PRODUCT_DOCUMENT: "Documento prodotto",
            BARCODES: "Barcodes",
            BARCODE: "Barcode",
            EAN: "EAN",
            UPC: "UPC",
            BULLET_POINTS: "Altre descrizioni",
            CATEGORIE: "Categorie",
            NESSUNA_CATEGORIA_PRIMARIA_SELEZIONATA: "Nessuna categoria primaria selezionata.",
            NESSUNA_CATEGORIA_SECONDARIA_SELEZIONATA: "Nessuna categoria secondaria selezionata.",
            COMPOSITION: "Composizione",
        },
        SWITCHER: {
            CAMBIA_TIPO_CAMPO: "Cambia il tipo del campo",
            TESTO_SEMPLICE: "Testo semplice",
            TRADUZIONI_SINGOLE: "Traduzioni singole",
        },
        COMPOSITION: {
            PERCENTUALE: "Percentuale",
            MATERIALE: "Materiale",
            PARTE: "Parte",
        },
        BULLET_POINTS: {
            TITLE: "Bullet points",
            APPLICA_LOCALIZZAZIONE: "Applica localizzazione",
            ANNULLA_LOCALIZZAZIONE: "Annulla localizzazione",
            CONFERMA_LOCALIZZAZIONE: "Conferma localizzazione",
        }
    },
    PAGE_BINDINGS: {
        SELEZIONARE_UNO_SHOP: "Seleziona uno shop per iniziare",
        ATTRIBUTI_COMPLETAMENTE_ASSOCIATI: "Attributi completamente associati",
        ATTRIBUTI_ASSOCIATI: "Attributi associati",
        SELEZIONARE_UN_ATTRIBUTO: "Selezionare un attributo dall'elenco",
        NUOVO_ATTRIBUTO: "Aggiungi un nuovo attributo",
        NUOVA_REGOLA: "Aggiungi una nuova regola",
        REGOLE_PER_ATTRIBUTO: "Regole per l'attributo",
        FILTRA_ASSOCIAZIONI_ATTIVE: "Visualizza le associazioni già attive",
        INDOVINA_ASSOCIAZIONI: "Autocompila le associazioni cercando di dedurre i valori dello shop da selezionare in base ai valori CloudStore",
        RIPRISTINA_ASSOCIAZIONI: "Annulla tutte le modifiche correnti e riporta le associazioni allo stato iniziale",
        AGGIUNGI_ASSOCIAZIONE: "Aggiungi una associazione inserendo un valore CloudStore non presente",
        SE_SI_VERIFICANO_CONDIZIONI: "Se si verificano le seguenti condizioni",
        LE_ASSOCIAZIONI_SONO_LE_SEGUENTI: "Le associazioni sono le seguenti",
        REGOLA_DEFAULT_NESSUNA_CONDIZIONE: "Questa è la regola di default. Non si possono aggiungere condizioni, le associazioni saranno sempre attive se le altre regole non hanno validità.",
        NESSUNA_CONDIZIONE: "Nessuna condizione definita. Le associazioni sono sempre valide.",
        BINDINGS_TABLE: {
            VALORE_CS: "Valore CloudStore",
            VALORE_SHOP: "Valore Shop"
        },
        CONFERMA_GUESS_BINDINGS: "Il sistema proverà a compilare automaticamente i valori degli shop non ancora associati a partire dai corrispondenti valori CloudStore. Vuoi proseguire?",
        CONFERMA_RIPRISTINO_BINDINGS: "Se prosegui, tutte le modifiche non salvate alle associazioni andranno perdute.",
        TUTTI_GLI_SHOP_FARFETCH: "Tutti gli shop Farfetch",
        ATTRIBUTO: "Attributo",
        NUMERO_VALORI_ASSOCIATI: "Numero valori associati",
        VALORI_ASSOCIATI: (count:number)=>(count===1)?<>1 valore associato</>:<>{count} valori associati</>,
        NUOVA_ASSOCIAZIONE_DA_SALVARE: "Questa è una nuova associazione da salvare",
        ASSOCIAZIONE_MODIFICATA_DA_SALVARE: "Questa associazione è stata modificata ed è da salvare",
        SALVA_TUTTE: "Salva tutte",
        HELP_ASSOCIAZIONE_ROOT: (shopName: string)=><>Le associazioni definite qui sotto saranno applicate di default in <span className="fw-bold">{shopName}</span>. Se vuoi aggiungere una dipendenza da un altro attributo, clicca sull'icona <i className="bi-plus-circle text-white mx-2" /> in corrispondenza dell'attributo da cui dovranno dipendere le associazioni.</>,
        MODIFICA_ASSOCIAZIONI: "Modifica associazioni",
        MODIFICA_VALORI: "Modifica valori",
        GESTISCI_ASSOCIAZIONI: "Gestisci associazioni",
        GESTISCI_ASSOCIAZIONI_DERIVATE: "Gestisci associazioni derivate",
        NESSUN_VALORE_CLOUDSTORE_TROVATO: "Nessun valore CloudStore trovato.",
        CONFERMA_ELIMINAZIONE: "Sei sicuro di voler eliminare questa associazione?",
        CONFERMA_ELIMINAZIONE_CON_FIGLI: "Sei sicuro di voler eliminare questa associazione con tutte le sue associazioni derivate?",
        SALVA_TUTTE_LE_ASSOCIAZIONI: "Salva tutte le associazioni modificate",
        CONFERMA_SALVATAGGIO_MASSIVO: "Confermi il salvataggio di tutte le associazioni modificate?",
        MOSTRA_TUTTI: "Mostra tutti",
        MOSTRA_ASSOCIATI: "Solo associati",
        MOSTRA_NON_ASSOCIATI: "Solo da associare",
        MOSTRA_INDOVINATI: "Mostra indovinati",
        MOSTRA_NON_INDOVINATI: "Mostra non indovinati",
        DUPLICA_ASSOCIAZIONI: "Duplica associazioni",
        DUPLICA_ASSOCIAZIONI_DISABILITATO: "Per duplicare le associazioni è necessario che non ci siano modifiche in corso.",
        DUPLICA_ASSOCIAZIONI_HELP: (attribute: string) =><>Questa funzionalità ti permette di scegliere su quali altre categorie già definite duplicare le associazioni per l'attributo <span className="fw-bold">{attribute}</span>. <br /> Se per la categoria selezionata un'associazione è già presente verrà mantenuta, altrimenti verrà aggiunta. <br />Se non è possibile aggiungerla verranno segnalati opportuni warning alla fine dell'operazione.</>,
        CATEGORIE_DA_DUPLICARE: "Categorie da duplicare",
        RISULTATI_DUPLICAZIONE: "Risultati duplicazione",
        CREATI: "Creati",
        IGNORATI: "Ignorati",
        NON_TROVATI: "Non trovati",
        ERRORE_SCONOSCIUTO: "Errore sconosciuto",
    },
    PAGE_ORDERS: {
        TABLE: {
            CODICE_ORDINE: "Codice ordine",
            CLIENTE: "Cliente",
            STATO: "Stato",
            DATA: "Data",
            NUMERO_ARTICOLI: "# Articoli",
            CONTROVALORE: "Controvalore",
            DOCUMENTI: "Documenti",
            RIMBORSATO: "Rimborsato",
        },
        STATO_RIMBORSO: "Stato rimborso",
        REFUNDED: "Solo rimborsati",
        NOT_REFUNDED: "Escludi rimborsati",
        SELEZIONA_SPEDIZIONE: "Seleziona spedizione",
        CARRIER: "Corriere",
        SCARICA_ORDINI: "Scarica ordini",
        ORDINE: "Ordine",
        STATO_ORDINE: "Stato ordine",
        DATA: "Data",
        CONTROVALORE: "Controvalore",
        NUMERO_ARTICOLI: "Numero articoli",
        APRI_ANTEPRIMA: "Apri anteprima",
        VAI_A_DETTAGLIO: "Vai al dettaglio",
        COPIA_ID: "Copia ID",
        COPIA_CODICE_ORDINE: "Copia codice ordine",
        INFORMAZIONI_ACQUIRENTE: "Informazioni acquirente",
        SPEDIZIONE: "Spedizione",
        FATTURAZIONE: "Fatturazione",
        ORDINI_TROVATI: "__COUNT__ ordini trovati",
        STATUS_CHANGE: "Cambia stato dell'ordine",
        NESSUN_DOCUMENTO_PRESENTE: "Nessun documento presente",
        NESSUN_CUSTOMER_PRESENTE: "Nessun cliente",
        NESSUNA_SPEDIZIONE_PRESENTE: "Nessuna spedizione presente",
    },
    PAGE_AVAILABILITY_ADJUSTMENTS:{
        FILTERS: {
            MANDATORY_FILTERS: "È necessario selezionare uno shop e un articolo per effettuare una ricerca.",
        },
        TABLE:{
            DATE : "Data",
            SHOP : "Shop",
            SENT_QUANTITY: "Quantità inviata",
            REASON: "Causa",
            STATE:"Stato",
            MESSAGE: "Messaggio",
            COMPLETED :"Completo",
            INCOMPLETED: "Incompleto",
            LISTING: "Listing",
            MOVEMENT: "Movimento",
            ORDER: "Ordine"
        },
        VAI_A_ARTICOLO: "Vai all'articolo",
        VAI_A_LISTING: "Vai al listing",
        VAI_A_ORDINE: "Vai all'ordine",
        VISUALIZZA_MOVIMENTO_MAGAZZINO: "Visualizza movimento di magazzino"
    },
    PAGE_ORDER: {
        ORDINE: "Ordine",
        DETTAGLIO_ORDINE: "Dettaglio ordine",
        ULTIMO_AGGIORNAMENTO: "Ultimo aggiornamento",
        NESSUN_PROBLEMA_RISCONTRATO: "Non sono stati riscontrati problemi sull'ordine.",
        PROBLEMI_RISCONTRATI: "Sono stati riscontrati problemi sull'ordine.",
        IN_CARICAMENTO: "in caricamento...",
        NON_TROVATO: "non trovato",
        IN_ERRORE: "in errore",
        ORDINE_NON_TROVATO: "L'ordine richiesto non è stato trovato.",
        ORDINE_IN_ERRORE: "Si è verificato un errore durante il caricamento dell'ordine, si prega di riprovare.",
        MENU: {
            SCARICA_EXCEL: "Scarica Excel",
            CONSULTA_NETSUITE: "Consulta l'invio a NetSuite",
            INVIA_NETSUITE: "Invia l'ordine a NetSuite",
            CONSULTA_ERP: "Consulta l'invio all'ERP",
            INVIA_ERP: "Invia l'ordine all'ERP",
            CONFERMA_INVIO_ORDINE_ERP: "Confermi l'invio dell'ordine all'ERP?",
            CONFERMA_INVIO_ORDINE_NETSUITE: "Confermi l'invio dell'ordine a NetSuite?",
            VAI_A_ELEMENTO_DELLA_CODA: "Vai all'elemento della coda",
        },
        PANORAMICA: "Panoramica",
        ARTICOLI: "Articoli",
        INFORMAZIONI: "Informazioni",
        DOCUMENTI: "Documenti",
        NETSUITE: "NetSuite",
        METADATA: "Metadata",
        DATA: "Data",
        SKU: "SKU",
        ARTICOLO: "Articolo",
        BRAND: "Brand",
        QUANTITA: "Quantità",
        MODIFICA_QUANTITA: "Modifica quantità",
        PREZZO_UNITARIO: "Prezzo unitario",
        PREZZO_TOTALE: "Prezzo totale",
        DAZI: "Dazi",
        SUBTOTALE: "Subtotale",
        TOTALE_ORDINE: "Totale ordine",
        SPESE_DI_SPEDIZIONE: "Spese di spedizione",
        SCONTO: "Sconto",
        MARKUP: "Markup",
        TIPO: "Tipo",
        MAGAZZINO: "Magazzino",
        TAGS: "Tags",
        ASSOLUTO: "Assoluto",
        DIFFERENZIALE: "Differenziale",
        MOVIMENTI_MAGAZZINO: "Movimenti di magazzino",
        COPIA_ID_MAGAZZINO: "Copia l'ID del magazzino",
        COPIA_SKU: "Copia lo SKU",
        ID_MAGAZZINO_COPIATO: "ID del magazzino __WH__ copiato!",
        UTENTE: "Utente",
        MODULO: "Modulo",
        SHOP: "Shop",
        AGGIORNAMENTI_DISPONIBILITA: "Aggiornamenti disponibilità",
        STATO: "Stato",
        MESSAGGIO: "Messaggio",
        NUOVO_DOCUMENTO: "Nuovo documento",
        DOCUMENTI_DI_TIPO: "Documenti di tipo",
        ELIMINA_DOCUMENTO: "Elimina documento",
        STAMPA_DOCUMENTI_SELEZIONATI: "Stampa documenti selezionati",
        SELEZIONA_PER_LA_STAMPA: "Seleziona col tasto destro, rimuovi col tasto sinistro",
        TIPO_DOCUMENTO: "Tipo documento",
        NESSUN_DOCUMENTO_DISPONIBILE: "Nessun documento disponibile per quest'ordine.",
        ELIMINA_DOCUMENTO_CONFERMA: "Sei sicuro di voler eliminare il documento",
        DOCUMENTO_ELIMINATO: "Documento eliminato con successo",
        CARICAMENTO_IN_CORSO: "Caricamento in corso...",
        NOME: "Nome",
        EMAIL: "Email",
        ID: "ID",
        CHANGE_ORDER_SATUS:"Inserisci il nuovo stato dell'ordine",
        CANCEL:"Annulla",
        CHANGE_STATUS:"Cambia stato",
        CHANGE_STATUS_CONFIRM_MESSAGE: (status:string)=><div>Si vuol procedere con il cambio di stato in <span className="fw-bold">{status}</span>?</div>,
        CHANGE_STATUS_SUCCESS:()=><><div>Richiesta inoltrata correttamente.</div><div>È possibile che occorra qualche secondo perché l'operazione di cambio di stato sia finalizzata, pertanto ti chiediamo di controllare tra poco il risultato.</div></>,
        SHIPPING_INFO: {
            NOME_AZIENDA: "Nome azienda",
            NOME: "Nome",
            COGNOME: "Cognome",
            CONTATTO_1: "Contatto 1",
            CONTATTO_2: "Contatto 2",
            VIA: "Via / piazza / altro",
            NUMERO: "N°",
            CITTA: "Città",
            CAP: "CAP",
            PROVINCIA: "Provincia",
            CODICE_PROVINCIA: "Codice provincia",
            NAZIONE: "Nazione",
        },
        BILLING_INFO: {
            NOME_AZIENDA: "Nome azienda",
            NOME: "Nome",
            COGNOME: "Cognome",
            PARTITA_IVA: "Partita IVA",
            CODICE_FISCALE: "Codice fiscale",
            PIVA: "P.IVA",
            CF: "C.F.",
            CONTATTO_1: "Contatto 1",
            CONTATTO_2: "Contatto 2",
            VIA: "Via / piazza / altro",
            NUMERO: "N°",
            CITTA: "Città",
            CAP: "CAP",
            PROVINCIA: "Provincia",
            CODICE_PROVINCIA: "Codice provincia",
            NAZIONE: "Nazione",
            ID_FATTURA: "ID fattura",
            NUMERO_FATTURA: "Numero fattura",
            DATA_FATTURA: "Data fattura",
            TOTALE_FATTURA: "Totale fattura",
            URL: "Url",
            METODO_PAGAMENTO: "Metodo di pagamento"
        },
        TAB_NETSUITE: {
            ID_ELEMENTO: "ID Elemento",
            CODICE_ESTERNO: "Codice esterno",
            DATA_CREAZIONE: "Data creazione",
            DATA_ULTIMO_AGGIORNAMENTO: "Data ultimo aggiornamento",
            STATO: "Stato",
            NUMERO_ESECUZIONI: "Numero di esecuzioni",
            NOME_SHOP: "Nome shop",
            ESEGUI_ELEMENTO: "Esegui elemento",
            INVIA_ORDINE: "Invia ordine a NetSuite",
            INVIA_ORDINE_CONFERMA: "Confermi l'invio dell'ordine a NetSuite?",
            INVIA_ORDINE_ESEGUITO: "L'ordine è stato messo in coda per l'invio a NetSuite.",
            INVIA_ORDINE_NON_ESEGUITO_GIA_ESECUZIONE: "L'ordine è già in coda per l'invio a NetSuite.",
        },
        TAB_METADATA: {
            SELEZIONA_VERSIONE: "Seleziona versione",
            CORRENTE: "Corrente",
            NESSUN_METADATO_DISPONIBILE: "Nessun metadato disponibile.",
            FINANCE_MODULE_DATA: "Dati del modulo Finance",
            TAXES_SOURCE: "Origine delle tasse",
            CALCOLATE_DALLO_SHOP: "Calcolate dallo shop",
            CALCOLATE_DA_CLOUDSTORE: "Calcolate da CloudStore",
            TASSAZIONE_SPESE_DI_SPEDIZIONE: "Tassazione spese di spedizione",
            TASSAZIONE_ARTICOLI: "Tassazione articoli",
            OPZIONI_DI_PROCESSAMENTO: "Opzioni di processamento",
            ORDINE_PARZIALE: "Ordine parziale",
            MAGAZZINI_SELEZIONATI_PER_SCARICO: "Magazzini selezionati per lo scarico",
            CONTROLLO_PREZZI_INBOUND_ORDER: "Controllo prezzi Order Inbound",
            PRICE_WARNING: "Price Warning",
            UNIT_PRICE_WARNING: "Unit price Tax Excluded Warning",
            TOTAL_PRICE_WARNING: "Total price Tax Excluded Warning",
            RIUSCITO: "Riuscito",
            NON_RIUSCITO: "Non riuscito",
            ACCETTATO_DA_CLOUDSTORE: "Accettato da CloudStore",
            NON_ACCETTATO_DA_CLOUDSTORE: "Non accettato da CloudStore",
            CONTROLLO_DISPONIBILITA_EFFETTIVA_ARTICOLI: "Controllo disponibilità effettiva articoli",
            ESITO: "Esito",
            MESSAGGIO_DI_ERRORE: "Messaggio di errore",
            CATALOG_SNAPSHOT_DATA: "Snapshot del catalogo",
            PREZZO_PIENO: "Prezzo pieno",
            PREZZO_SCONTATO: "Prezzo scontato",
            PENDING_ORDERS_CHECK_DATA: "Controllo ordini pending",
            DATA_ULTIMO_MOVIMENTO_MERCI: "Data dell'ultimo movimento merci",
            VALIDATION_DATA: "Validazioni",
            VALIDAZIONE_DISPONIBILITA: "Validazione disponibilità",
            VALIDAZIONE_PREZZO: "Validazione prezzo",
            QUANTITA_RICHIESTA: "# Richiesta",
            QUANTITA_DISPONIBILE: "# Disponibile",
            QUANTITA_ACCETTATA: "# Accettata",
            RISULTATO: "Risultato",
            CONFIGURAZIONE: "Configurazione",
            ESEGUITO: "Eseguito",
            STATO_ESECUZIONE: "Stato esecuzione",
            OK: "Riuscito",
            KO: "Non riuscito",
            NOT_APPLIED: "Non applicato",
            PRICE: "Prezzo",
            TOTALPRICETAXEXCL: "Prezzo totale (tax excl.)",
            UNITPRICETAXEXCL: "Prezzo unitario (tax excl.)",
            TOTALPRICETAXINCL: "Prezzo totale (tax incl.)",
            UNITPRICETAXINCL: "Prezzo unitario (tax incl.)",
        },
        TAB_ACTIVITIES: {
            TITLE: "Attività",
            NESSUNA_ATTIVITA_DISPONIBILE: "Nessuna attività disponibile per questo ordine.",
            TITLES: {
                STATUS_HISTORY: (status: string, color: string)=><div className="d-flex align-items-center">Stato dell'ordine modificato in <div className={`fw-bold text-${color} ms-1`}>{status}</div></div>,
                ACCETTAZIONE_ORDINE: "Accettazione ordine",
                INVIO_ORDINE_ERP: "Invio ordine all'ERP",
                INVIO_ORDINE_NETSUITE: "Invio ordine a NetSuite",
                INVIO_INFORMAZIONI_PACKAGING: "Invio informazioni di packaging",
                INVIO_INFORMAZIONI_SPEDIZIONE: "Invio informazioni di spedizione",
                PRENOTAZIONE_SPEDIZIONE: "Prenotazione spedizione",
                RICHIESTA_DOCUMENTO_SPEDIZIONE: "Richiesta documento di spedizione",
                TRANSAZIONE_DI_TIPO: (type: string)=><div>Transazione di tipo <span className={`fw-bold ${type==="PAYMENT"? "text-success" : "text-danger"}`}>{type}</span></div>,
                SPEDIZIONE: "Spedizione",
            },
            MODIFICATO_DA: "Modificato da",
            ARTICOLI: "Articoli",
            DATA_COMPLETAMENTO: "Data completamento",
            DURATA: "Durata",
            TIPO_DOCUMENTO: "Tipo documento",
            ID_TRANSAZIONE: "ID transazione",
            IMPORTO: "Importo",
        },
        TAB_TRANSACTIONS: {
            TITLE: "Transazioni",
            TABLE: {
                NESSUNA_TRANSAZIONE_DISPONIBILE: "Nessuna transazione disponibile per questo ordine.",
                DATA: "Data",
                TIPO_TRANSAZIONE: "Tipo transazione",
                ID_TRANSAZIONE: "ID transazione",
                STATO_TRANSAZIONE: "Stato transazione",
                IMPORTO: "Importo",
                METODO_PAGAMENTO: "Metodo di pagamento",
                GATEWAY: "Gateway",
            },
            CONTEXT_MENU: {
                COPIA_ID_TRANSAZIONE: "Copia ID transazione",
                COPIA_ID_PAGAMENTO: "Copia ID pagamento",
                CREA_UN_RIMBORSO: "Crea un rimborso",
                MODIFICA_TRANSAZIONE: "Modifica transazione",
                DETTAGLI_TRANSAZIONE: "Dettagli transazione"
            },
            NUOVO_RIMBORSO: "Nuovo rimborso",
            INFORMAZIONE_RIMBORSO_GATEWAY: "Alla creazione del rimborso per questa transazione verrà inoltrata la richiesta al corrispondente gateway di pagamento.",
            INFORMAZIONE_RIMBORSO_NO_GATEWAY: "Alla creazione del rimborso per questa transazione non scatena un effettivo rimborso automatico.",
            IMPORTO_RIMBORSO: "Importo del rimborso",
            RAGIONE_RIMBORSO: "Ragione del rimborso",
            ERRORE_RIMBORSO_IMPORTO_ECCEDE_DISPONIBILE: (amountAvailable: string, amountRequested: string) => `L'importo richiesto per il rimborso (${amountRequested}) eccede l'importo ancora rimborsabile per questa transazione (${amountAvailable}).`,
            RIMBORSO_IMPORTO_TOTALE: "Rimborso dell'importo totale",
            INFORMAZIONE_NESSUN_IMPORTO_RIMBORSABILE: "Nessun importo rimborsabile disponibile per questa transazione.",
            IDENTIFICATIVO_PAGAMENTO: "Identificativo pagamento",
            MOTIVO_TRANSAZIONE: "Motivo della transazione",
            NOTE: "Note",
            RIMBORSO_DEFINITO_ORDINE: "Il rimborso è definito per l'intero ordine",
            RIMBORSO_DEFINITO_RIGHE: "Il rimborso è definito per righe specifiche dell'ordine"
        },
        SALVATAGGIO_INFORMAZIONI_SPEDIZIONE_COMPLETATO: "Salvataggio informazioni di spedizione completato con successo!",
        SALVATAGGIO_INFORMAZIONI_FATTURAZIONE_COMPLETATO: "Salvataggio informazioni di fatturazione completato con successo!",
        INFORMAZIONI_AGGIUNTIVE: "Informazioni aggiuntive",
        NESSUNA_INFORMAZIONE_AGGIUNTIVA: "Nessuna informazione aggiuntiva per questo ordine.",
        DETTAGLI_ULTIMO_INVIO_A_NETSUITE: "Dettagli ultimo invio a NetSuite",
        NESSUN_INVIO_A_NETSUITE: "Nessun invio a NetSuite disponibile per questo ordine.",
        NESSUN_ARTICOLO_PRESENTE: "Non sono presenti articoli nell'ordine.",
        ARTICOLO_NON_PRESENTE: "Articolo non presente nell'inventario.",
        APPLICA_A_SKU_STESSO_PARENT: "Applica a tutte le variazioni dello stesso prodotto presenti nell'ordine",
        ARTICOLO_NON_DISPONIBILE_NELLO_SHOP: "Articolo non disponibile nello shop selezionato. Clicca per rimuovere l'articolo dall'ordine.",
        CONFERMA_RIMOZIONE_ARTICOLO: (sku: string) => `Sei sicuro di voler rimuovere l'articolo ${sku} dall'ordine?`,
    },
    PAGE_CATEGORIES: {
        CATEGORIE_CLOUDSTORE: "Categorie CloudStore",
        ASSOCIAZIONI_SHOP: "Associazioni shop",
        NESSUNA_CATEGORIA_TROVATA: "Nessuna categoria trovata",
        AGGIUNGI_CATEGORIA_ROOT: "Aggiungi categoria root",
        SELEZIONA_CATEGORIA: "Seleziona una categoria di CloudStore per visualizzare le associazioni con gli shop",
        NESSUNA_TRADUZIONE: "Nessuna traduzione",
        NESSUNA_ASSOCIAZIONE: "Nessuna associazione",
        NON_ASSOCIABILE: "Non associabile",
        NUOVA_CATEGORIA: "Nuova categoria",
        MODIFICA_CATEGORIA: "Modifica categoria",
        ELIMINA_CATEGORIA_INFO: (name: string) =><><p>Stai per eliminare la categoria <strong>{name}</strong>.</p><p>La categoria NON potrà essere eliminata se esistono articoli associati ad essa. Vuoi procedere?</p></>,
        MODIFICA_ASSOCIAZIONE: (shopName: string) => <>Modifica associazione per {shopName}</>,
        AGGIUNGI_ASSOCIAZIONE: (shopName: string) => <>Aggiungi associazione a {shopName}</>,
        ELIMINA_ASSOCIAZIONE: "Elimina associazione",
        ELIMINA_ASSOCIAZIONE_INFO: (shopName: string, cloudStoreCategoryLabel: string, shopCategoryLabel: string) =><><p>Stai per rimuovere l'associazione sullo shop <strong>{shopName}</strong> tra la categoria Cloudstore</p><p><strong>{cloudStoreCategoryLabel}</strong></p><p>e la categoria shop</p><p><strong>{shopCategoryLabel}</strong></p><p>Vuoi procedere?</p></>
    },
    PAGE_CATEGORY :{
        CATEGORY:"Categoria",
        TABS:{
            SUBCATEGORY:{
                TITLE:"Sottocategorie",
                SUBCATEGORY_OF:"Elenco delle sottocategorie di",
                SUBCATEGORY_NEW:"Nuova Categoria",
            },
            SHOPS:{
                TITLE:"Associazioni shops",
                NO_CAT_SHOP:"Non è stata riscontrata nessuna mappatura per la categoria",
                DELETE_CAT_TITLE:"Si desidera eleminare la categoria selezionata ?",
                SELECT_CAT:"Seleziona categoria",
                TITLE_CAT_SHOP:"Aggiungi nuova associazione categoria",
                ADD_NEW_CAT_SHOP: "Aggiungi una nuova associazione tra shop e categoria",
                SELECTED_CAT:"Categoria"
            },
            TRANSLATIONS:{
                TRANSLATION: "Traduzione",
                TITLE:"Traduzioni",
                COLUMNS : {
                    LANG:"Lingua",
                    TRANSLATION:"Traduzioni"
                },
                NEW_TRANSLATION:"Aggiungi una nuova traduzione",
                NEW_LANGUAGE:"Selezione nuova lingua",
                NEW_LANGUAGE_TO_ADD:"Nuove lingue da aggiungere",
                NEW_TRANSLATION_ADD_CONFERMATION:"Sei sicuro di agginre le nuove lingua/e",
                REMOVE_TRANSLATION_CONFIRMATION:"Sei sicuro di eliminare la traduzione",
                ADD_NEW_CAT_TRANSLATION: "Premere il bottone aggiungere nuove traduzioni",
            }
        },
        SELECT_CAT_FROM_LIST: "Cerca o seleziona una categoria dal menù di ricerca",
        SEARCH_CAT_TITILE:"Ricerca una categoria",
        SEARCH_PLACEHOLDER:"Min. 3 caratteri",
        ADD_CATEGORY:{
            TITLE: 'Insesisci una nuova categoria',
            NEW_CAT:'Nome nuova categoria',
            SUCCESS:"Nuova categoria aggiunta con successo",
        },
        UPDATE_SHOP_CATEGORY:{
            TITLE: 'Sfoglia le categorie dello shop selezionato',
            SELECTED_CATEGORY : 'Categoria selezionata',
            SELECTED_CATEGORY_NEW : 'Seleziona nuova categoria ...',
        },
        REMOVE_CATEGORY: "Elimina Categoria",
        REMOVE_CATEGORY_TEXT: "Attenzione si sta per eliminare la categoria __CATEGORY__ procedendo con l'operazione si eliminerà sia la categoria che tutte le sotto categorie ",
        REMOVE_CATEGORY_SUCCESS:"Rimozione della categoria __CATEGORY__ avvenuta con successo",
    },
    PAGE_SHOPS_WAREHOUSES_BINDINGS: {
        MAGAZZINI_NON_SELEZIONATI: "I seguenti shop non hanno nessun magazzino selezionato",
        CONFERMA_SALVATAGGIO_SENZA_RICHIESTA: ()=><><p>Stiamo per aggiornare la configurazione dei magazzini; questa operazione comporta il ricalcolo delle quantità disponibili per lo Shop per il quale si sta cambiando la configurazione dei magazzini. L'operazione potrebbe richiedere un po' di tempo ed è monitorabile dalle code dei task a lunga esecuzione.</p><p>Contestualmente verrà eseguita la procedura di aggiornamento massivo delle quantità sul canale di vendita.</p></>,
        SALVATAGGIO_AVVENUTO_CORRETTAMENTE: "Configurazione salvata correttamente",
        EVIDENZIA_RIGA: "Evidenzia questa riga",
        EVIDENZIA_COLONNA: "Evidenzia questa colonna",
        SELEZIONA_RIGA: "Seleziona questa riga (alt+click)",
        SELEZIONA_COLONNA: "Seleziona questa colonna (alt+click)",
        NOTIFY_SAVE_ERRORS: "Si sono verificati i seguenti errori nell'esecuzione dell'operazione",
        SALVATAGGIO_SHOP: "Salvataggio shop",
        RICALCOLO_QUANTITA: "Ricalcolo quantità",
        AGGIORNAMENTO_CANALI: "Aggiornamento canali di vendita",
        NOME_SHOP: "Nome shop",
        STEP: "Step",
        ERRORE: "Errore"
    },
    PAGE_WAREHOUSES_MOVEMENTS: {
        WARNING_MANDATORY_FILTERS: "Selezionare il filtro data e almeno uno tra i filtri sku e magazzino.",
        DETTAGLI_MOVIMENTO: "Dettagli movimento",
    },
    PAGE_RETURNS:{
        DETAILS: "Dettaglio reso",
        RETURN:"Reso",
        LOADING: "in caricamento...",
        NOT_FOUND: "Not found",
        ON_ERROR: "in errore",
        INFO: "Informazioni reso",
        ORIGIN_ORDER: "Ordine di origine",
        REASON:"Motivo reso",
        RESOLUTION:"Risoluzione",
        ITEMS: "Articoli",
        TABLE:{
            QUANTITY:"Quantita",
            STATUS:"Stato",
            DATE:"Data",
            CREATION_DATE:"Data creazione",
            ID:"Identificativo",
            RETURN:"Reso",
            CUSTOMER_CODE: "Codice cliente",
            UPDATE_DATE:"Ultimo aggiornamento",
            VAI_A_DETTAGLIO: "Vai al dettaglio",
        }
    },
    PAGE_LOGS:{
        TRACKING:{
            TRACKING:"Tracking",
            ELEMENT_PROCESSING: "Elaborazione Elemento",
            ELEMENT_CREATION:"Creazione Elemento", 
        },
        SETTINGS:{
            NEW_SETTINGS:"Aggiungi nuova configurazione",
            FREQUENCY:"Frequenza",
            SEARCH_TERM:"Termine di ricerca",
            NO_SERCH_TERMS:"Nessun termine di ricerca",
            GROUP:"Gruppo",
            LEVELS:"Livelli",
            EMAILS: "Emails",
            COMPONENT:"Componente",
            INSERT_MAILS: "Indirizzi email",
            MODIFY_CONFIG:"Modifica configurazione",
            DELETE_CONFIG:"Cancella configurazione",
            DELETE_CONFIRM_MESSAGE:"Procedere con l'eliminazione della configurazione del registro attività?",
            DELETE_CONFIRM:"Rimozione configurazione avvenuta con successo"
        },
        WAREHOUSES_DETAILS:"Dettaglio magazzini"
    },
    PAGE_QUEUES:{
        SEARCH_TERM_PLACEHOLDER:"Cerca una coda",
        FAVORITES:"Preferiti",
        CORE:"Code core",
        MODULE:"Code moduli",
        EXTERNAL:"Code esterne",
        SEARCH_RESULTS:"Risultati ricerca",
        RERUN_QUEUE:"Riesegui code",
        QUEUE_NOT_FOUND:"La Coda richiesta non è stata trovata.",
        QUEUE_ERROR:"Si è verificato un errore durante il caricamento della coda, si prega di riprovare.",
        QUEUE_EMPTY_BOX:"Non sono stati trovati elementi per la coda selezionata",
        QUEUE_EMPTY_EXECUTIONS_DETAILS:"Non sono state trovate esecuzioni per la coda specifica",
        PANORAMICA: "Panoramica",
        NESSUNA_CODA_PREFERITA: ()=><>Nessun preferito selezionato. Per aggiungere delle code ai preferiti cliccare sull’icona<i style={{padding:"3px", fontSize: "16px"  }} className=" bi-star text-primary"/>della coda stessa</>,
        NESSUNA_CODA_TROVATA: "Nessuna coda trovata.",
        CONFERMA_ESECUZIONE_ELEMENTI: (count: number) => (count === 1 ? `Confermi l'esecuzione dell'elemento selezionato?` : `Confermi l'esecuzione dei ${count} elementi selezionati?`),
        ERRORE_ELABORAZIONE_ELEMENTI: (count: number) => (count === 1 ? `Si è verificato un errore durante l'elaborazione dell'elemento selezionato.` : `Si è verificato un errore durante l'elaborazione di ${count} tra gli elementi selezionati.`),
        TABLE: {
            NOME: "Nome report",
            CREATION_DATE:"Creato il",
            UPDATE_DATE:"Aggiornato il",
            GO_TO_DETAIL: "Dettagli",
            COPY_ID: "Copia ID",
            EXECUTIONS: "Esecuzioni",
            ATTIVITA: "Attività",
            STATUS: "Stato",
            STATUS_ELABORATED:"Elaborato",
            STATUS_PENDING: "In attesa",
            STATUS_TO_BE_PROCESSED: "Da elaborare",
            STATUS_PROCESSED_SUCCESSFUL:"Elaborazione completata",
            STATUS_PROCESSED_FAILED: "Elaborazione fallita",
            RECORDS:"# record",
            GOTO_DETAILS:"Vai al dettaglio",
            RIESEGUI_ELEMENTO:"Rielabora nuovamente",
            EXTERNAL_CODE:"Codice esterno",
            VAI_A_FLUSSO_ORIGINE: "Vai al flusso di origine",
            ELEMENTI_ELABORATI_TOTALI: "Elementi elaborati / Totali",
            COPIA_CODICE_ESTERNO: "Copia codice esterno",
            SHOP: "Shop",
            SPEDIZIONE: "Spedizione",
            MARKETPLACE: "Marketplace",
            SUBMISSION_ID: "Submission ID",
            SKU: "SKU",
            QUANTITA: "Qtà",
            FILE: "File",
            ARTICOLO: "Articolo",
            TIPO: "Tipo",
            APPLICAZIONE_REGOLE_DI_ESCLUSIONE: "Applicazione regole di esclusione",
            APPLICAZIONE_CONDIZIONI_COMMERCIALI: "Applicazione condizioni commerciali",
            ALLINEAMENTO_QUANTITA_CON_NETSUITE: "Allineamento quantità con NetSuite",
            SINCRONIZZAZIONE_FULL_PARENT_ITEMS: "Sincronizzazione Full Parent Items",
            SINCRONIZZAZIONE_DIFFERENZIALE_PARENT_ITEMS: "Sincronizzazione Differenziale Parent Items",
            LISTING_TIPO: (listing_type:ChildListingTypeEnum)=>{
                const listingTypeTheme = getListingTypeTheme(listing_type) ?? {type: listing_type, variant: "secondary"}
                return <>Listing di tipo <Badge className="smallest" bg={listingTypeTheme.variant}>{listing_type}</Badge></>
            },
            LISTING_TIPO_SU_ARTICOLI: (listing_type:ChildListingTypeEnum)=>{
                const listingTypeTheme = getListingTypeTheme(listing_type) ?? {type: listing_type, variant: "secondary"}
                return <>Listing di tipo <Badge className="smallest" bg={listingTypeTheme.variant}>{listing_type}</Badge> su articoli</>
            },
            LISTING_TIPO_SU_BUCKET: (listing_type:ChildListingTypeEnum, abName: string)=>{
                const listingTypeTheme = getListingTypeTheme(listing_type) ?? {type: listing_type, variant: "secondary"}
                return <>Listing di tipo <Badge className="smallest" bg={listingTypeTheme.variant}>{listing_type}</Badge> sul bucket <span className="fw-bold">{abName}</span></>
            },
            LISTING_TIPO_SU_SHOP: (listing_type:ChildListingTypeEnum, shopRender: JSX.Element)=>{
                const listingTypeTheme = getListingTypeTheme(listing_type) ?? {type: listing_type, variant: "secondary"}
                return <span>Listing di tipo <Badge className="smallest" bg={listingTypeTheme.variant}>{listing_type}</Badge> sullo shop {shopRender}</span>
            },
            AGGIORNAMENTO_QUANTITA_DEDICATE: "Aggiornamento quantità dedicate a uno shop",
            AGGIORNAMENTO_QUANTITA_DEDICATE_A: (shopRender: JSX.Element)=>{
                return <span>Aggiornamento quantità dedicate allo shop {shopRender}</span>
            },
            SHOP_DI_ORIGINE: "Shop di origine",
            SHOP_DI_DESTINAZIONE: "Shop di destinazione",
            RESO_DI_ORIGINE: "Reso di origine",
            ORDINE_DI_ORIGINE: "Ordine di origine",
            NS_INTERNAL_ID: "NS internal ID",
            NS_EXTERNAL_ID: "NS external ID",
            TOTALE: "Totale",
            NOME_CLIENTE: "Nome cliente",
            CODICE_CLIENTE: "Codice cliente",
            SALES_ORDER: "Sales order",
            TRACKING_NUMBER: "Tracking number",
            UPC: "UPC",
            TRANSAZIONE: "Transazione",
            TIPO_ORDINE: "Tipo ordine",
            ID_PARTNER: "ID Partner",
            ORDINE: "Ordine",
            OPERAZIONE: "Operazione",
            TIPI_OPERAZIONE: {
                UPDATE_ORDER_POSITION_STATUS: "Aggiornamento stato riga ordine",
                BOOK_SHIPPING: "Prenotazione spedizione",
                UPDATE_SHIPPING_DETAIL: "Aggiornamento dettagli spedizione",
                FETCH_SHIPPING_DOCUMENT: "Recupero documenti",
                CREATE_RETURN: "Creazione reso",
                UPDATE_RETURN_STATUS: "Aggiornato stato reso"
            },
            TIPI_DOCUMENTO: {
                ORDER_INFO: "Descrizione ordine",
                RETURN_INFO: "Descrizione reso",
                LABEL_RETURN: "Etichetta di reso",
                LABEL_SHIPPING: "Etichetta di spedizione",
                LABEL_CHINA_SHIPPING: "Etichetta di spedizione Cina"
            },
            CODICE_ORDINE: "Codice ordine",
            VEDI_ESITO_ELABORAZIONE: "Vedi esito elaborazione",
            NESSUN_ESITO_DI_ELABORAZIONE_TROVATO: "Nessun esito di elaborazione trovato",
        },
        STATUS: {
            TO_BE_PROCESSED: "In attesa",
            PROCESSING: "In esecuzione",
            PROCESSED_SUCCESSFUL: "Elaborato",
            PROCESSED_FAILED: "Fallito"
        },
        DETAILS: {
            TAB_INFO:"Informazioni",
            TAB_INFO_TITLE_1:"Informazioni Coda",
            TAB_INFO_TITLE_2:"Esecuzione Coda",
            TAB_PAYLOAD:"Payload",
            TAB_DETAIL:"Dettaglio",
            EXTERNAL_CODE:"Codice esterno",
            CREATION_DATE:"Data creazione",
            UPDATE_DATE:"Data ultimo aggiornamento",
            STATUS:"Stato",
            REPORT:"Report",
            TIMELINE_ELEMENT:"Non sono presenti informazioni per questa specifica esecuzione"
        },
        RIELABORA: "Rielabora",
        VUOI_RIELABORARE_QUESTO_ELEMENTO: "Sei sicuro di voler rielaborare questo elemento?",
        METTI_IN_ELABORATO: "Metti in stato Elaborato",
        VUOI_METTERE_IN_ELABORATO: (count:number) => (count === 1 ? `Sei sicuro di voler mettere in stato Elaborato l'elemento selezionato?` : `Sei sicuro di voler mettere in stato Elaborato i ${count} elementi selezionati?`),
        ALLEGATI: "Allegati",
        NESSUN_ALLEGATO_DISPONIBILE: "Nessun allegato disponibile.",
        STATO_AVANZAMENTO: "Stato avanzamento",
        STATO_AVANZAMENTO_NON_DISPONIBILE: "Stato avanzamento non disponibile.",
        NON_ELABORATO: "Non elaborato",
        IN_ATTESA: "In attesa",
        COMPLETATO: "Completato",
        NON_DISPONIBILE: "Non disponibile",
        IN_ELABORAZIONE: "In elaborazione",
        BUSINESS_CONDITIONS_PROGRESS_ELEMENTS: {
            PREPARAZIONE: "Preparazione",
            ELABORAZIONE_ASSOCIAZIONI_CUSTOMERS: "Elaborazione associazioni customers",
            ELABORAZIONE_ASSOCIAZIONI_SHOPS: "Elaborazione associazioni shops",
            AGGIORNAMENTO_STATI_RELAZIONI: "Aggiornamento stati e relazioni",
            APPLICAZIONE_CONDIZIONI_CREAZIONE_LISTING: "Applicazione condizioni e creazione listing",
        },
        LISTING_EXCLUSION_RULES_PROGRESS_ELEMENTS: {
            PREPARAZIONE: "Preparazione",
            ELABORAZIONE_AVAILABILITY_BUCKETS: "Elaborazione availability buckets",
            AGGIORNAMENTO_REGOLE: "Aggiornamento regole",
            APPLICAZIONE_REGOLE_DI_ESCLUSIONE: "Applicazione regole di esclusione",
        }
    },
    PAGE_LISTING: {
        DETTAGLIO_LISTING: "Dettaglio listing",
        VAI_AL_DETTAGLIO: "Vai al dettaglio",
        FILTERS: {
            SHOP: "Shop",
            STATO: "Stato",
            TIPO: "Tipo",
        },
        TABS: {
            DATI: "Dati",
            ELENCO_ARTICOLI: "Elenco articoli",
            AGGIORNAMENTI_DISPONIBILITA: "Aggiornamenti disponibilità"
        },
        DATA: "Data",
        ORIGINE: "Origine",
        TEMPO_DI_ESECUZIONE: "Tempo di esecuzione",
        TIPO: "Tipo",
        STATO: "Stato",
        LABEL_STATUS: (status:ChildListingStatusEnum) =>{
            if( status === "READY") {return "Pronto"}
            if( status === "RUNNING") {return "In esecuzione"}
            if( status === "COMPLETED_WARNING") {return "Completato con warning"}
            if( status === "FAILED") {return "Fallito"}
            if( status === "COMPLETED") {return "Completato"}
            return status as string
        },
        ARTICOLI: "Articoli",
        ARTICOLI_PUBBLICATI: "Articoli pubblicati",
        ARTICOLI_SCARTATI: "Articoli scartati",
        ARTICOLI_FALLITI: "Articoli falliti",
        PASSAGGI: "Passaggi",
        NESSUN_PASSAGGIO_DISPONIBILE: "Nessun passaggio disponibile",
        TABLE_ITEMS: {
            SKU: "SKU",
            TITOLO: "Titolo",
            MARCA: "Marca",
            STATO: "Stato",
            MESSAGGIO: "Messaggio",
        },
        TABLE_AVAILABILITY_ADJUSTMENTS: {
            SKU: "SKU",
            DATA: "Data",
            SHOP: "Shop",
            QUANTITA: "Qty",
            STATO: "Stato",
            MESSAGGIO: "Messaggio",
        },
        PUBBLICATO: "Pubblicato",
        SCARTATO: "Scartato",
        FALLITO: "Fallito",
        PRONTI: "Pronti",
        PARENT_CONFERMATI: "Parent confermati",
        PARENT_COMPLETATI_SENZA_FIGLI: "Parent completati senza figli",
        CONFERMA_RIPUBBLICAZIONE_LISTING: "Confermi la riesecuzione di questo listing?",
        NEW_LISTING: {
            TITLE: "Crea un listing",
            TIPO: "Tipo listing",
            MODALITA: "Modalità",
            SHOP: "Shop",
            SHOP_DA_INCLUDERE: "Shop da includere",
            BUCKET: "Bucket",
            ITEM_TEXT_PLACEHOLDER: "Inserire i codici usando come separatore uno dei seguenti: spazio, a capo, TAB, virgola, punto e virgola, due punti",
            SEPARATORE: "Separatore",
            SPAZIO: "Spazio",
            A_CAPO: "A capo",
            TAB: "TAB",
            VIRGOLA: "Virgola",
            PUNTO_E_VIRGOLA: "Punto e virgola",
            DUE_PUNTI: "Due punti",
            SCONOSCIUTO: "Sconosciuto",
            VERIFICA_ARTICOLI: "Verifica articoli",
            VERIFICA_ARTICOLI_DESC: "Seleziona articoli da includere nel listing e clicca su Verifica per validarli.",
            MOSTRA_SOLO_ARTICOLI_NON_VALIDI: "Mostra solo articoli non validi",
            MOSTRA_TUTTI_GLI_ARTICOLI: "Mostra tutti gli articoli",
            QUESTO_VALORE_E_DUPLICATO: "Questo valore è duplicato",
            CONFERMA_LISTING_SHOP: (listingType: string, shopNumber: number)=><>Confermi la creazione di un listing <span className="fw-bold">{listingType}</span> su <span className="fw-bold">{shopNumber}</span> shop?</>,
            CONFERMA_LISTING_SKU: (listingType: string, itemsCount: number)=><>Confermi la creazione di un listing <span className="fw-bold">{listingType}</span> per <span className="fw-bold">{itemsCount}</span> SKU?</>,
            CONFERMA_LISTING_SKU_PARENT: (listingType: string, itemsCount: number)=><>Confermi la creazione di un listing <span className="fw-bold">{listingType}</span> per <span className="fw-bold">{itemsCount}</span> SKU Parent?</>,
            OPERAZIONE_EFFETTUATA_SU_ARTICOLI_VALIDI: (validItemsCount: number, totalItemsCount: number)=><>L'operazione verrà effettuata su <span className="fw-bold">{validItemsCount}</span> articoli validi di <span className="fw-bold">{totalItemsCount}</span> totali.</>,
            ERRORE_LISTING_SHOPS: (listingType: string, shopNames: string[]) => <>Si è verificato un errore nella creazione del listing <span className="fw-bold">{listingType}</span> per {shopNames.length === 1?<>lo shop <strong>{shopNames[0]}</strong>.</>:<> gli shop <strong>{shopNames.map((name, index)=>`name${index === shopNames.length-1?"":", "}`)}</strong>.</>}</>
        }
    },
    PAGE_DAM: {
        NUOVO: "Nuovo DAM",
        MODIFICA: "Modifica DAM",
        IMPOSTA_COME_PREDEFINITO: "Imposta come predefinito",
        PREDEFINITO: "Predefinito",
        USATI: "Usati",
        LIBERI: "Liberi",
        TOTALI: "Totali",
        ASSET_TOTALI: "Asset totali",
        STATISTICHE: "Statistiche",
        CONFIGURAZIONE: "Configurazione",
        NOME: "Nome",
        CUSTOMER_CODE: "Codice cliente",
        HOSTNAME: "Host",
        PORT: "Porta",
        ENABLED: "Abilitato",
        IS_DEFAULT: "Predefinito",
        SECURE: "Sicuro",
        USERNAME: "Nome utente",
        PASSWORD: "Password",
        REMOTE_UPLOAD_DIRECTORY: "Directory di upload remoto",
        EXPORTED_HTTP_URL_PREFIX: "Prefisso URL HTTP esportato",
        ERRORE_NOME_GIA_UTILIZZATO: "Nome già in uso.",
        STATO: "Stato",
        PENDING: "In Attesa",
        CONFIRMED: "Confermato",
        AUTH_ERROR: "Errore di Autenticazione",
        ERROR: "Errore",
        CONFERMA_IMPOSTA_PREDEFINITO: (name: string) => <>Confermi di voler impostare il DAM <strong>{name}</strong> come predefinito?</>,
    },
    PAGE_USERS: {
        NUOVO_UTENTE: "Nuovo utente",
        GRUPPI: "Gruppi",
        GROUPS: {
            TUTTI_GLI_UTENTI: "Tutti gli utenti",
            AMMINISTRATORI: "Amministratori",
            AMMINISTRATORE: "Amministratore",
            MASTER: "Master",
            FINANCE: "Finance",
            MAGAZZINIERI: "Magazzinieri",
            MAGAZZINIERE: "Magazziniere",
            ATTIVI: "Attivi",
            ATTIVO: "Attivo",
            CANCELLATI: "Cancellati",
            CANCELLATO: "Cancellato",
            SOSPESI: "Sospesi",
            SOSPESO: "Sospeso",
            DA_CONFERMARE: "Da confermare",
            IN_ERRORE: "In errore",
        },
        NESSUN_UTENTE_SELEZIONATO: "Nessun utente selezionato.",
        DETTAGLI_UTENTE: "Dettagli utente",
        MODIFICA_PASSWORD: "Modifica password",
        INVIA_EMAIL_DI_RESET_PASSWORD: "Invia email di reset password",
        TU: "Tu",
        CAMBIA_TIPO_UTENTE: "Cambia tipo utente",
        CONFERMA_CAMBIO_TIPO_UTENTE: (username: string, userType: string) => <>Confermi di voler cambiare il tipo utente di <strong>{username}</strong> in <strong>{userType}</strong>?</>,
        CAMBIO_TIPO_UTENTE_EFFETTUATO: "Cambio tipo utente effettuato con successo.",
        CAMBIO_TIPO_UTENTE_AVVISO: "Il cambio del tipo utente sarà effettivo alla prossima login. Vuoi effettuare il logout ora?",
        EFFETTUA_LOGOUT: "Effettua logout",
        NON_ORA: "Non ora",
        AVATAR: {
            MODIFICA_AVATAR: "Modifica avatar",
            MODIFICA_AVATAR_DESC: "Carica un file o trascinalo nell'area sottostante per modificarlo.",
            CLICCA_O_DROPPA_QUI: "Clicca qui o trascina il file...",
            DROPPA_QUI: "Trascina il file qui...",
        },
        EDIT_FORM: {
            USER_TYPE: "Tipo utente",
            USERNAME: "Nome utente",
            PASSWORD: "Password",
            CONFERMA_PASSWORD: "Conferma password",
            FIRST_NAME: "Nome",
            LAST_NAME: "Cognome",
            COMPANY_NAME: "Ragione sociale",
            WEBSITE: "Sito web",
            DEFAULT_LANG: "Lingua predefinita",
            CONFERMA_CREAZIONE_UTENTE: "Confermi la creazione del nuovo utente?",
        }
    },
    TABLE: {
        PAGINA_NUMERO_DI: "Pagina __NUMBER__ di __TOTAL__",
        RISULTATI: "risultati",
        RISULTATI_FILTRATI_DA: "risultati (filtrati da __TOTAL__ totali)",
        VAI_A: "Vai a...",
        PAGINA: "Pagina",
        NESSUN_RISULTATO: "Nessun risultato.",
        SI_E_VERIFICATO_UN_ERRORE: "Si è verificato un errore, clicca sul pulsante sotto per riprovare."
    },
    DATE_PICKER: {
        DEFAULT_DATE_RANGES: {
            OGGI: "Oggi",
            IERI: "Ieri",
            ULTIMA_SETTIMANA: "Ultima settimana",
            PRIMO_MESE: "Dal primo del mese",
            MESE_PRECEDENTE: "Nel mese precedente"
        },
        SALVA_FILTRO_PERSONALIZZATO: "Salva filtro personalizzato",
        INTERVALLO_PERSONALIZZATO: "Intervallo personalizzato",
    },
    REACT_SELECT: {
        PLACEHOLDER: "Seleziona un valore...",
        RICERCA_IN_CORSO: "Ricerca in corso...",
        DIGITARE_CARATTERI_RICERCA: (count:number) =>(count===1)?"Digitare almeno un carattere per la ricerca.": `Digitare almeno ${count} caratteri per la ricerca.`,
        NESSUN_RISULTATO: "Nessun risultato trovato."
    },
    CONFIGURAZIONE: {
        NUOVA_CONFIGURAZIONE: "Nuova configurazione"
    },
    FILTERS: {
        SELEZIONARE_ALMENO_UN_FILTRO: "Selezionare almeno un filtro per visualizzare i risultati.",
        NESSUN_RISULTATO: "Nessun risultato trovato.",
        ERRORE: "Si è verificato un errore, si prega di riprovare."
    },
    ADVANCED_FILTERS: {
        FILTRO_AVANZATO: "Filtro avanzato",
        LABELS: {
            BRAND: "Brand",
            CATEGORIE: "Categorie",
            STAGIONI: "Stagioni",
            CANALE_DI_VENDITA: "Canale di vendita",
            QUANTITY: "Quantità",
            SELEZIONA_LE_CATEGORIE: "Seleziona le categorie...",
            CATEGORIE_SELEZIONATE: "Categorie selezionate",
            DATA: "Data",
            SKU: "Sku",
            STATO: "Stato",
            ORDER_TYPE : "Tipologia di ordine",
            ORDER: "Ordine",
            ORDERS: "Ordini compresi in",
            WAREHOUSES: 'Magazzini',
            SELEZIONA_MAGAZZINO: "Seleziona un magazzino...",
            SELEZIONA_ELEMENTI: "Seleziona gli elementi...",
            ELEMENTI_SELEZIONATI: "Elementi selezionati",
            COMPONENTS:"Componenti",
            GROUP:"Gruppo",
            CUSTOMERS:"Clienti",
            SHOP: "Shop",
            ARTICOLO: "Articolo",
            ARTICOLI: "Articoli compresi in",
            SEARCH: "Termine di ricerca"
        },
        NESSUN_FILTRO_APPLICATO: "Nessun filtro applicato.",
        ERRORE_CARICAMENTO_FILTRI: "Si è verificato un errore nel caricamento dei filtri.",
        SHOP: "Canali di vendita compresi in ",
        BRAND: "Brand compresi in ",
        SEASON: "Stagioni comprese in ",
        E_ALTRI: " e altri",
        E_ALTRE: " e altre",
        DATA: "Data",
        DATA_DA: "da",
        DATA_A: "a",
        IL_GIORNO: "il giorno",
        QUANTITA_NO: "NON devono avere quantità disponibili",
        QUANTITA_SI: "devono avere almeno una quantità disponibile",
        FILTRI_PERSONALIZZATI: "Filtri personalizzati",
        NESSUN_FILTRO_PERSONALIZZATO: "Nessun filtro personalizzato disponibile.",
        SALVA_FILTRO_PERSONALIZZATO: "Salva filtro personalizzato",
        SALVA_FILTRO_PLACEHOLDER: "Filtro personalizzato",
        APPLICA: "Applica",
        ANNULLA: "Annulla",
        RESETTA: "Resetta",
        FILTRO_NON_APPLICATO: "Filtro non ancora applicato",
        CATEGORIES: "Categorie comprese in",
        SKU: "Sku compresi in",
        QUALSIASI_STATO: "Qualsiasi stato",
        IN_STATO: "In stato"
    },
    DOCUMENT_TYPES: {
        COMMERCIAL_INVOICE: "Fattura",
        AIRWAY_BILL: "Lettera di vettura aerea",
        RETURN_INSTRUCTIONS: "Istruzioni di reso",
        RETURN_LABEL: "Etichette per il reso",
        CITES_DECLARATION: "Dichiarazione di Washington",
        ORDER_DESCRIPTION: "Descrizione dell'ordine",
        SHIPPING_DESCRIPTION: "Descrizione della spedizione",
        SHIPPING_LABEL: "Etichette di spedizione",
        OTHER: "Altro",
    },
    INPUT_TAGS:{
        ADD_TAGS:"Aggiungi un tag e premi invio",
        REMOVE:"Clicca per rimuovere",
        TITLE: "Tags"
    },
    AVAILABILITY_DETAILS: {
        TITLE: (shopName: string) =><>Dettagli disponibilità per <strong>{shopName}</strong></>,
        QUANTITA_PRESENTE_SHOP: "Quantità presente nello shop",
        QUANTITA_INVIATA_SHOP: "Quantità inviata allo shop",
        QUANTITA_CALCOLATA: "Quantità calcolata",
        QUANTITA_DISPONIBILE_BUCKET: "Quantità disponibile nel bucket",
        QUANTITA_DISPONIBILE_MAGAZZINI_ATTIVI: "Quantità disponibile nei magazzini attivi",
        SITUAZIONE_MAGAZZINI: "Situazione magazzini al momento dell'invio della quantità allo shop",
        TABLE: {
            MAGAZZINO: "Magazzino",
            QUANTITA: "Quantità",
            QUANTITA_RISERVATA: "Quantità riservata",
            ABILITATO_ARTICOLO: "Abilitato su articolo",
            ABILITATO_SHOP: "Abilitato su shop"
        }
    },
    QUEUES: {
        STATUSES: {
            TO_BE_PROCESSED: "In attesa",
            PROCESSING: "In esecuzione",
            PROCESSED_SUCCESSFUL: "Elaborato",
            PROCESSED_FAILED: "Fallito"
        },
        CARD:{
            ACCOUNT:"Account",
            SHOP:"Shop",
            AMAZON: "Amazon",
            BC:"Business Conditions",
            WHS:"Warehouses",
            ERP:"Modulo Erp",
            NETSUITE:"NetSuite",
            FXFF:"Fxff",
            TON:"Tony",
            RETAILPRO:"RetailPro",
            EFASHION:"e-Fashion",
            NEW_EXTERNAL:"Nuove code esterne",
            THE_CORNER:"The Corner",
            NEW_QUEUE:"Nuove code"
        },
        DESCRIPTIONS: {
            UNKNOWN_QUEUE: "Coda personalizzata",
            INTERNAL_QUEUE_IN_CLOUDSTORE: "Coda interna in CloudStore",
            EXTERNAL_QUEUE_TO_CLOUDSTORE: "Coda esterna a CloudStore",
            ITEMS_TO_BE_PROCESSED: "Elementi da elaborare",
            ITEMS_IN_ERROR: "Elementi in errore",
            NO_ERROR: "Nessun errore!",
            DEFAULT_DESCRIPTION: "Non è disponibile una descrizione per la coda",
            OUTBOUND: {
                MOD_M2_PRICE_QUANTITY: {
                    LABEL: "Outbound prezzi e quantità",
                    DESCRIPTION: "Esportazione informazioni di prezzi e quantità verso l'ESB."
                },
                MOD_M2_ITEMS: {
                    LABEL: "Outbound articoli",
                    DESCRIPTION: "Esportazione informazioni di anagrafiche articoli verso l'ESB."
                },
                TON_ITEM_NS: {
                    LABEL: "Outbound item",
                    DESCRIPTION: "Esportazione anagrafica articoli da CloudStore a NetSuite"
                },
                SVT_ORDER: {
                    LABEL: "Outbound ordini a Account Partner",
                    DESCRIPTION: "Outbound ordini partner da Account Marketplace ad Account Partner"
                },
                ERP_ORDERS: {
                    LABEL: "Outbound ordini di vendita",
                    DESCRIPTION: "Invio all'ERP collegato degli ordini di vendita ricevuti da CloudStore"
                },
                NS_OUTBOUND_SALES_ORDERS: {
                    LABEL: "Outbound ordini di vendita",
                    DESCRIPTION: "Invio a NetSuite degli ordini di vendita ricevuti da CloudStore"
                },
                NS_OUTBOUND_TRANSFER_ORDERS: {
                    LABEL: "Outbound ordini di trasferimento",
                    DESCRIPTION: "Invio a NetSuite degli ordini di trasferimento ricevuti da CloudStore"
                },
                OTHER_OUTBOUND_PACKAGES: {
                    LABEL: "Invio informazioni di packaging",
                    DESCRIPTION: "Invio delle informazioni di packaging verso gli Shop che hanno questo flusso attivo",
                    EXTERNAL_KEY: "Ordine da spedire",
                    PARTITON_ID:  "Shop",
                },
                OTHER_OUTBOUND_SHIPMENTS: {
                    LABEL: "Invio spedizioni",
                    DESCRIPTION: "Invio delle spedizioni verso gli Shop che hanno questo flusso attivo"
                },
                OTHER_OUTBOUND_RETURN: {
                    LABEL: "Invio resi senza RMA",
                    DESCRIPTION: "Invio delle informazioni relative ai resi senza RMA verso gli Shop che hanno questo flusso attivo"
                },
                OTHER_OUTBOUND_RETURN_REQUEST: {
                    LABEL: "Risposta richiesta resi",
                    DESCRIPTION: "Invio della risposta alla richiesta dei resi verso gli Shop che hanno questo flusso attivo"
                },
                OTHER_OUTBOUND_ORDERS_CANCELLATION: {
                    LABEL: "Invio cancellazione ordini",
                    DESCRIPTION: "Aggiornamento sul canale di vendita dello stato cancellato di un ordine"
                },
                OTHER_OUTBOUND_REMOVE_ITEMS_RESULT: {
                    LABEL: "Rimozione articoli",
                    DESCRIPTION: "Risultati delle attività di rimozione degli articoli dagli Shop"
                },
                AMZN_FEED_REQUEST_FULFILLMENT: {
                    LABEL: "Feed spedizioni",
                    DESCRIPTION: "Invio informazioni relative alle spedizioni",
                },
                AMZN_FEED_REQUEST_INVENTORY: {
                    LABEL: "Feed inventario",
                    DESCRIPTION: "Invio aggiornamenti inventario articoli"
                },
                AMZN_FEED_RESPONSE: {
                    LABEL: "Feed response",
                    DESCRIPTION: "Letture delle risposte di Amazon ai vari feed"
                },
                TON_OUTBOUND_NS:{
                    LABEL: "Outbound Item verso NetSuite",
                    DESCRIPTION: "Outbound Item verso NetSuite"
                },
                MKPLSVT_SS_ORDER:{
                    LABEL:"Outbound Orders to SCSC",
                    DESCRIPTION:"Outbound Orders to SCSC",
                },
                MKPLSVT_ORDER:{
                    LABEL:"Outbound Orders to CS Connector",
                    DESCRIPTION:"Outbound Orders to CS Connector",
                },
                CORE_SHOP_MIINTO_ASYNC_REQUEST: {
                    LABEL: "Richieste asincrone Miinto",
                    DESCRIPTION: "Coda dedicata alla gestione delle richieste asincrone di Miinto"
                },
            },
            INBOUND: {
                TON_RP: {
                    LABEL: "Inbound movimenti di magazzino",
                    DESCRIPTION: "Importazione dei movimenti di magazzino generati da Retail Pro"
                },
                EFASHION_ITEMS: {
                    LABEL: "Inbound item da eFashion",
                    DESCRIPTION: "Elaborazione degli articoli da importare in CloudStore da eFashion"
                },
                NS_INBOUND_CASHSALE_INVOICE: {
                    LABEL: "Inbound fatture / scontrini",
                    DESCRIPTION: "Importazione delle informazioni relative agli scontrini e alle fatture"
                },
                NS_INBOUND_CUSTOMER: {
                    LABEL: "Inbound clienti",
                    DESCRIPTION: "Importazione dei clienti che hanno accesso al modulo B2B"
                },
                NS_INBOUND_FULFILLMENTS: {
                    LABEL: "Inbound spedizioni",
                    DESCRIPTION: "Importazione delle informazioni relative alle spedizioni"
                },
                NS_INBOUND_ITEM_AVAILABILITY: {
                    LABEL: "Inbound aggiornamenti quantità",
                    DESCRIPTION: "Importazione delle quantità disponibili rimanenti degli articoli"
                },
                NS_INBOUND_ORDERS: {
                    LABEL: "Inbound aggiornamento ordini",
                    DESCRIPTION: "Importazione degli aggiornamenti relativi agli ordini"
                },
                NS_INBOUND_ITEMS: {
                    LABEL: "Inbound articoli",
                    DESCRIPTION: "Importazione delle anagrafiche degli articoli"
                },
                RP_INBOUND_MOVIMENTI: {
                    LABEL: "Inbound movimenti",
                    DESCRIPTION: "Importazione dei movimenti di magazzino creati su Retail Pro"
                },
                OTHER_INBOUND_ITEMS: {
                    LABEL: "Importazione articoli",
                    DESCRIPTION: "Importazione delle anagrafiche degli articoli"
                },
                OTHER_INBOUND_ITEM_IMAGES: {
                    LABEL: "Importazione immagini articoli",
                    DESCRIPTION: "Importazione delle immagini degli articoli"
                },
                OTHER_BULK_INBOUND_ITEMS: {
                    LABEL: "Importazione flusso articoli",
                    DESCRIPTION: "Importazione massiva di informazioni anagrafiche relative agli articoli"
                },
                OTHER_BULK_INBOUND_ITEM_IMAGES: {
                    LABEL: "Importazione flusso immagini articoli",
                    DESCRIPTION: "Importazione massiva di immagini relative agli articoli"
                },
                OTHER_BULK_INBOUND_WHS_MOVEMENTS: {
                    LABEL: "Importazione flusso movimenti di magazzino",
                    DESCRIPTION: "Importazione massiva di movimenti di magazzino"
                },
                OTHER_BULK_INBOUND_WHS_RESERVATIONS: {
                    LABEL: "Importazione flusso riserve di magazzino",
                    DESCRIPTION: "Importazione massiva di riserve di magazzino"
                },
                OTHER_INBOUND_WHS_MOVEMENTS: {
                    LABEL: "Importazione movimenti di magazzino",
                    DESCRIPTION: "Importazione di movimenti di magazzino"
                },
                RESERVATIONS: {
                    LABEL: "Importazione riserve di magazzino",
                    DESCRIPTION: "Importazione delle riserve di magazzino"
                }
            },
            NETSUITE: {
                CONSULT_SEND_ORDER: "Consulta l'invio a NetSuite",
                SEND_ORDER: "Invia ordine a NetSuite",
                SEND_ORDER_NOT_AVAILABLE: "L'ordine è già in coda per essere inviato a NetSuite",
                SEND_ORDER_TITLE: "Invio ordine",
                SEND_ORDER_CONTENT_OK: "L'ordine è stato messo in coda per essere inviato a <strong>NetSuite</strong>.",
                SEND_ORDER_CONTENT_KO: "Non è stato possibile preparare l'ordine da inviare a <strong>NetSuite</strong>, oppure è già in attesa di essere inviato."
            },
            OTHER: {
                REPORT: {
                    LABEL: "Report",
                    DESCRIPTION: "Elaborazione dei report configurati dall'utente"
                },
                LISTING: {
                    LABEL: "Listing",
                    DESCRIPTION: "Creazione dei listing per gli articoli soggetti a pubblicazione automatica"
                },
                LRT: {
                    LABEL: "Attività a lunga esecuzione",
                    DESCRIPTION: "Coda che elabora elementi di lunga esecuzione",
                    TIPO_TASK: "Tipo Task",
                    TASK_TYPES: {
                        BUSINESS_CONDITIONS_APPLY: "Applicazione delle condizioni commerciali",
                        ITEM_QUANTITIES_RECALCULATION: "Ricalcolo delle quantità degli articoli",
                        LISTING_AB: "Listing AB",
                        LISTING_SHOP: "Listing Shop",
                        LISTING_EXCLUSION_RULES_APPLY: "Applicazione delle regole di esclusione dal listing",
                        NS_INVENTORY_AVAILABILITY_SYNC: "Sincronizzazione disponibilità inventario NetSuite",
                        PARENT_ITEM_SYNC: "Sincronizzazione parent item",
                        TEST: "Test",
                        TEST_MODULE: "Test modulo"
                    }
                },
                LISTING_EXCLUSION_RULES: {
                    LABEL: "Regole di esclusione dal listing",
                    DESCRIPTION: "Applicazione delle regole di esclusione dal listing di un sottoinsieme di articoli del catalogo"
                },
                AVAILABILITY_PRICE:{
                    LABEL:"Outbound Availability and Prices",
                    DESCRIPTION:"Invio di quantità e/o prezzi allo Shop.",
                },
                AVAILABILITY_PRICE_RESULT:{
                    LABEL:" Inbound Availability and Prices Result",
                    DESCRIPTION:"Controllo dell’esito dell’invio quantità e/o prezzi allo Shop in caso questo operi in modalità asincrona.",
                }
                
            },
            BC:{
                BUSINESS_CONDITION_1: {
                    LABEL: "Condizioni commerciali shop",
                    DESCRIPTION: "Applicazione delle condizioni commerciali agli shop di un sottoinsieme di articoli del catalogo"
                },
                BUSINESS_CONDITION_2: {
                    LABEL: "Condizioni commerciali item",
                    DESCRIPTION: "Applicazione delle condizioni commerciali agli item di un sottoinsieme di articoli del catalogo"
                }
            },
        },
        OTHER: {
            REPORT: {
                CATALOG_01: "Estrazione Catalogo",
                FARFETCH_03: "Report anomalie cataloghi Farfetch",
                LISTING_01: "Riconciliazione Listing",
                LISTING_02: "Situazione Listing",
                ORDERS_01: "Ordini Scaduti",
                ORDERS_02: "Ordini per Shop",
                SHOP_01: "Catalogo per Shop",
                SHOPIFY_01: "SKU Duplicati Shopify",
                TEST_01: "Test 1",
                TEST_02: "Test 2",
                TEST_03: "Test 3",
                WHS_01: "Giacenze di Magazzino",
            }
        }
    },
    STREAMS: {
        INVENTORY_AND_CATALOG_INBOUND: "Scarico disponibilità / catalogo",
        ORDER_INBOUND: "Scarico ordini",
        ORDER_DOCUMENTS_INBOUND: "Scarico documenti ordine",
        RETURN_INBOUND: "Scarico resi",
        RETURN_REQUEST_INBOUND: "Scarico richieste di reso",
        SHIPMENT_INBOUND: "Scarico spedizioni",
        AVAILABILITY_AND_PRICES_OUTBOUND: "Aggiornamento quantità e prezzi",
        ITEM_OUTBOUND: "Aggiornamento articoli",
        ORDER_CANCELLATION_OUTBOUND: "Aggiornamento cancellazione ordini",
        ORDER_REPLY_OUTBOUND: "Aggiornamento conferma ordini",
        ORDER_PACKAGING_OUTBOUND: "Aggiornamento informazioni di confezionamento",
        RETURN_OUTBOUND: "Aggiornamento resi",
        RETURN_REQUEST_REPLY_OUTBOUND: "Aggiornamento conferma resi",
        SHIPMENT_OUTBOUND: "Aggiornamento spedizioni",
        PAYMENT_OUTBOUND: "Aggiornamento informazioni pagamenti",
        ORDER_INBOUND_PRICE_CHECK_CONFIG: {
            CONTROLLO_ATTIVO: "Controllo attivo",
            TIPO_TOLLERANZA: "Tipo tolleranza",
            ASSOLUTO: "Assoluto",
            PERCENTUALE: "Percentuale",
            VALORE_TOLLERANZA: "Valore tolleranza",
            SCRIVI_NEL_REGISTRO_ATTIVITA: "Scrivi nel Registro Attività",
            BLOCCA_RISPOSTA: "Blocca risposta",
            MAI: "Mai",
            SOLO_SE_MINORE: "Solo se il prezzo è minore del limite minimo",
            SOLO_SE_MAGGIORE: "Solo se il prezzo è maggiore del limite massimo",
            MAGGIORE_MINORE: "Se il prezzo minore del limite minimo o maggiore del limite massimo",
        },
        REPLY_POLICIES: {
            REPLY_ALWAYS: "Automatico senza controllo inventario",
            REPLY_NEVER:"Manuale",
            REPLY_IF_IN_CATALOG:"Automatica solo se in inventario",
            REPLY_IF_IN_CATALOG_AND_AVAILABLE:"Automatica se disponibile"
        },
        ERRORE_POLICY_DIVERSA_NONE_CONTROLLO_PREZZI_NON_ATTIVO: "Se il controllo prezzi non è attivo questo valore dev'essere impostato a 'Mai'.",
        CONTROLLO_PREZZI_DISABILITATO_SE_INBOUND_ORDER_NON_ATTIVO: "Il controllo prezzi non è attivabile se lo scarico ordini è disabilitato.",
        AVAILABILITY_AND_PRICES_OUTBOUND_OPTIONS: {
            AVAILABILITY: "Solo quantità",
            PRICES: "Solo prezzi",
            AVAILABILITY_PRICES: "Quantità e prezzi"
        },
        ITEM_OUTBOUND_ALWAYS_ENABLED: "Per questo shop l'aggiornamento articoli è sempre attivo.",
    },
    OVERRIDE_WAREHOUSE_ALGORITHM: {
        EREDITA_STRATEGIA_DEFAULT: "Eredita la strategia di default",
        NONE: "NONE",
        NO_OP: "Nessuna operazione",
        WHS_PRIORITY: "Priorità magazzini",
        TEMP_COMMIT: "Magazzino di appoggio",
        SHOP_DRIVEN: "SHOP_DRIVEN",
    },
    FORMS: {
        ERRORI_NEL_FORM: "Ci sono errori nei campi del form, si prega di controllare.",
        CAMPO_OBBLIGATORIO: "Campo obbligatorio",
        LUNGHEZZA_COMPRESA: "La lunghezza del campo deve essere compresa tra __MIN__ e __MAX__ caratteri.",
        VALORE_COMPRESO: "Il valore del campo deve essere compreso tra __MIN__ e __MAX__.",
        EMAIL_NON_VALIDA:"mail non valida",
        FORMATO_UUID_NON_VALIDO: "Il valore del campo dev'essere in formato UUID",
        ERRORE_REGEX: "Formato non corretto",
        VALORE_GIA_IN_USO: "Valore già in uso",
    },
    TRACKING: {
        TITLE: "Tracking",
        LINK: "Mostra tracking",
        MODAL_TITLE: (correlationUUID:string)=>`Tracking per Correlation UUID ${correlationUUID}`,
        TABLE: {
            ID: "ID",
            TIPO: "Tipo",
            TEMPO_DI_RISPOSTA: "Tempo di risposta",
            CONTEXT: {
                MOSTRA_DETTAGLIO: "Mostra dettaglio",
                COPIA_ID: "Copia ID"
            }
        },
        DETAILS: {
            DATI_GENERALI: "Dati generali",
            RICHIESTA: "Richiesta",
            RISPOSTA: "Risposta",
            INFORMAZIONI: "Informazioni",
            ATTRIBUTI: "Attributi",
            INFO: {
                DATA: "Data",
                URI: "URI",
                METODO_HTTP: "Metodo HTTP",
                TIPO_PAYLOAD: "Tipo di payload",
                CODICE_HTTP: "Codice HTTP",
                ERRORE: "Errore",
            }
        }
    },
    LANGUAGES:{
        IT: "italiano",
        DE: "tedesco",
        DK: "danese",
        ES: "spagnolo",
        EU: "unione europea",
        FR: "francese",
        EN: "inglese",
        RU: 'russo',
        SE: "svedese",
        CN: "cinese",
        KR: "coreano"
    },
    TREE_SEARCH : {
        OTHER_RESULTS : "Mostra altri risultati ( __REMINIG__ rimanenti )",
    },
    COMPONENT_PRICEBOOKS: {
        CURRENCY: "Valuta",
        STOCK_PRICEBOOK: "Prezzo pieno",
        SALE_PRICEBOOK: "Prezzo scontato",
        AGGIUNGI: "Aggiungi",
        RIMUOVI: "Rimuovi",
        SELECT_PRICEBOOK:"Seleziona listino",
        INCLUDES_VAT:"Tasse Incluse",
    },
    COUNTRIES: {
        SPAGNA: "Spagna",
        REGNO_UNITO: "U.K.",
        FRANCIA: "Francia",
        BELGIO: "Belgio",
        PAESI_BASSI: "Paesi Bassi",
        GERMANIA: "Germania",
        ITALIA: "Italia",
        SVEZIA: "Svezia",
        POLONIA: "Polonia"
    },
    HOME_WIDGETS: {
        ORDINI_DI_OGGI: "Ordini di oggi",
        NESSUN_ORDINE_OGGI: "Nessun nuovo ordine.",
        FATTURATO: {
            TITLE: "Fatturato",
            SUB_TITLE: "Dati degli ordini di oggi",
            TOTALE: "Totale",
            ARTICOLI: "Articoli",
            ORDINI: "Ordini",
            FATTURATO_DI_OGGI: "Fatturato di oggi",
        },
        ESPOSIZIONE_CATALOGO: {
            TITLE: "Esposizione catalogo",
            SUB_TITLE: "Statistiche di esposizione del catalogo nei tuoi shop attivi",
            VALORI_MEDI: "Valori medi",
            CONTROVALORE: "Controvalore",
            QUANTITA: "Quantità",
            TAGLIE: "Numero taglie",
            ARTICOLI: "Numero articoli"
        },
        STAMPA_ETICHETTE: {
            TITLE: "Stampa Etichette",
            SUB_TITLE: "Stampa etichette per i tuoi ordini",
        }
    },
    YOOX_SALE_CHANNEL:{
        BE: 'Benelux',
        CEU: 'Europa Centrale',
        DE: 'Germania, Austria',
        DK: 'Scandinavia-Eire',
        EEU: 'Orientale',
        ES: 'Spagna',
        FR: 'Francia',
        GR: 'Grecia',
        IT: 'Italia',
        NL: 'Olanda',
        SEU: 'Europa Meridionale',
    },
    GLF_SALE_CHANNEL:{
        FR: 'Private Sales Channel (Francia)' 
    },
    DECATHLON_SALE_CHANNEL:{
        BE: 'Belgio',
        DE: 'Germania',
        ES: 'Spagna',
        FR: 'Francia',
        IT: 'Italia',
        NL: 'Olanda',
    },
    ABOUT_YOU_SALE_CHANNEL:{
        DE: "Germania",
        AT: "Austria",
        NL: "Olanda",
        BE: "Belgio",
        FR: "Francia",
        DK: "Danimarca",
        SE: "Svezia",
        FI: "Finlandia",
        ES: "Spagna",
        IT: "Italia",
    },
    MODIVO_SALE_CHANNEL:{
        CS: 'Repubblica Ceca',
        EL: 'Grecia',
        IT: 'Italia',
        PL: "Polonia",
        SK: 'Slovacchia',
    },
    ZALANDO_SALE_CHANNEL:{
        DE: 'Germania',
        NL: 'Paesi Bassi',
        FR: 'Francia',
        IT: 'Italia',
        UK: 'Regno Unito',
        AT: 'Austria',
        CH: 'Svizzera',
        PL: 'Polonia',
        BE: 'Belgio',
        SE: 'Svezia',
        FI: 'Finlandia',
        DK: 'Danimarca',
        ES: 'Spagna',
        NO: 'Norvegia',
        CZ: 'Repubblica Ceca',
        IE: 'Irlanda',
        PT: 'Portogallo',
        SK: 'Slovacchia',
        SI: 'Slovenia',
        LT: 'Lituania',
        LV: 'Lettonia',
        EE: 'Estonia',
        HR: 'Croazia',
        HU: 'Ungheria',
        RO: 'Romania'
    },
    COUNTRIES_CODE: {
        AC: "Isola di Ascensione",
        AD: "Andorra",
        AE: "Emirati Arabi Uniti",
        AF: "Afghanistan",
        AG: "Antigua e Barbuda",
        AI: "Anguilla",
        AL: "Albania",
        AM: "Armenia",
        AO: "Angola",
        AQ: "Antartide",
        AR: "Argentina",
        AS: "Samoa Americane",
        AT: "Austria",
        AU: "Australia",
        AW: "Aruba",
        AX: "Isole Åland",
        AZ: "Azerbaigian",
        BA: "Bosnia ed Erzegovina",
        BB: "Barbados",
        BD: "Bangladesh",
        BE: "Belgio",
        BF: "Burkina Faso",
        BG: "Bulgaria",
        BH: "Bahrein",
        BI: "Burundi",
        BJ: "Benin",
        BL: "Saint-Barthélemy",
        BM: "Bermuda",
        BN: "Brunei",
        BO: "Bolivia",
        BQ: "Caraibi Olandesi",
        BR: "Brasile",
        BS: "Bahamas",
        BT: "Bhutan",
        BV: "Isola di Bouvet",
        BW: "Botswana",
        BY: "Bielorussia",
        BZ: "Belize",
        CA: "Canada",
        CC: "Isole Cocos",
        CD: "Congo (Kinshasa)",
        CF: "Repubblica Centrafricana",
        CG: "Congo (Brazzaville)",
        CH: "Svizzera",
        CI: "Costa d'Avorio",
        CK: "Isole Cook",
        CL: "Cile",
        CM: "Camerun",
        CN: "Cina",
        CO: "Colombia",
        CR: "Costa Rica",
        CU: "Cuba",
        CV: "Capo Verde",
        CW: "Curaçao",
        CX: "Isola di Natale",
        CY: "Cipro",
        CZ: "Repubblica Ceca",
        DE: "Germania",
        DJ: "Gibuti",
        DK: "Danimarca",
        DM: "Dominica",
        DO: "Repubblica Dominicana",
        DZ: "Algeria",
        EC: "Ecuador",
        EE: "Estonia",
        EG: "Egitto",
        EH: "Sahara Occidentale",
        ER: "Eritrea",
        ES: "Spagna",
        ET: "Etiopia",
        FI: "Finlandia",
        FJ: "Figi",
        FK: "Isole Falkland",
        FM: "Micronesia",
        FO: "Isole Faroe",
        FR: "Francia",
        GA: "Gabon",
        GB: "Regno Unito",
        GD: "Grenada",
        GE: "Georgia",
        GF: "Guyana Francese",
        GG: "Guernsey",
        GH: "Ghana",
        GI: "Gibilterra",
        GL: "Groenlandia",
        GM: "Gambia",
        GN: "Guinea",
        GP: "Guadalupa",
        GQ: "Guinea Equatoriale",
        GR: "Grecia",
        GS: "Georgia del Sud e Isole Sandwich Meridionali",
        GT: "Guatemala",
        GU: "Guam",
        GW: "Guinea-Bissau",
        GY: "Guyana",
        HK: "Hong Kong",
        HM: "Isole Heard e McDonald",
        HN: "Honduras",
        HR: "Croazia",
        HT: "Haiti",
        HU: "Ungheria",
        ID: "Indonesia",
        IE: "Irlanda",
        IL: "Israele",
        IM: "Isola di Man",
        IN: "India",
        IO: "Territorio Britannico dell'Oceano Indiano",
        IQ: "Iraq",
        IR: "Iran",
        IS: "Islanda",
        IT: "Italia",
        JE: "Jersey",
        JM: "Giamaica",
        JO: "Giordania",
        JP: "Giappone",
        KE: "Kenya",
        KG: "Kirghizistan",
        KH: "Cambogia",
        KI: "Kiribati",
        KM: "Comore",
        KN: "Saint Kitts e Nevis",
        KP: "Corea del Nord",
        KR: "Corea del Sud",
        KW: "Kuwait",
        KY: "Isole Cayman",
        KZ: "Kazakistan",
        LA: "Laos",
        LB: "Libano",
        LC: "Santa Lucia",
        LI: "Liechtenstein",
        LK: "Sri Lanka",
        LR: "Liberia",
        LS: "Lesotho",
        LT: "Lituania",
        LU: "Lussemburgo",
        LV: "Lettonia",
        LY: "Libia",
        MA: "Marocco",
        MC: "Monaco",
        MD: "Moldavia",
        ME: "Montenegro",
        MF: "Saint Martin",
        MG: "Madagascar",
        MH: "Isole Marshall",
        MK: "Macedonia del Nord",
        ML: "Mali",
        MM: "Myanmar",
        MN: "Mongolia",
        MO: "Macao",
        MP: "Isole Marianne Settentrionali",
        MQ: "Martinica",
        MR: "Mauritania",
        MS: "Montserrat",
        MT: "Malta",
        MU: "Mauritius",
        MV: "Maldive",
        MW: "Malawi",
        MX: "Messico",
        MY: "Malesia",
        MZ: "Mozambico",
        NA: "Namibia",
        NC: "Nuova Caledonia",
        NE: "Niger",
        NF: "Isola Norfolk",
        NG: "Nigeria",
        NI: "Nicaragua",
        NL: "Paesi Bassi",
        NO: "Norvegia",
        NP: "Nepal",
        NR: "Nauru",
        NU: "Niue",
        NZ: "Nuova Zelanda",
        OM: "Oman",
        PA: "Panama",
        PE: "Perù",
        PF: "Polinesia Francese",
        PG: "Papua Nuova Guinea",
        PH: "Filippine",
        PK: "Pakistan",
        PL: "Polonia",
        PM: "Saint Pierre e Miquelon",
        PN: "Pitcairn",
        PR: "Porto Rico",
        PS: "Palestina",
        PT: "Portogallo",
        PW: "Palau",
        PY: "Paraguay",
        QA: "Qatar",
        RE: "Riunione",
        RO: "Romania",
        RS: "Serbia",
        RU: "Russia",
        RW: "Ruanda",
        SA: "Arabia Saudita",
        SB: "Isole Salomone",
        SC: "Seychelles",
        SD: "Sudan",
        SE: "Svezia",
        SG: "Singapore",
        SH: "Sant'Elena",
        SI: "Slovenia",
        SJ: "Svalbard e Jan Mayen",
        SK: "Slovacchia",
        SL: "Sierra Leone",
        SM: "San Marino",
        SN: "Senegal",
        SO: "Somalia",
        SR: "Suriname",
        SS: "Sud Sudan",
        ST: "Sao Tome e Principe",
        SV: "El Salvador",
        SX: "Sint Maarten",
        SY: "Siria",
        SZ: "Swaziland",
        TC: "Isole Turks e Caicos",
        TD: "Ciad",
        TF: "Territori Francesi del Sud",
        TG: "Togo",
        TH: "Thailandia",
        TJ: "Tagikistan",
        TK: "Tokelau",
        TL: "Timor Est",
        TM: "Turkmenistan",
        TN: "Tunisia",
        TO: "Tonga",
        TR: "Turchia",
        TT: "Trinidad e Tobago",
        TV: "Tuvalu",
        TW: "Taiwan",
        TZ: "Tanzania",
        UA: "Ucraina",
        UG: "Uganda",
        UM: "Isole Minori Esterne degli Stati Uniti",
        US: "Stati Uniti d'America",
        UY: "Uruguay",
        UZ: "Uzbekistan",
        VA: "Città del Vaticano",
        VC: "Saint Vincent e Grenadine",
        VE: "Venezuela",
        VG: "Isole Vergini Britanniche",
        VI: "Isole Vergini Americane",
        VN: "Vietnam",
        VU: "Vanuatu",
        WF: "Wallis e Futuna",
        WS: "Samoa",
        XK: "Kosovo",
        YE: "Yemen",
        YT: "Mayotte",
        ZA: "Sudafrica",
        ZM: "Zambia",
        ZW: "Zimbabwe",
        UNDEFINED: "Non definito"
    },
    CURRENCY : {
        AED: "Dirham degli Emirati Arabi Uniti",
        AFN: "Afghani",
        ALL: "Lek albanese",
        AMD: "Dram armeno",
        ANG: "Fiorino delle Antille Olandesi",
        AOA: "Kwanza angolano",
        ARS: "Peso argentino",
        AUD: "Dollaro australiano",
        AWG: "Fiorino di Aruba",
        AZN: "Manat azero",
        BAM: "Marco convertibile della Bosnia-Erzegovina",
        BBD: "Dollaro di Barbados",
        BDT: "Taka del Bangladesh",
        BGN: "Lev bulgaro",
        BHD: "Dinaro del Bahrein",
        BIF: "Franco del Burundi",
        BMD: "Dollaro delle Bermuda",
        BND: "Dollaro del Brunei",
        BOB: "Boliviano",
        BRL: "Real brasiliano",
        BSD: "Dollaro delle Bahamas",
        BTN: "Ngultrum del Bhutan",
        BWP: "Pula del Botswana",
        BYN: "Rublo bielorusso",
        BZD: "Dollaro del Belize",
        CAD: "Dollaro canadese",
        CDF: "Franco congolese",
        CHF: "Franco svizzero",
        CLP: "Peso cileno",
        CNY: "Renminbi cinese",
        COP: "Peso colombiano",
        CRC: "Colón costaricano",
        CUC: "Peso cubano convertibile",
        CUP: "Peso cubano",
        CVE: "Escudo capoverdiano",
        CZK: "Corona ceca",
        DJF: "Franco di Gibuti",
        DKK: "Corona danese",
        DOP: "Peso dominicano",
        DZD: "Dinaro algerino",
        EGP: "Sterlina egiziana",
        ERN: "Nakfa eritreo",
        ETB: "Birr etiope",
        EUR: "Euro",
        FJD: "Dollaro delle Figi",
        FKP: "Sterlina delle Falkland",
        GBP: "Sterlina britannica",
        GEL: "Lari georgiano",
        GHS: "Cedi ghanese",
        GIP: "Sterlina di Gibilterra",
        GMD: "Dalasi del Gambia",
        GNF: "Franco della Guinea",
        GTQ: "Quetzal guatemalteco",
        GYD: "Dollaro della Guyana",
        HKD: "Dollaro di Hong Kong",
        HNL: "Lempira honduregno",
        HRK: "Kuna croata",
        HTG: "Gourde haitiano",
        HUF: "Fiorino ungherese",
        IDR: "Rupia indonesiana",
        ILS: "Nuovo siclo israeliano",
        INR: "Rupia indiana",
        IQD: "Dinaro iracheno",
        IRR: "Rial iraniano",
        ISK: "Corona islandese",
        JMD: "Dollaro giamaicano",
        JOD: "Dinaro giordano",
        JPY: "Yen giapponese",
        KES: "Scellino keniano",
        KGS: "Som kirghiso",
        KHR: "Riel cambogiano",
        KMF: "Franco delle Comore",
        KPW: "Won nordcoreano",
        KRW: "Won sudcoreano",
        KWD: "Dinaro kuwaitiano",
        KYD: "Dollaro delle Isole Cayman",
        KZT: "Tenge kazako",
        LAK: "Kip laotiano",
        LBP: "Sterlina libanese",
        LKR: "Rupia dello Sri Lanka",
        LRD: "Dollaro liberiano",
        LSL: "Loti del Lesotho",
        LYD: "Dinaro libico",
        MAD: "Dirham marocchino",
        MDL: "Leu moldavo",
        MGA: "Ariary malgascio",
        MKD: "Denar macedone",
        MMK: "Kyat birmano",
        MNT: "Tugrik mongolo",
        MOP: "Pataca di Macao",
        MRU: "Ouguiya della Mauritania",
        MUR: "Rupia mauriziana",
        MVR: "Rufiyaa delle Maldive",
        MWK: "Kwacha malawiano",
        MXN: "Peso messicano",
        MYR: "Ringgit malese",
        MZN: "Metical mozambicano",
        NAD: "Dollaro namibiano",
        NGN: "Naira nigeriana",
        NIO: "Córdoba nicaraguense",
        NOK: "Corona norvegese",
        NPR: "Rupia nepalese",
        NZD: "Dollaro neozelandese",
        OMR: "Rial omanita",
        PAB: "Balboa panamense",
        PEN: "Sol peruviano",
        PGK: "Kina papuana",
        PHP: "Peso filippino",
        PKR: "Rupia pakistana",
        PLN: "Zloty polacco",
        PYG: "Guaraní paraguaiano",
        QAR: "Rial qatariota",
        RON: "Leu rumeno",
        RSD: "Dinaro serbo",
        RUB: "Rublo russo",
        RWF: "Franco ruandese",
        SAR: "Riyal saudita",
        SBD: "Dollaro delle Isole Salomone",
        SCR: "Rupia delle Seychelles",
        SDG: "Sterlina sudanese",
        SEK: "Corona svedese",
        SGD: "Dollaro di Singapore",
        SHP: "Sterlina di Sant'Elena",
        SLL: "Leone della Sierra Leone",
        SOS: "Scellino somalo",
        SRD: "Dollaro del Suriname",
        SSP: "Sterlina del Sud Sudan",
        STN: "Dobra di São Tomé e Príncipe",
        SYP: "Sterlina siriana",
        SZL: "Lilangeni dello Swaziland",
        THB: "Baht thailandese",
        TJS: "Somoni tagiko",
        TMT: "Manat turkmeno",
        TND: "Dinaro tunisino",
        TOP: "Paʻanga tongano",
        TRY: "Lira turca",
        TTD: "Dollaro di Trinidad e Tobago",
        TWD: "Nuovo dollaro taiwanese",
        TZS: "Scellino tanzaniano",
        UAH: "Hryvnia ucraina",
        UGX: "Scellino ugandese",
        USD: "Dollaro statunitense",
        UYU: "Peso uruguaiano",
        UZS: "Som uzbeko",
        VES: "Bolívar sovrano",
        VND: "Dong vietnamita",
        VUV: "Vatu di Vanuatu",
        WST: "Tala samoano",
        XAF: "Franco CFA BEAC",
        XCD: "Dollaro caraibico orientale",
        XOF: "Franco CFA BCEAO",
        XPF: "Franco CFP",
        YER: "Rial yemenita",
        ZAR: "Rand sudafricano",
        ZMW: "Kwacha zambiano",
        ZWL: "Dollaro zimbabwese"
    },
    DAYS_OF_WEEK: {
        DOMENICA: "Domenica",
        LUNEDI: "Lunedì",
        MARTEDI: "Martedì",
        MERCOLEDI: "Mercoledì",
        GIOVEDI: "Giovedì",
        VENERDI: "Venerdì",
        SABATO: "Sabato",
    },
    MONTHS: {
        GENNAIO: "Gennaio",
        FEBBRAIO: "Febbraio",
        MARZO: "Marzo",
        APRILE: "Aprile",
        MAGGIO: "Maggio",
        GIUGNO: "Giugno",
        LUGLIO: "Luglio",
        AGOSTO: "Agosto",
        SETTEMBRE: "Settembre",
        OTTOBRE: "Ottobre",
        NOVEMBRE: "Novembre",
        DICEMBRE: "Dicembre"
    }
}

export default it